webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(0);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/YPcVN/%3F1684306201335&title=Blue%20Summer&summary=At%20forty%2C%20Cal%20Shaw%20has%20seen%20better%20days%2C%20that%27s%20for%20sure%2C%20but%20it%20wasn%27t%20always%20like%20this.%20He%20grew%20up%20with%20his%20brother%2C%20Alvin%2C%20and%20his%20sister%20Julia%2C%20in%20the%20small%20Maine%20town%20of%20Baxter%2C%20confident%20in%20his%20own%20capabilities%2C%20especially%20regarding%20music.%20He%20took%20h&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/YPcVN/%3F1684306201335",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=At%20forty%2C%20Cal%20Shaw%20has%20seen%20better%20days%2C%20that%27s%20for%20sure%2C%20but%20it%20wasn%27t%20always%20like%20this.%20He%20grew%20up%20with%20his%20brother%2C%20Alvin%2C%20and%20his%20sister%20Jul%0Dhttps://textcafe.co/books/YPcVN/%3F1684306201335&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/YPcVN/%3F1684306201335&posttype=link&caption=At%20forty%2C%20Cal%20Shaw%20has%20seen%20better%20days%2C%20that%27s%20for%20sure%2C%20but%20it%20wasn%27t%20always%20like%20this.%20He%20grew%20up%20with%20his%20brother%2C%20Alvin%2C%20and%20his%20sister%20Julia%2C%20in%20the%20small%20Maine%20town%20of%20Baxter%2C%20confident%20in%20his%20own%20capabilities%2C%20especially%20regarding%20music.%20He%20took%20h",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/YPcVN/%3F1684306201335&description=At%20forty%2C%20Cal%20Shaw%20has%20seen%20better%20days%2C%20that%27s%20for%20sure%2C%20but%20it%20wasn%27t%20always%20like%20this.%20He%20grew%20up%20with%20his%20brother%2C%20Alvin%2C%20and%20his%20sister%20Julia%2C%20in%20the%20small%20Maine%20town%20of%20Baxter%2C%20confident%20in%20his%20own%20capabilities%2C%20especially%20regarding%20music.%20He%20took%20h&media=https://textcafe.co/books/YPcVN/image/9781952143069.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781952143069').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/YPcVN/image/9781952143069.jpg?1684306201335',
        alt: 'Blue Summer'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "cover", "Blue_Summer_interior_epub_new", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/YPcVN/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Blue_Summer_interior_epub_new__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Blue_Summer_interior_epub_new___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Blue_Summer_interior_epub_new__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_last__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_last__);
/*jshint esversion: 6 */









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/cover",
    "name": "cover",
    "component": __WEBPACK_IMPORTED_MODULE_4__components_cover___default.a
  }, {
    "path": "/Blue_Summer_interior_epub_new",
    "name": "Blue_Summer_interior_epub_new",
    "component": __WEBPACK_IMPORTED_MODULE_5__components_Blue_Summer_interior_epub_new___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_6__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/YPcVN/image/9781952143069.jpg?1684306201335",
      "alt": "This image is the cover for the book Blue Summer"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Blue Summer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("At forty, Cal Shaw has seen better days, that's for sure, but it wasn't always like this. He grew up with his brother, Alvin, and his sister Julia, in the small Maine town of Baxter, confident in his own capabilities, especially regarding music. He took his happy life for granted, as lucky children often do. But everything changed when he was ten and his dad died in a freak accident. Soon, trouble, mostly in the form of a violent stepfather, found a home—his home. As an escape, the Shaw kids turned to music lessons with family friend Uncle Gus, but it turns out no one can escape the violence and grief that rains down on the Shaws. Blue Summer is the story of the Shaw family's undoing, and Cal’s struggle to grow up in a world determined to break him. Even his music threatens to take him down with booze-filled nights and one-night stands. As Cal tries to make sense of his existence, living as far away from his family as he can, a snippet of melody comes to him—timeless and haunting. But before he can finish it, his past asserts itself with a phone call that Uncle Gus is dying and it's time to come home and face an altogether different kind of music. In this story, author Jim Nichols writes a riveting coming-of-age novel that examines the melancholy fate of a boy torn apart by loss and domestic abuse, and the justice he eventually delivers, all the while writing a beautiful melody to counter it all, a song he calls ‘Blue Summer.’")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      jim Nichols\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jim Nichols grew interested in fiction writing while working as a ticket agent for a commuter airline in Rockland. Born in Brunswick and raised in Freeport, Maine, Nichols has worked variously as bartender, pilot, skycap, taxi driver, fence builder, orange picker, travel agent, and dispatcher for an air taxi service. His writing, which draws from his many experiences, has appeared in numerous regional and national magazines including Esquire, Narrative, The Clackamas Review, American Fiction, River City, and Night Train. He has been nominated several times for Pushcart prizes, and his novel Closer All the Time won the Maine Literary Award for Fiction. Nichols now lives in Warren, Maine, with his wife Anne, and their two rescue dogs, Brady and Jessie. They have two grown sons, Aaron and Andrew.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "epub:type": "cover"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781952143069.jpg",
      "src": "image/9781952143069.jpg"
    }
  })])])])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "body-text-new ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Blue Summer")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text-new ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Jim Nichols")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ISLANDPRT_Horiz_BLKlogo.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer002"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "section-font"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Other Outdoor Books by Islandport Press")]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Closer All the Time")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-2"
  }, [_vm._v("by Jim Nichols")]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-2"
  }, [_c('span', {
    staticClass: "italics CharOverride-4"
  }, [_vm._v("Contentment Cove")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("by Miriam Colwell")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-2"
  }, [_c('span', {
    staticClass: "italics CharOverride-4"
  }, [_vm._v("Mercy ")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("by Sarah L. Thomson")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-2"
  }, [_c('span', {
    staticClass: "italics CharOverride-4"
  }, [_vm._v("Pink Chimneys, Abbott’s Reach, ")]), _c('span', {
    staticClass: "italics CharOverride-6"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "italics CharOverride-7"
  }, [_vm._v("The Havener Sisters")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("by Ardeana Hamlin")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Random Act")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-2"
  }, [_vm._v("by Gerry Boyle")]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-2"
  }, [_c('span', {
    staticClass: "italics CharOverride-4"
  }, [_vm._v("Stealing History")]), _c('span', {
    staticClass: "italics CharOverride-7"
  }, [_vm._v(", ")]), _c('span', {
    staticClass: "italics CharOverride-4"
  }, [_vm._v("Breaking Ground, ")]), _c('span', {
    staticClass: "italics CharOverride-6"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "italics CharOverride-4"
  }, [_vm._v("Mapping Murder")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("by William D. Andrews")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Strangers on the Beach")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-2"
  }, [_vm._v("by Josh Pahigian")]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("This Time Might Be Different")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-2"
  }, [_vm._v("by Elaine Ford")]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-2"
  }, [_c('span', {
    staticClass: "italics CharOverride-4"
  }, [_vm._v("The Contest")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("by James Hurley")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("These and other books are available at: www.islandportpress.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("Jim Nichols")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "section-font ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Islandport Press")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("P.O. Box 10")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Yarmouth, Maine 04096")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("www.islandportpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("books@islandportpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("First Islandport Edition / August 2020")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("All Rights Reserved.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Copyright © 2020 Jim Nichols")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("ISBN: 978-1-952143-03-8")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("ISBN: 978-1-952143-06-9 (ebook)")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("LCCN: 2020932368")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("This is a work of fiction. Names, characters, places, and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual events or persons, living or dead, is entirely coincidental.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Publisher: Dean Lunt")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Book Design: Teresa Lagrange, Islandport Press")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Cover image courtesy of ")]), _c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("iStock.com/chainatp ")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Printed in the USA")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "section-font"
  }, [_c('br'), _c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("For Anne")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "epub:type": "toc",
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "section-font"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Bolduc Correctional Facility, 1997\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Tampa, 1995\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Tampa, 1995\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, Summer, 1964\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, Summer, 1964 \t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, Summer, 1964 \t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Tampa, 1995\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Tampa, 1995\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Tampa, 1995\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, Fall, 1964\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, Late Winter, 1965\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, Late Winter, 1965\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, Spring, 1965\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Tampa, 1995\t99")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Tampa, 1995\t103")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, Spring, 1966\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, Spring, 1966\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, Summer, 1966\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, Fall, 1966\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, Fall, 1966\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, Fall, 1966\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("En Route, 1995\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("En Route, 1995\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, Fall, 1966\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, Fall, 1966\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, 1970\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, 1970\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, 1970\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, 1970\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, 1971–1972\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_c('span', {
    attrs: {
      "lang": "fr-FR",
      "xml:lang": "fr-FR"
    }
  }, [_vm._v("Bolduc Correctional Facility")]), _vm._v(", 1997\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("En Route, 1995\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Portland, 1995\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Portland, 1995\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, 1995\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, 1995\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, 1995\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("Baxter, 1995\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_c('span', {
    attrs: {
      "lang": "fr-FR",
      "xml:lang": "fr-FR"
    }
  }, [_vm._v("Bolduc Correctional Facility")]), _vm._v(", 1997\t")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Blue_Summer_interior_epub_new#_idTextAnchor001"
    }
  }, [_vm._v("Acknowledgments\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer008"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer009"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('p', {
    staticClass: "section-font"
  }, [_c('br'), _c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("“In the blue summer evenings, I will go along the paths . . . “"), _c('br')]), _c('span', {
    staticClass: "CharOverride-13"
  }, [_vm._v("—Arthur Rimbaud")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer011"
    }
  }, [_c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_vm._v("Bolduc Correctional Facility, 1997")]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-4"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-4"
  }, [_c('br'), _c('br'), _vm._v("So I thought I’d try to write this down. Chances are I’m no literary savant, but I promise my heart’s in the right place, and I "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("have")]), _vm._v(" been a world-class bookworm for my whole pathetic life, so maybe that’ll help. Who knows? I guess we’ll see. I think it’s worth telling, at any rate, and I don’t see anyone else volunteering to do it. And Lord knows I’ve got plenty of time now to try and figure it out, thanks to the Great State of Maine.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My name is Calvin Shaw. No household name, to be sure, but I wouldn’t be surprised if it still rang a bell with some of you out there. There were some pretty lurid headlines at the time, after all: "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Musician Kills Stepfather with Trumpet")]), _vm._v(", that sort of thing.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I can hear you now: You’re "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("that")]), _vm._v(" guy!")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Yep, I’m that guy. But you might also have heard of me if you’re into cool jazz. I’ll bet you’re at least familiar with some of my music. “Blue Summer,” for instance. Everybody knows “Blue Summer”"), _c('span', {
    staticClass: "CharOverride-3"
  }), _vm._v("because Tony Bennett had a hit with it (after a lyricist named Billy Weber added words to my music), and any number of artists have covered it since.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("It was a long, blue summer, the wrong blue summer . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And so on. You remember. And maybe Weber’s words weren’t exactly what I had in mind, but I’m not complaining. I’m lucky the thing exists at all—never mind becoming a near-standard, if I do say so myself—because there were some pretty long odds against that happening, reason being that it chose such a dismal time in my life to come dancing along. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("See, I’d about decided to bring the old curtain down.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I’m not exactly sure why it had come to that. I mean, I’d been a recent guest of the Pinellas County Jail, which wasn’t what you’d call a real morale booster, and I was also drying out, which can do funny things to your head. But I’d been way low-down before without thinking it might be time to jump off a bridge. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It doesn’t matter anyway. It’s just that that’s where things stood when this stubborn little melody showed up, and that’s a big part of my story: that I was at a low point, maybe a bottom, and then “Blue Summer” came along and started to turn things around.  ")]), _vm._v(" "), _c('p', {
    staticClass: "parts-head"
  }, [_c('br'), _vm._v("TIN PARADISE")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("One")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_vm._v("Tampa, 1995")]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-4"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("We’ll start at that low point: a trailer park in Tampa, Florida. It’s early in the morning, still dark outside, and the phone has startled me awake. I’m lying on my little fold-out bed waiting for it to stop. I’m not in the greatest of moods, because good sleep has been hard to come by. For once I was there, and now someone’s trying to ruin it. The longer the phone rings, the more pissed off I get, and in no time I want to rip it out of the wall and smash it on the floor. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But then I remember what I’ve pretty much decided. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I remember that it likely makes no real difference anymore how much sleep I get, or whether I drag my sorry ass out of bed and answer the phone. None of it matters, because it’s become only a matter of time. (Which isn’t to say that I have to be in any big hurry, either. It’s like deciding to rob a bank: just because you’ve made up your mind doesn’t mean you have to run right out and buy a ski mask, right?)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So I take a deep breath and let the irritation bleed off. And when the ringing finally stops I stretch out and let my arms fall back. I feel the indifferent old world reconstruct itself around me. It’s the same world as yesterday: I’m alone in a trailer park, and pretty soon I’ll smell empanadas and coffee, and I’ll hear radios playing, and maybe a rough-running car or two warming up. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I can already hear traffic on Dearborne Street. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There’s always traffic on Dearborne, and there’s always somebody blowing his horn. Like the guy I hear now, really leaning on it, running on down the road. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When he’s gone I wonder if that blast was meant for anyone in particular. It’s easy to imagine some other poor soul lying awake, listening. Maybe like me: pushing middle age, stretched out in their skivvies under a dingy old army surplus blanket in a beat-up old trailer. But not "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("exactly")]), _vm._v(" like me, unless there’s a brand-new melody playing "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("sotto voce ")]), _vm._v("in his head. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("You remember about the melody, right? Well, this is exactly when it arrives, slipping in as if to fill the vacuum left by my unconsummated little fit of anger about the phone. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At first it’s barely present, like a leftover piece of dream. It doesn’t flicker and fade, though, and then it takes on enough shape that I can hear it clearly. There’s an intricate run of pure-sounding notes. It’s different and interesting, a bit gloomy, and my right foot starts to slowly tap, and the next thing I know, a piece of lyric joins the party, which for me always means things are moving along. (The words themselves aren’t important. Most of them won’t even survive. They’re just place-holders, rhythm-makers.) ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("They drive fast and blow their horns a lot on Dearborne.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("That’s what plays in my head, but it changes almost immediately into something better: "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("They speed and honk their horns a lot in Tampa.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I ponder that melody and rhythm for a few minutes. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But thinking about traffic reminds me suddenly of counting cars on the River Road with my sister Julie and her best friend Becky O’Dell (who was red-haired and nice, but who lurched when she walked for no good reason; more on that later), and all at once it’s not about Dearborne or Tampa at all anymore. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Now it’s about Julie and me, about our brother Alvin (yeah, Calvin and Alvin—it wasn’t my idea) and my parents and Becky and that POS Randy Pike and everybody else connected to where I grew up in Baxter, Maine; which means it’s also about all the tragedy that started during that bluest of summers. (Which I’ll get to, but for now, back to the trailer.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I tap out the rhythm against my chest, and then whistle it softly, on the intake (to be quiet), and to fix it in my mind I snap open the beat-up cornet case that’s always on the floor nearby. I want to feel what it’s like to play it. I take out this sweet little Olds that I picked up in a pawnshop in NYC, touch the smooth mother-of-pearl caps and flutter the valves, liking the silky action and the "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("plupetty-plup ")]), _vm._v("sound that I always imagine is a soft little musical engine trying to start.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I mute the horn with my hand and tease my new tune out, and I mark that it’s coming out in D minor, which suits its rather serious and melancholy feeling. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("After a bit I walk down to my little tin box of a bathroom, still playing, and I stop long enough to do my business and then, coming back, I try and draw the melody out a little more, hoping to coax it into something that might resolve. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It’s still not a huge deal, but it’s gaining weight. I’m playing around, almost out of habit, but at the same time getting more involved, even becoming a little wary about where it might be going, what it might have to say about my family, and especially, my father and Julie. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("See, it’s taking me somewhere I wasn’t expecting. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Which happens sometimes: You have a direction in mind and you’re trying to fulfill it, and you’re rolling along fine, and then there’s an association of some kind and a change of direction, maybe darker, and you’re pulled down another path. (Which isn’t different from life itself, now that I think about it—at least, my messed-up life.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Anyway, I sit back down on the bed and fiddle until I’m pretty sure it’s not going to show itself entirely at this moment—it’s holding back, as if the time isn’t right—and then I’m all the way awake, so I put the cornet away and go into my little tin box of a kitchen and pour myself a heaping bowl of Cheerios. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I turn on the box radio for the traffic report. This is routine, because I’ve been driving taxi, which is what I do when music gigs are hard to come by, which they have been lately. People get out of the habit of thinking of you when you go to jail, even if it’s only for a couple of months. I haven’t exactly been out there knocking on doors since I was released, either. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The traffic reporter is talking about a slowdown caused by an overturned potato truck. I chew the cereal and wonder what a potato truck was doing in Tampa, Florida. For all I know they drive potatoes down here all the time, but it’s odd, because I’ve just been thinking about Maine. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then I think, For all I know, they’re Idaho spuds. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Anyway, the reporter goes on about cars skidding on the squashed potatoes. His voice is shaky. He guesses it’ll be mid-morning before traffic is back to normal, which means all the usual routes into town will be clogged. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I say, “Well, fuck the mother-fucking duck,” as if that traffic report actually matters, and snap the radio off. (I got that catchy little phrase from my Pinellas cellmate, Rocky Kincaid, who was a decent sax man, known as Skinny-Ass One around the yard. I was Skinny-Ass Two, but I’ve put on a few pounds since I got out. Our stays had overlapped for close to thirty days—me, for what they called "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Disorderly Intoxication ")]), _vm._v("plus "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Assault on a Police Officer")]), _vm._v(", Rocky, for "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Attempting to Purchase a Controlled Substance")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I put my bowl in the sink, yank open the sticky door, and go outside for a Lucky Strike. It’s my first of the day, which always makes me feel guilty, but you can’t give up everything. (I quit drinking when I went to jail, and that’s an accomplishment I don’t want to ruin, even if it wasn’t of my own volition, but I don’t feel that way about smoking.) ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Not that any of it matters, I remind myself.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I sit on the stoop, looking around the trailer park. It’s not quite dawn, warm and humid already. Cars and trucks are running by on Dearborne and nighthawks are blowing their horns. I can see the traffic light flashing red (the only light around, because all the streetlights have been busted out).")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There are little birds chirping from the bushes behind me. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The phone rings again, and I don’t move. I cross my ankles and smoke with no hands. The ash falls on my shirt and I brush it off. Maybe it’s somebody with a gig, but I don’t really care. I can take it or leave it, now. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("After a while the ringing stops. I scratch my stubble and wait for my ride to show. Yeah, I’m still going to work. I thought about quitting, but it makes more sense to have a few bucks coming in while I’m playing out the string. Giving up seems to have lifted my spirits in some contrary way, and I figure I might as well enjoy it while I can. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Which is a perfect mood for what happens next.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I’ve just lit a second cigarette off the stub of the first and I’m watching the red sun edge up over the horizon when the door of this rattletrap trailer across the lane pops open and these three little urchins come out and stand on the step. ")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("two")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Tampa, 1995")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-4"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("I’ve gotten to know two of these kids. They’re brother and sister, and always a little shy at first. Their heads are down and they’re looking sideways at each other. The third kid—a boy—is looking doubtfully at me, waiting to see about the beat-up white dude across the way. They’re all still in their PJs. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("After I say “You all can come on over if you want,” it still takes a few seconds, but then they’re standing in front of me, looking down at the dirt.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Bet I can guess what you want,” I say. “Huh, Carlo?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Uh-huh,” says one of the boys.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Can’t you look at me?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Carlo’s bright eyes flicker up. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You too, Ava,” I say. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ava looks up for a millisecond, then ducks her head again. She’s as pretty as Carlo is handsome, and being a little girl, she’s extra special to me. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“And what’s your friend’s name?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Joaquin.” Carlo makes a face. “You like that name?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sure, that’s a fine name.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He live over there.” Carlo flings an arm out toward the far end of the trailer park, where the orange pickers live, facing a row of slatted privies across a muddy ditch. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well,” I say, “we all gotta live somewhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Joaquin frowns.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So,” I say. “Magic trick?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Invisible ball!” Carlo says.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ava moves a little closer. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t have a paper bag,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Carlo brings one out from behind his back. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t know, man. I don’t know if my magic works on old wrinkled-up lunch bags.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Aw, man . . .” Carlo says.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We can give it a try, though.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I stick a hand in the bag.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Carlo nudges Joaquin, who slaps at his arm.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I pluck something out of thin air, pretend to pop it into my mouth. Then I move my tongue around from cheek to cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That just his tongue!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You wait!” Carlo says. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I take the invisible ball out of my mouth, walk away from the stoop and toss it underhanded into the air. I hold the paper bag out and snap my thumb against the bottom of the bag. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“See!” Carlo says.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Do it again!” Joaquin says.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I let the ball spill out into my palm, toss it up again, and step to the side. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Snap!")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Carlo does a little scuff step, claps his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ava holds her breath.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I throw the ball higher, circling under it like a catcher after a pop-up, and catch it again in the wrinkly old lunch bag. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The kids clap their hands and it makes me laugh. I could do this all day. But then a horn blasts out on Dearborne, and a taxi comes whistling around the corner. There’s a trail of dust behind it and a man with a bushy, gray beard at its wheel. The kids shriek in mock terror—they’ve seen this guy before—and fly back across the lane. The door of their trailer clatters shut as the taxi pulls up. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I crumple the paper bag and toss it into my trailer. Then I lock the door and walk through the dust to the car. The driver grins at me as I slide into the front seat. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Playing with the porch monkeys again?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t be an asshole, Neal.” I know he’s a dumbass who doesn’t know any better, but it always riles me when someone’s not cool with kids.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He laughs, spins the steering wheel, looks backwards, his beard pooling up on the shoulder of his ratty green field jacket. Then he pulls a U-turn in front of the kids’ trailer. He has his ignition key on a big ring with other keys and a metal swastika-shaped bottle opener. He’s a burly guy who always steers his cab with both hands.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“They shit on us too.” As if that makes it right. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not those little kids.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Wait until they grow up.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“If they do, brother, you asked for it.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Neal wrangles us through the intersection and onto Dearborne, cutting off a pickup truck. The pickup’s horn blares as it rushes by, and we both—cabbies, right?—casually flip him off.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He steps on the gas toward the airport. There’s a railroad berm on our left with some kind of sunburnt hedge in front of the rails, and scruffy countryside on our right, sloping down a long way to the orange groves. The sky is getting lighter. Far ahead I can see the Tampa skyline. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Neal pulls into the left lane, blows past someone on a straightaway and cuts back in quick. They honk at us, too, a double honk, and my mind takes a quick leap from that onto my new melody. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It’s been with me the whole morning, very persistent but still not complete, and I’m starting to have this feeling that it wants me to stick around for its own sake, and that’s why it’s holding back, trying to make itself irresistible. I snicker under my breath at the idea: a piece of music choosing me at this stage of my life. That would take a stronger belief in the whole idea of fate, or destiny, than I possess (and would also negate the random aspect of direction and change that I was thinking about earlier, wouldn’t it?). ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But as we ride along toward Tampa, the melody teasing me, I let myself go there. What have I got to lose, right? And I wonder: What if it’s important? What if I happen to be the rickety gateway it needs, for whatever reason? What if it needs me like "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Starry Night")]), _vm._v(" needed van Gogh and “Julia” needed John Lennon? I’m not equating myself, but I don’t have to: some amazing work has come from lesser mortals. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Think one-hit wonders like “Sweet Lorraine” and “Undecided.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Neal shifts in his seat and I look at him steering with his knees while he sticks a pinch of snuff up under his lip. We’re still going eighty-five. He looks back and offers the tin, but I shake my head because I’d rather get his hands back on the wheel. He shrugs and stuffs the tin back into one of his many pockets.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Finally his hands go back where they belong.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I look out the window at the low countryside and ponder my fantasized role in bringing this new melody into the world, and I think, what the hell, go ahead and snicker. Maybe it’s a flight of fancy, but if the tune keeps after me, and convinces me I need to stick around, and I decide I have to postpone the other thing, then what the hell? I can try my best and see what happens, and when the time comes, still do what I have to do. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Win-win, right? ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So I watch the city ahead of us glow with the sunrise, and I tell myself it’s not that bad to be going to work and thinking about new music and feeling halfway decent. Maybe I should just enjoy it while it lasts. Because if there’s anything I’ve learned during my thirty-odd years of the blues, it’s just how evanescent these decent moments can be. ")]), _vm._v(" "), _c('p', {
    staticClass: "parts-head"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v("PREHISTORIC")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Three")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_vm._v("Baxter, Summer, 1964")]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-4"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("So, we’re talking thirty years. That takes me back to age ten, which is when everything started to go sideways. The Fourth of July that year, to be precise, although the day itself started out all right. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When I rolled out of my bunk and headed downstairs for breakfast we were a normal, small-town family—mom, dad, three kids—with no real worries about anything. We lived where Shaws had always lived, except for a few years after my grandparents moved to Bath during the war, so my grandfather could work in the shipyard. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We went to church like everybody else. We sat down to supper together and my father asked us questions about our day. We were expected to answer thoughtfully; he was the boss. We had chores to do and music lessons to practice—my father believed firmly that music lessons were a necessity—and we were supposed to mind what he and my mother said. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My father, John Shaw—known as Jack—was a former high school sports hero and current town selectman, a man who’d survived several battles in the Pacific Theater during World War II, who still wore the St. Christopher medal my grandmother gave him when he left for boot camp. After coming home he’d parlayed his veteran status and all-around good name into a decent living selling cars at the local GM dealership, and as a result, we were fairly comfortably middle-class.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My mom, Betty Flint Shaw, grew up in Palo Alto, but was pretty and smart enough to mostly overcome that handicap with her Maine neighbors, although there were some reservations because she wasn’t all that friendly, and had never learned how to small-talk. In fact, she was something of a cold fish even with us. But that wasn’t her fault, according to my father. When I wondered one day why she wasn’t as friendly as my friend’s mother, he said, “Well, your mother has never quite figured that kind of thing out.” And when I said “Why not?” he said, “You’d have to ask her parents.” I must have looked unsatisfied, because he grinned and tousled my hair. “None of us is perfect, right, Old Cal? Besides, you can’t say she doesn’t try.” And it was true; on rare and unexpected occasions she would plant a kiss on your cheek or reach an arm around you and attempt a tender squeeze. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Anyway, it was the Fourth, and after breakfast we piled into the station wagon and went to the parade. There were fire engines and floats, Boy Scouts and Little Leaguers, veterans and politicians. The downtown was hung with red, white and blue bunting, and there was a balloon vendor with a helium tank. People had their dogs on leashes, and kids were jumping out from behind telephone poles with squirt guns. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The parade took an hour. The last float—Betsy Ross with an American flag on her lap—went by, followed by a dozen vets, including my father and Uncle Gus (who wasn’t really an uncle), marching with their arms swinging, and a half-dozen Red Cross nurses, including my mother (who’d trained as a nurse’s assistant but had never deployed, because the war had ended). ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We kids trailed them to the town hall, where everyone broke ranks and made for the park behind the Main Street block, which had been set up for a chicken barbecue, with a giant grill and a dozen long tables under an awning. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I ate the chicken, the coleslaw, the potato chips, and the brownie, everything except the pickle, which my faux uncle Gus Shaw “liberated” from my plate with a fat-fingered flourish (think Chris Farley putting on airs). ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was hot, but nobody bothered with sunblock. Red cheeks and arms were part of the deal. Out past the tables there were horseshoe and wood-splitting contests, pony rides and face-painting, and more balloons. Over near Baxter Elementary School some girls had set up a card table with a record player and were playing Beatles records and doing the twist. (The Beatles were a new thing in Maine that year. So was the twist, for that matter.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("After we ate my father lit his pipe, joined the line for horseshoes, put his hands on his hips, and said, “Well, I don’t see any competition to worry about here.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The other men laughed and insulted him back. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My mother and Uncle Gus stayed to watch, and we kids were turned loose for an hour, after which we were instructed to meet at the fire station. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My father told us to try and pretend we were civilized. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin and I galloped off, while Julie—a newly fledged teenager—walked with dignity toward the music. Her friend Becky O’Dell broke out of a crowd of kids to join her, and they went the rest of the way together, Julie in her new summer dress, Becky in her usual overalls, hobbling efficiently to keep up. (She was an odd case in that—as I mentioned before—there was nothing congenitally wrong with her legs. It was just that when she was a toddler she’d learned to walk by imitating her older brother, who had cerebral palsy, and her parents, who thought it was cute, had let it go on until she was stuck that way.) ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("If I remember right, Julie was a Paul girl; Becky loved Ringo. I didn’t like any of them at first—out of jealousy, I guess. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Anyway, Alvin and I took off the other way and joined a couple of schoolmates, the four of us pretending to be tough guys, pushing and shoving one another, sassing grown-ups and trading insults with a cluster of teenage hoods until they ran us off by snapping their cigarettes away and feinting toward us. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was, of course, over too quickly. I knew the hour was up when Alvin raised the new Timex on his wrist, took a couple of steps backward with his eyes on me and then spun and ran off for the fire station. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hey!” I ditched our friends and sprinted after him. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin ran like some kind of bird, jabbing his feet and jutting his chin, but he had long legs and was pretty fast. I’d still have caught him, though, if there hadn’t been so many people in the way, or if it had been a little farther. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Beat you!” he gasped, when we’d windmilled to a stop. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You jumped the gun.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No sir,” Alvin said, still panting. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Here’s Julie,” our mother said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She came strolling up and Uncle Gus clicked his heels and saluted our father. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All stragglers present and accounted for, sir. What should we do with them, sir?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He liked to play up that Dad had outranked him in the service, but it was also funny because of his pudginess and the slightly wet way that he talked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Throw ’em in the brig!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Aye aye, sir!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We walked back through town—slowly, because it seemed like everyone we met wanted to shake Dad’s hand and chat. We turned down School Street to where we’d left the station wagon parked next to a row of school buses. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Driving home it was steaming in the car, and we rolled down the windows and let the warm air blow in. Above us the sky was deep blue with big, billowy clouds, and a breeze off the river made the tops of the pines sway. Once that Dodge got up to speed it could really go, and we rumbled past woods and open fields and fenced-in old farmhouses with teetering barns and fat silos. I caught glimpses of the water, which looked sluggish because the tide was just changing. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin and I sprawled in the way-back, where we could feel every bump. A big one would sometimes lift us right off the deck, and make us laugh and groan after we landed. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie sat beside Uncle Gus, reading an Andre Norton paperback she’d found on the floor. (Our father planted books—and a pipe—anywhere that he might find himself with time on his hands: the bathroom, the car, his boat.) ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Our mother was in the front seat, watching the scenery. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("After a while Alvin and I started bickering about dinosaurs. We’d been fighting over them for a month, since my father had asked me a crossword question about the Mesozoic without giving my older brother first crack at it. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It made sense to ask me, because I was the one with dinosaur books all over the house, but to my older brother it was a serious breach of family protocol. And it didn’t help when I came up with the answer and my father said, “Good man!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Afterward Alvin dived right into one of those books, a big hardcover called "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Prehistoric Animals")]), _vm._v(" that I’d gotten for Christmas. I caught him curled up with it on the porch swing and knew immediately what he was up to. He was a quick study, so it was only a day or two until he was ready to chime in on the subject, and he’d been looking for openings ever since. Today he’d started in while we were crossing the bridge over the Baxter River. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“This area would have been crawling with Diplodocuses in prehistoric times,” he’d announced, which had compelled me to say something equally loud about how they actually preferred marshes and swamps. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Which was all it took. We went back and forth about the Diplodocus, and before long were arguing over whether my favorite—"), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Tyrannosaurus rex")]), _vm._v("—would have been annihilated in a fight with Allosaurus. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Ridiculous! Tyrannosaurus was way bigger.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“But Allosaurus was a much better fighter.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re full of it!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t be childish,” he said, which was one of his favorite gambits: pretending to be the grown-up after he’d started the whole thing. (He desperately "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("wanted")]), _vm._v(" to be a grown-up, and wore chinos and collared jerseys that he buttoned up to his neck, while I was dungarees and T-shirts.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I kissed the tip of my middle finger. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Cal just gave me the finger!” he yelled.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Our mother turned in her seat and shot us a look. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I was just biting my fingernail.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re a liar!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s enough.” She stared until we looked away, then faced front again. Our mother had little tolerance for tomfoolery (which was another thing that could make her unlikable.) ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin sneered at me. I shifted sideways, managing to kick his leg in the process. It wasn’t much more than a nudge, but he squealed anyway, and our mother yanked herself back around. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m warning you two.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Uncle Gus, sitting in the line of fire, cleared his throat. He hated discord. Julie just kept reading. Our father wasn’t paying any attention; he was whistling under his breath, his elbow out the window, other hand on the wheel, mind somewhere else. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“But he kicked me!” Alvin whined. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I barely touched the little baby.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He jabbed a foot out. “How do you like it?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I took a swipe back at him and then we were grunting and wrestling in the small space. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“John!” our mother demanded. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Our father started, looked wide-eyed at her, and pulled the car over to the shoulder. We felt it as we slowed down and separated before he threw the gearshift into park. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He turned in the seat and looked at us. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Do I have to come back there?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, sir,” we said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Then knock it off.” He held his gaze until I muttered, “Sorry.” Then he raised an eyebrow at our mother, checked for traffic, and drove us back into the southbound lane. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin and I glowered, but kept our hands to ourselves.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Our father went back to daydreaming about his aircraft carrier during the war, maybe, or some even-par stretch at the Baxter Golf Club, or fly-fishing at Whetstone Falls on the East Branch of the Penobscot River, which he claimed as his favorite place on Earth. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Our mother kept turning abruptly to look preemptively at us, which made it hard for our father to keep daydreaming, and after a while I could see he was looking at us too in the rearview mirror. And since he could never be aware of us without his boyish side coming out, it wasn’t long until he said, “You know, this wouldn’t be a bad day for a game of croquet.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin and I cheered from the way-back. Julie lowered her book. Uncle Gus grinned, and even our mother managed a smile. We’d only learned about croquet that summer. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I only wish I could find some decent competition.” Our father cocked his head mock-sadly toward our mother, who rolled her eyes. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You can!” Alvin shouted. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah,” I said, “me!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ve heard that sad song before.” He winked at the mirror. “Now Julie might give me a run for my money, if we could only keep her away from the booze.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie looked up at the mirror and they smiled at each other.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Look out!” our mother cried then.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A tractor pulling a hay wagon had just come rocking around a curve, hogging the middle of the road. Our father had to yank the Dodge close to the shoulder to avoid being sideswiped. Then the hay wagon was behind us, swaying along toward town, and we were all able to breathe again.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Will you please pay attention, John!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Saw him the whole time,” our father said with a grin. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Our mother shook her head.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We crested a hill and started down the long slope that led to our house. At the bottom of the hill we passed our hayfield and then the old vegetable stand with its "), _c('span', {
    staticClass: "small-caps _idGenCharOverride-1"
  }, [_vm._v("closed")]), _vm._v(" sign hanging from a nail on one of the shutters. (The vegetable stand had come with the property. Sometimes Alvin and I used it for a clubhouse.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We turned into the dirt driveway and rode past the barn—which was still partly red, but mostly weathered board—to our double-dormered farmhouse. Dad threw the gearshift and shut off the engine. All the side doors opened at once. I pulled the tailgate latch ahead of Alvin and scrambled out first. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin slid out and gave me a shove, but I just laughed. I’d sprouted that spring and was almost as tall now, and I’d also gotten into some scraps at school—my growth had given me a sort of martial confidence on the playground—and acquitted myself quite well. So maybe he was still a year older but he didn’t rule the roost the way he used to. (Which was probably another reason he’d been so touchy about the crossword question.) ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Save some of that energy,” our father said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We ran inside, and our parents changed out of their uniforms into shorts and jerseys. Uncle Gus didn’t have a change of clothes, but took his jacket off and rolled up his sleeves. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There was a flat piece of lawn behind the barn, where the wickets and pegs had been set up since May, when the first truly warm weather had come in. Our father went into the barn for the rack that held the mallets and wooden balls. He carried it out with two hands at waist level and set it down near the home peg. We grabbed the mallets and balls: black for him, yellow for our mother, orange for Uncle Gus; blue, green and red for Julie, Alvin and me.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I tossed my red ball up and down in one hand, trying to make it look lighter than it was, while we drew straws to see who would go first. Our father won and took several practice swings, then wriggled like a golfer to set himself and somehow knocked his ball in a bumpy, erratic curve right through the first wicket. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Heck of a shot!” Uncle Gus said, and clapped his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nothing to it,” our father said archly. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He won that first match going away, won another almost as easily, and then started to showboat, taking increasingly crazy shots and, when successful, imitating Cassius Clay, the new Heavyweight Champ, by holding his arms up and saying, “I am the greatest!” (Our father had boxed in the navy, and he’d loved it when Clay had put a beating on Sonny Liston that February.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We all thought this was funny except Alvin, who was a chronic poor sport. He just got angry, and finally, when our father clinched one more victory by knocking Alvin’s green ball clear off the playing field, he threw his mallet down, stomped over to the barn and sat on the old half-log bench by the side door, crossing his arms on his chest, eyes narrow and angry behind his thick-lensed glasses. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Was that really necessary, John?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My father shaded his eyes. “It’s just part of the game.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He’s eleven years old.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dad turned to look at Uncle Gus.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t look at me!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Our father rubbed his chin. “Well, I suppose we could call it a mulligan.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not fair!” I yelled, because I was now in second place. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Shut up, Cal,” Alvin said. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You shut up.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And that was it for our mother, who wasn’t competitive and had probably been looking for an excuse to quit. She said, “That’s quite enough,” picked up her yellow ball, and carried it away in the crook of her arm.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thanks for nothing!” Julie snapped at us. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re welcome.” Alvin made a prissy face.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Shut up!” She grabbed her own ball in two hands and set off after our mother, too angry to remember her new, stately walk. She could be feisty sometimes. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Our father looked at Uncle Gus, who held up his palms, and they started off, too—my father tall and broad-shouldered, Uncle Gus shorter and stout—with Alvin close behind, smirking over his shoulder. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I watched them go, and when they’d put their balls and mallets down and were on their way back to the house, I made a face at them and drove my red ball viciously toward the rack. There was a loud crack when it hit, but only Alvin looked back (with a sneer). Everybody else just kept moving. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I stomped over and kicked my ball the last few feet. Then I slammed it and the mallet into the rack. I didn’t care anymore that nobody was paying attention. I was good and angry, and enjoying it enough that I let myself stay that way, right up until my father left after supper to play poker. Which is something I still feel guilty about, because it was the last chance I would ever have to be nice to him, and it would have been so easy, too.")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Four")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_vm._v("Baxter, Summer, 1964 ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _vm._v("After supper we watched "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Wagon Train")]), _vm._v(", and when it was over our father said, “Well, I suppose,” and got up from his recliner. He went around to where we kids sat on the green couch. “Don’t let your mother rob any banks while I’m gone,” he said, “or shoot any of the neighbors or anything. Okay? I’m counting on you, now.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie said “We won’t!”, but Alvin and I—still nursing our separate grievances—kept our mouths shut. We also ducked away when our father reached out to ruffle our hair. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Tough guys, huh?” he said, and then he smiled and turned to kiss the top of my sister’s head.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t stay out all night,” our mother said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It won’t take me all night to clean out that crew.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s what you said last year.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He walked back to her, bent down and took her hand. He raised it and kissed her knuckles. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“And please don’t drink too much.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Wouldn’t dream of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You said that last year, too.” She squinted up at him. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He grinned and waved to us on his way out of the living room. Only Julie waved back. When our mother heard the screen door shut, she rose from her chair and went into the kitchen. She’d changed out of her shorts and jersey into a pair of gray slacks and a green blouse.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I stretched myself over the arm of the couch to look down the hallway and saw her standing by the window. The window lit up when Dad’s headlights hit it, and she seemed to tense. The light slid away and my mother cocked her head to keep it in sight. He was heading into town, going to the Amvets hall, which I knew sat on a low hill down a side street past the water tower. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then he was gone and our mother stared for a moment longer before turning on the tap water and letting it run into the sink where the supper dishes sat. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I watched her for a few seconds more. But there was another Western coming on—"), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Gunsmoke")]), _vm._v(", maybe—and I hiked myself back into a sitting position. Soon I was lost in the action, and with my father gone, I finally forgot about being angry. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It gets difficult now, because this is where it all started to go bad. I didn’t witness everything I’m going to describe. I saw some of it, and Uncle Gus told me a lot more a few years later, after I’d moved in with him. (We had a session at his kitchen table, drinking hard cider, where I pressed him for every detail of that night.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Some I’ve had to imagine. It was necessary if I was going to tell it all, because my mother would never go there. But I’m pretty sure what I’ve conjured up is close to the truth. I knew everyone involved down to their toenails, after all.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Anyway, I’ll do the best I can. I know, for example, that it was still dark when my mother opened her eyes that night to squint at the alarm clock on the side table, and I think we can assume it took a moment to realize that she was alone in bed in the middle of the night. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She must have come fully awake in a panic, then. I can picture her slipping into her robe and pulling the sash tight; I’d seen it a hundred times. And I actually did watch her pad out of their bedroom and go quietly downstairs, because I’d awakened, too—there was something in the air—and heard her door open, and when she came out I was lying on the floor in my doorway, chin in my hands. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She didn’t see me, and after she’d gone halfway down the stairs I got up and followed. At the bottom I put my back to the wall and peered into the kitchen. She was looking out the window at the dark driveway. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She switched on the light above the sink—I crouched low to stay in the shadows—and walked over to the old rotary phone mounted on the wall next to the door. There would have been a click and a dial tone before she twirled in Uncle Gus’s number, and then a hollow ring from the other end. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Uncle Gus told me it took a while to pick up, because he’d been sound asleep. “Hullo?” he said, and I’m pretty sure his voice was hoarse, because he chain-smoked and was always hoarse in the morning until he coughed up a certain amount of gunk. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Gus?” my mother said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Betty? Is everything all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Jack never came home. What time did the game break up?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It was late,” Uncle Gus said, “but he left before the rest of us. Said he was tired of taking our money and he was going to call it a night. Before midnight, I’m pretty sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well, he’s not home.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Maybe here Uncle Gus cleared his throat again. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m sure it’s nothing. Give me a minute to throw some clothes on. I’ll go and have a look. Most likely he just decided to pull over and take a nap.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Did he drink a lot?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He had a few. I wouldn’t say a lot.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Can you pick me up? I can’t sit here and wait.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Uncle Gus hesitated. “Okay, sit tight. I’ll be right over.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My mother hung up, turned to go back upstairs, and stopped when she saw me in the doorway. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What happened?” I said. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Go back to bed, Cal.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“But where are you going?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Your father’s broken down somewhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll come with you.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Your uncle is taking me. You go back to bed.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She followed me upstairs and waited until I grudgingly shut the door. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But I didn’t go back to bed, and when she started back downstairs I cracked the door open to watch, and as soon as she turned into the kitchen I was on the move, avoiding the noisy stairs and hugging the wall. (I was a good sneak, with a lot of practice.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Spying again from the kitchen doorway I saw her go outside. I hustled back through the living room to the side door and circled around the house to the north end of the porch. The grass was wet on my bare feet, and it was still warm, with a few stars behind the house but not eastward, past the river, where a band of pink had pushed over the tops of the pines. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Through the porch railing I saw her staring down the driveway. Her arms were crossed on her chest. We waited in the near-dark, together but separate.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Uncle Gus only lived a couple of miles away, but it seemed a long time until I heard him coming and then saw his headlights way up by the far curve. He didn’t seem to be going nearly fast enough. Finally, though, he came down the long straightaway, headlights flickering through the tall trees, then disappearing behind the barn, finally emerging past the abandoned vegetable stand. He turned into our driveway, crunching over the gravel, came up past the barn, and stopped by the flagstoned walkway.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He shut the engine off, and I remember the  quick silence and Mom waiting. Then he struggled bulkily out of the car and looked up at the house. When my mother realized he couldn’t see her in the shadows, she moved onto the top step. He saw her then, put his hands in his pockets and looked down at his L.L.Bean boots. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her heart must have begun to thump.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He went off the road a mile or so back,” Uncle Gus said to his boots. His voice sounded strangled, and as he stepped closer and looked at my mother, I could see that his face was beginning to fall in on itself.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He didn’t make it, Betty,” he said, in the same squeezed voice. “I’m so sorry.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then he came up the steps and put his arms around her. Her own arms stayed at her sides. While they stood there I ran back around the house, feeling as if I’d touched the electric fence at Talbot’s dairy farm down the River Road across from Becky O’Dell’s house. I made it upstairs before they came inside to call the police. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Before they left my mother trudged upstairs to tell us to go back to bed—Julie and Alvin were awake by this time, and had come out in their pajamas—and that she had to go with Uncle Gus, but she’d be back in a little while. She didn’t sound like herself; her voice was shaky. She went back downstairs, and we stayed where we were.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What’s going on?” Julie asked me.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Something happened to Daddy.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m not sure.” (I wasn’t sure exactly what awful thing Uncle Gus had meant by "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("He didn’t make it.")]), _vm._v(") I went into my parents’ bedroom and raised the window shade. Julie and Alvin followed me, and we watched Uncle Gus take our mother out to his car. He opened her door and waited until she was inside, then shut the door and walked heavily around to his side. It still wasn’t quite dawn. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Uncle Gus told me later that he tried to talk her out of going at this point, but she wouldn’t listen; she just sat there, waiting to leave. He started the engine, turned on the headlights, and drove back to the River Road. They rode along silently until he pulled onto the shoulder and shut off the engine. Then they looked at each other and he could tell they were both thinking the same thing: how awful that he’d been so close to home. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My mother was out before Uncle Gus could come around to her door, but had to stop and cover her mouth. Then she was moving again and he met her in front of the car. He took her arm and they walked across the damp road, past black tire marks that cut sharply toward the weedy ditch. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Lying in the ditch was a young spike-horn deer, midsection caved in, eyes glazed. They stepped past the carcass and came opposite a gap in the roadside brush. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It smelled like gasoline; they saw the Dodge overturned against a thick white pine. My mother pulled loose from Uncle Gus and stepped down into the ditch, hands out for balance. He followed, reaching, but she was already scrambling up the other side. He trailed her across the ripped ground and through the gap in the brush to the wagon. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The gasoline smell was stronger. My mother knelt and yanked at the buckled, inverted door, but it wouldn’t budge. She pulled her jacket sleeve down and with the covered heel of her hand knocked chunks of glass out of the way, but she couldn’t reach him because he was on the other side, upside down, knees to his chest. He was scrunched up like a kid, not a grown man, and his eyes were slightly open. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Uncle Gus told me later that he didn’t look especially hurt. It was just his eyes. The other thing that stuck with him was the St. Christopher medal lying outside his shirt. (“I guess he used all the luck up during the war,” he’d said, sitting at the kitchen table, and then he’d swiped at his eyes.) ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, honey,” Uncle Gus said now. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My mother turned and shoved her head and shoulders through the window, past jagged, flexible shards. He put his hands on her waist and carefully pulled her back, and walked her away from the car toward the road. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The ambulance came then, its siren growing louder until red light flashed on the treetops along the roadside. It stopped on the shoulder where the Dodge had sailed off the road, and two men jumped out and hurried past my mother and Uncle Gus to the station wagon. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The taller man dropped to his knees and shined his flashlight through the broken window. Almost at once the flashlight clicked off, and he straightened and turned away from the wrecked car. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Uncle Gus and my mother waited to hear that they’d been wrong, somehow. It was a last feeble hope, and they knew better because the tall man wouldn’t be walking so sadly toward them, and besides, they’d seen Jack’s eyes. But they held their breath anyway until the man said, “I’m so sorry, Mrs. Shaw.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My mother shut her eyes and turned her face into Uncle Gus’s chest. Betty Flint Shaw never cried—had grown up tougher than that—and she didn’t cry now. Not quite. But she held tightly to Uncle Gus and grieved. She was grieving for my father, of course, but I think that without knowing it she was also mourning that small, generally hidden tenderness that she had sensed trying to grow within her since she’d known him, and which was bound to sputter and die now that he was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Five")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_vm._v("Baxter, Summer, 1964 ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("Three days later we climbed the granite steps that led to the massive oak door of Sacred Heart Church. Uncle Gus held the door open. He wasn’t a lot taller than my mother, but his round head seemed twice as large. He had on his old double-breasted navy dress uniform, and you could see the strain on the six gold buttons that held it shut. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He touched my mother’s back as she went past him into the narthex, wearing a black dress to just below her knees, and a black jacket. I remember how her hair—lighter than mine or Alvin’s, more like Julie’s—had been sprayed stiff beneath her shallow black hat. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Behind her went Julie in her Sunday dress: dark blue with tiny white blossoms. Then Alvin and me in our too-small blazers, and next, my Shaw grandparents, who’d driven up from Bath. (It was the first time I’d seen them in two or three years; they weren’t big on visiting.) Uncle Gus brought up the rear, holding his white cap in both hands. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The light inside the church had an odd tint because of tall, stained-glass windows. When we got to the first pew, my mother genuflected and stood aside while the rest of us filed past and sidestepped into place. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I looked at the monstrous coffin sitting in front of the altar. Its lid was open so that anyone who wanted could take a last look at John Shaw. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We’d said good-bye earlier, by ourselves. Julie and Alvin had gone first, then I’d put my hands on the heavy, dark wood and looked in at him. He was in dress uniform, his white hat on his chest, and he looked like my father: thick, dark hair, bushy eyebrows, cleft chin. I had the eerie feeling that he was only sleeping and might sit up at any moment. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was strange, too, because you could never stare at him without his feeling it and looking around with a grin. Only this time, he just lay there, he didn’t sit up or grin, and finally I made myself leave and walk stiffly back to the pew. My steps echoed in the open space of the church and left a dark resonance in my mind, a new feeling that added to the strangeness. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My grandparents took their turns, then finally my mother, bowing her head, making the sign of the cross. She looked in at him for a long moment, turned to come back, and I was shocked to see the hot, dark anger in her eyes. She was furious at him. She caught me looking and quickly hooded her eyes. Back in the pew she knelt briefly, sat back, and said, “All right, we can leave, now.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We walked out of the church and into the sunshine. I could smell the warm grass. There were people on the lawn, waiting to go in, chatting and smoking cigarettes and pipes. But this stopped when we appeared, and at the bottom of the steps they gathered to meet us. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Becky O’Dell waded up and hugged Julie. She put her cheek against Julie’s and the breeze took her red hair and blew it around Julie’s head. They stood that way until Becky’s mother called her name, and then Becky wiped her eyes and hobbled away. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Our friends and neighbors began to file into the church. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I looked over my shoulder at them as Uncle Gus led us along the brick sidewalk to his Belair. We were going home until it was time for the actual service. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At the Belair my grandfather embraced my mother in his stunted, Old-Yankee way, and then my grandmother put her arms around her and cried on her shoulder, something that knocked my mother’s hat loose and made her stiffen.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They walked on to their own car. Julie, Alvin and I got in the back of Uncle Gus’s, and he held the door for our mother. Behind the wheel he lit a cigarette and blew smoke out the window. He shifted and drove us down the hill toward the bridge. We rode down the River Road, past his own house, and a mile farther past the still torn-up roadside where our father had crashed. Then Uncle Gus took a last drag on the cigarette and dropped it sparking onto the road. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We turned up our driveway and stopped behind my grandparents’ pickup. Uncle Gus swung around in the front seat, red-faced, trying to think of something to say. Finally he just said, “We’ll have to give it some time.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My mother got out and tugged sharply at her dress. She walked toward the house without waiting for us, moving stiffly, as if she were still marching in a parade. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Inside my grandparents slumped at the kitchen table, ignoring cups of coffee. My mother and Uncle Gus poured some for themselves and sat down, too. I went upstairs and flopped on my bunk and looked blankly out the window at the field and the woods. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My mind was busy and I was trying to ignore the dark shapes and dismal echoes: shadowy stuff that came home with me from the service. I wasn’t managing very well. There was a lot of swirling and clashing going on in there, and trying to keep it under control made my head feel hot and loose. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin came in and climbed the ladder into the upper bunk, which was set at right angles to mine. (Our father had built them that way to fit into a corner, one bunk against each wall, the head of Alvin’s over the foot of mine, with space for a little coat closet under his.)  ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Alvin?” I said, ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He shifted his weight, making his bunk creak. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I really hate this.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He still didn’t answer. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t you hate it?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Shut up, Cal.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I turned on my side and looked out the window. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie walked by on the landing and I heard her bedroom door open and shut. I looked at the blond-wood side of Alvin’s bunk and thought of our father in that dark coffin. There were angry flashes in my head and I remembered the fire in my mother’s eyes and thought I must be feeling what she was feeling. They were going to close that coffin up tight and bury him in the ground. I couldn’t bear the thought. My eyes flooded and I felt tightness in my chest. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("After a while our mother came upstairs, her footsteps slow and tired, and said, “Let’s go,” and we all dragged ourselves out of our rooms and followed her back down. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was warm in the packed church. A housefly buzzed against the stained-glass window opposite our pew and people were murmuring. Father Daly came out in his white priest garb with the purple stole, palms pressed together in front of his chin. He stepped up to the lectern and the murmuring stopped. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Father Daly cleared his throat. “Let us p-p-pray.” He held his hands out and began to chant. He didn’t stutter when he chanted, his voice just rolled on and on, and I stopped listening and just let the buzz of his words sit in my mind. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When he finished we all made the sign of the cross. Father Daly stuttered through a eulogy, highlighting high points in John Shaw’s life: his Eagle Scout success, his exploits on the baseball field, his stint as a petty officer during the war, his service as a town father. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then he offered us a sampling of scripture. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I felt the reality of it like a rain cloud. Then this was shot through with a dull, sooty anger. I couldn’t let it show, and that made me claustrophobic, and it didn’t help that Uncle Gus was rocking minutely forward and back, as if he couldn’t get comfortable. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin took his glasses off and pinched his eyes shut. I was sure he was trying not to cry. On the other side of him, Julie’s mouth hung open and trembled, and her shiny eyes were fixed on Father Daly. She made a choking sound and my mother looked at her for a moment and put an arm around her, but it looked even more awkward than usual, and Julie didn’t seem to find much comfort there. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Father Daly said a final prayer and asked if anyone had memories to share, and a few men walked self-consciously up to the lectern to tell stories about hunting trips and golf matches and state championship games. When they were done, Father Daly stood from his chair against the wall and took a step toward reclaiming the lectern. But Uncle Gus surprised him by rising to say, “Excuse me.” Father Daly looked at him, and Uncle Gus sidestepped out of our pew. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Father Daly backed up and sat down. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Uncle Gus took the lectern, tugged at his jacket, cleared his throat, and started talking. He had a hard time looking at anyone, and his voice was tight and squeaky, but he didn’t give up. He told us how he’d gotten to know John Shaw because they’d had the same last name and the navy did everything alphabetically. This—along with a shared love of music (Gus an accomplished musician, my father a slappy, self-taught piano player)—made it easy to be friends, and when they shipped out together, they got even closer. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Uncle Gus had been a Midwest foster child, and had no real family, so after the war he’d followed John Shaw back to Maine, where he’d found an old ranch house to fix up on the same stretch of road where his best friend settled with his new wife (a pretty volunteer nurse’s aide they’d met on shore leave in San Francisco, and of whom Jack had said, after two dates, “I do believe that might be the girl I’m going to marry!”). ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Uncle Gus had more to say. I don’t remember the phrasing, but he was basically confessing just how much his own happiness had depended on John Shaw. (Which we already knew: He’d stayed a bachelor, and we’d been his family; his good times were hunting or fishing or music at our house, or anything else, really, that involved spending time with my father.) Finally his voice cracked and he gripped the lectern—shoulders up and large head low—until he’d regained control, and then his hands fell to his sides and he said, “We’re just going to miss him, that’s all. There’s really no way around it. We’re all going to miss Jack Shaw like hell.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Which made pious Father Daly frown. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But it made Julie catch her breath, and seemed to me to be exactly the truth of the thing. ")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Six")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_vm._v("Tampa, 1995")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("Despite Neal the Nazi’s driving habits, we make it to the office of the taxi service—a shack a mile down the access road from the airport—and I sign out my cab and hang the clipboard back on its hook on the wall, to the left of the manager’s desk. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Emile Lopez is the manager. He’s skinny as a fence post, so everybody calls him Fats, or sometimes, El Gordo. Today he’s wearing an un-tucked Hawaiian shirt that hangs loosely on him. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Watch the oil, all right, Shaw?” he says. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I look at his skeptical face, with its horsey upper lip. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t want to put another goddamn engine in that thing.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll keep an eye on it.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He waves at me and goes back to his paperwork. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I walk out to the lot and fire up the old blue Chevy I’ve been saddled with since I got out of jail. (Fats let another driver commandeer the Crown Victoria I’d been driving, reasonably enough, since they had no way to know when I’d be back.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It takes a few seconds to warm up, then I drive out of the lot and down the access road and around to the taxi stand by baggage claim.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Delta has just come in from New York, and I grab a couple of pleasant old-timers heading into Clearwater to see what shape their winter renters left the condo. They’re on the spring-training rental list, and some of the minor leaguers can be rambunctious. But my passengers love the idea of being associated with professional baseball, so they don’t really mind. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Traffic is still crawling because of the potato truck, but these people are too nice to be impatient, and as we make our way toward the causeway, they tell me what various young ballplayers have done to their property. Then they get into the past winter and how much snow they had and how long the dirty snowbanks lasted. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Here in Florida it’s sweltering, and my AC isn’t much, but my new "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("no importa")]), _vm._v(" attitude is holding up all right. I don’t mind the heat or the small talk. And after a while, when the conversation runs down, I get my passengers’ permission to put the radio on. The local jazz station in St. Pete is featuring Miles Davis today; his muted trumpet seems just right. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It’s pretty on the causeway, with the little fishing boats circling in the bay and the sunlight on the water and the bait fishermen casting from the pedestrian shoulder. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Miles is playing “Blue in Green,” and as I watch gulls gliding overhead and sunlight on the water and girls walking the bridge in pairs, with their hair shifting in the breeze, I suddenly feel that earlier mood again. I’m grateful to be here at this moment, seeing what I’m seeing and hearing Miles—and Coltrane and Chambers and Bill Evans—calling and answering about their personal knowledge of the sad beauty of life.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then we thump off the causeway and I have to dodge a panel truck taking a quick, risky slant across my lane, and just like that I’m back in business mode. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I drop my passengers and head back across the causeway. Traffic is starting to improve, and by the time Fats has bounced me around Tampa for a couple of hours, it is no more sluggish than usual. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then it becomes just another day. I’m hustling the same as always, working the side streets to make time, playing my passengers for tips, and I don’t have time for nostalgia or deep thinking. (I do carry in the back of my mind a thought about making a trip across the Skyway Bridge, because I want to look down at the water and see how it feels up there on that high span. But I never get far enough south.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The sun moves across the sky and it gets even warmer and I make trips with airmen to McGill, a long run to Winter Haven, and do lots of running around town. And maybe it’s my new attitude, but by the time my shift ends and I’ve headed for the barn to turn the old Chevy back in, I’ve had my best money day in a long time. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It makes me smile, the way things work sometimes. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At the office, Fats is grumpy when he hands me a note scribbled in smudged pencil. He doesn’t like taking messages and won’t make any effort to jot them down legibly. But I manage to work out that it’s from a friend named Henderson who runs a little jazz club on North Franklin. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I wonder if it was he who called me at home that morning, but when I borrow Fats’s phone and call he claims it wasn’t. He’d only that afternoon heard from Tampa Red that their horn player had had to sneak out of town for domestic reasons, and they needed a stand-in for two nights.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You sure it wasn’t you?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Use your head, Cal. What the hell would I be doing up before dawn?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good point.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So are you in? Else I’m going to have to call around.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s not much notice.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You can handle it.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I wonder for a moment if my blazer is clean enough for a gig—Red’s combos always sport blue blazers—and then I say, “All right, what the hell.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good.” I hear someone talking in the background, and then he comes back on. “Red’s asking do you want to get together and go over the list?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nah, I’m fine.” I’ve heard Red’s band before, most recently at an Al Downing event just before I was locked up. They play the usual West Coast stuff: the Chet Baker, Miles and Gerry Mulligan cool jazz, which is right up my alley. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“And you’ve got it all under control?” Hendu says. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You wouldn’t bullshit me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I got squared away at Pinellas.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That must have been fun.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah, not so much.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I remember lying on my bunk in the kick tank, shaking and nauseous.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Okay, then. Eight o’clock.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I hang up the phone just as Fats is about to give me hell for tying up one of his business lines. He eyes me anyway as I walk over to the cabbie card table, drop my cash bag, pull out my receipts and fare sheets and start figuring my forty percent of the take with the old calculator.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You make me any money?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Millions,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There’s a roar as a jet takes off. It flies close overhead, rattling the windows. Fats’s office is off the end of a short runway that’s only used when the wind is right. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So how much did you steal?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No more than was reasonable.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He snorts a laugh. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I give him the paperwork and his share of the cash, then ask him to sport me a ride back to Dearborne Street. He rolls his eyes and wonders when I’m going to break down and buy a frigging mo-ped or something, but then presses the transmitter key. “All stations alert! We got a deadbeat here needs a ride.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“A mo-ped?” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“A scooter, then. Whatever. A fucking mule.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The radio crackles. “Let me guess, that "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("pendejo")]), _vm._v(" Shaw.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“"), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Si")]), _vm._v(",” Fats says. “He says you can charge him double. It’s all the same to him.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Fats laughs. His jokes are almost always for his own benefit.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Five minutes,” the voice says, and clicks off.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thanks a lot, Fats.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He grunts.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I appreciate it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Fats squints up at me. “You’re awful goddamn sweet today.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I make prayer hands and bow my head. Fats waves me off and I go outside to wait. It’s still warm, and I lean on the chain-link fence and fight off wanting a drink. ("), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Just one!")]), _vm._v(" my friendly little demon whispers. "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Just a beer! It’s so hot out!")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I kick at the dusty spikes of grass growing through the bottom of the fence and watch another passenger jet taking off on the short runway. The jet barrels along, wings sagging, gathering speed. Then its nose jerks up as if it is leaving the ground at a sharp angle, but really it’s just plowing slightly upward and forward, in a chesty sort of way, when it thunders over the shack. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The roar fades and I hear a beep and turn to see my old Crown Vic—number seven—coming up. It stops opposite where I stand and the driver gives me a wise-guy smile. He has thick, black hair slicked back and a pencil-thin mustache and wears a black sleeveless T-shirt that shows off the ropy muscles in his arms. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I get in and he puts his hand on the meter as if to throw it. When I just smile, he says, “Bah!”, and pulls himself back behind the wheel. “How’s that Chev-ro-lay working for you?” he says, looking over his shoulder at the road. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s a peach.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He grins.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Go ahead with the meter.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s all right, "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("chico")]), _vm._v(". I’ll take you in out of the goodness of my heart.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He throws the gearshift and drives toward the road. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re a good man.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m a fool,” he says. “But I can’t help it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There’s a gap in the oncoming traffic and he steps on it to merge. We snake out into the traffic and head north. He has his radio on, and is flicking cigarette ash out the window, and we listen to cha-cha music all the way in. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When he lets me off at the trailer park I stick a sawbuck in his ashtray and jump out before he can refuse it. Then I grin like I’ve put one over on him. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He drives off, tapping the horn lightly. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I look at the kids’ trailer, but it feels empty. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Inside my own I ignore another sharp craving for cold beer—there’s none in the place anyway; I’d have to go out—and settle for a glass of water. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I sit down on my bed and dig a blank music sheet out of my old portfolio, so I can set down the melody that’s back in my head again.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I take out the Olds, play a couple of bars, and score it. Then I play a little more, muting so that no one will come thumping on my door because their afternoon siesta has been interrupted. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I cross a section out on the sheet and rewrite it. Then I put the sheet away and just blow for an hour, warming up for Henderson’s. I play scales and a few easy pieces and work my way into “Blue in Green,” trying to make it sound like Miles, and then I mess around in different voices: Clark Terry, Chet, Lee Morgan, Dizzy. (I was always pretty good at imitation; it’s an important part of how I learned to play back in those days when the trumpet was all I had, after it seemed like I’d lost everything else.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Afterwards I go back to my new melody and fiddle with that until I have to stop, because without meaning to, I’ve conjured up something very weepy and raw, something that has to do with Julie, or maybe her ghost. (I know I haven’t told you much about Julie yet; I just haven’t found the right moment to be direct about it. But trust me, I’m working up to it.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I hold the cornet in my lap as the old emotions rise; for the sake of the music I let them knock around inside, dark and lumpy and mean as can be. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Bent over the horn with my elbows on my knees, I feel all the old cruel scenes play themselves out; I hold them in my mind until my stomach twists and I remember about the barn and what happened there and how unfair it all was. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I hold my breath against another fierce desire to drink, then exhale and tell my sweet sister that maybe pretty soon we’ll be together again, and we’ll be able to talk as much as she wants. But that doesn’t help; she wants to talk now. And I can’t stop her. It’s like another melody has come along that has to be heard—only I know where this one goes, and there’s nothing I have to do but let it play. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I see the two of us in the hayloft, Julie tossing her head and stepping out onto the timbers that run all the way across to the wall above the double doors. I watch her walk across and then start back and I face up to the swirling dark colors that form into tumbling shapes and I hold on tight. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("This is a bad one, but I’ve outlasted bad ones before, and eventually it all starts to smooth out. Then everything settles a little more, and it’s not much longer until I can let go. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I hang my head, spot a soiled T-shirt in a heap of laundry on the floor, and grab it to blow my nose. I drop the T-shirt, raise the horn, and press it to my lips for a moment, and then I play my melody through again, trying to let it just speak.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I’m talking back to Julie now, the best way I can. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I follow the shape of our conversation, turning and expanding along one edge, and I work it out that way until everything matches, and I see the shape shift again, and I play along the new path for a few more bars, and then I start from the beginning and play it all again, hearing the piano chords in my head, and I jot it down on the music sheet, writing around a couple of damp spots on the paper. ")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Seven")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-8"
    }
  }, [_vm._v("Tampa, 1995")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _vm._v("Tampa Red is in good form, but he has a new drummer who manages to consistently come down exactly in the middle of the beat. You or I couldn’t manage it if we tried, but he does it naturally, and nothing anyone else plays seems to make any difference. That’s bad, because it can make it hard to really swing, which is the main idea, right? ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But I’m able to work with it, which is encouraging. I haven’t played in public for some time, and haven’t played "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("straight")]), _vm._v(" in public for years. I could never neglect my horn for long—even fall-down drunk I was likely to haul it out and start blowing—but performing for an audience, with other musicians, is a whole different ball of wax. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But I’m doing all right. The ideas are there, and once I get warmed up, I find I’m still capable of chasing them into a decent shape. Not setting the world on fire, maybe, but no liability, either. And it gets better as we go along. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When we’re soloing and it drops to me, I know where to go and how to do it. I know how to pick up Red’s lines and throw them back at him; how to build off his digression and make it into my own; how to bring it all back to where we started. It feels really, really good, and even better when our audience applauds and whistles and Red looks at me and nods.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There’s a good crowd, and it’s smoky and dark in the little joint. My old amigo Rocky Kincaid is there; he looked me up after he got out of the pokey, and then figured Tampa was as good a place as any to hang his hat. (He’s from Mississippi, but nomadic, and was just passing through when he ran afoul of the law, as they say.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Kincaid is sitting at one of the old two-tops near the windows with a tall, lovely gal—no surprise, with Kincaid—who hasn’t been shy about clapping and even whistling when she likes something we’ve done. When we take a break I step down from the little foot-high stage and go over to say hello. Rocky kicks a chair out so I can sit down. I take the blazer off and drape it over the back of the chair. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“This is Celeste Boucher,” Rocky says. He’s grinning and his forehead is shiny. “She’s a trumpet girl, and she’s got a big crush on you. She says you look like Quaid, man! Quaid with a trumpet! Now how am I supposed to compete with that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m sure you’re worried about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Celeste shakes my hand and smiles.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I was telling her about our tats, man.” Rocky rolls up the sleeve of his pink dress shirt, exposing the tattoo he got in jail: a little blue sax with a flurry of sixteenth notes flying out of its bell.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She’s never seen that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh hell, yeah, she’s seen mine.” He pokes at my sleeve, and I roll it up past my own tattoo, which is like Rocky’s, only with a trumpet. Celeste reaches over and touches the tattoo on my inner forearm. It gives me a tingle and she smiles as if she knew it would.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Tell her the story,” Rocky says. “You tell it better than me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She doesn’t want to hear all that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s a good story!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good and boring.” I smile at Celeste.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nah, man, it’s a tragic tale of . . . something.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Of nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, it’s definitely of something. Me and you, brother. Two jazzmen locked up in the can. Remember when we played for the warden?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He winks at Celeste.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We never played for the warden.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We did when I tell it. Remember how he offered to commute us?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Wardens can’t commute sentences.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Celeste don’t know that. She’s from the swamp country.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, Rocky,” Celeste smiles tolerantly. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All right,” Rocky says, “she probably knows. So forget that. What did the warden do? He let us bunk together, and instead of peeling potatoes, we got to wail for the population.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Which was true: The warden liked jazz, and offered to let us skip work detail and practice if we’d perform for the inmates. So we did, and a guy who played piano joined us, and then we got a drummer (who was better than Tampa Red’s drummer, by the way), and just like that, we had a combo. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We weren’t that bad. Kincaid could play, and the keyboard dude had some chops, and I’d been out of the kick tank long enough to stop shaking. One day the four of us decided to get the tattoos from a con who had a little business going. Thinking about it, I wonder what’s happened to the other two guys.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rocky’s still inventing jail-time adventures for Celeste—making us both laugh—when I hear piano chords from the little staging area. I look over and Red is sitting at the piano, looking back with his eyebrows up. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I roll my sleeve back down. “Time to go to work.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Break a leg!” Rocky says, and Celeste says, “Nice to meet you,” and when I get back to the stand I see that she’s watching with her hands clasped under her chin. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It’s been a good crowd all night. Most of the other people have been paying attention too, and Henderson himself, standing behind the bar in his green apron—"), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The color of money, brother")]), _vm._v("—has had a smile on his face most of the night. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I pick up my horn and just like that, Red launches the intro to “Joy Spring,” and I have ten seconds to get myself ready to go. I give him a look, but I’m there and he laughs, and then we’re at the break and I do my best Brownie imitation.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The whole set is fast—Red likes to work that way—and we play “Daahoud”"), _c('span', {
    staticClass: "CharOverride-3"
  }), _vm._v("and a couple more quick ones, and then we’re cooking along in the middle of a Thelonious number called “Well, You Needn’t,” playing it fast, like on "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Chet Is Back!")]), _vm._v(" Red is comping sweet, two-handed chords while I chase after a flexy shape that snakes through the chords, nasty and abrupt, like a used pipe cleaner. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I’ve maintained my fluency as the night’s gone on, and now something clicks and I nip up as close as I ever get to master territory, nailing a phrase so precisely—when it really shouldn’t have fit—that I hear Celeste Boucher laugh out loud and somebody else whistles.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("That’s a good feeling; maybe the best. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So I have some drive when the pay phone on the wall starts in, and I’m able to keep on for a while, playing through the shrillness, but the damn thing won’t stop, and finally I give Red a look, take a shortcut back to the melody and let it go. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I lower my horn, and while our bass man twongs his way up through my applause, I see Henderson come out of the back room, lean across the bar, and snatch the phone off its cradle.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He listens, then holds it against his chest and jerks his head for me to come over. I tuck the Olds under my arm, suspicious as to whether it might be the same person who called that morning. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Heads turn to see where I’m going. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Henderson holds out the receiver, then walks back to the triple beer taps to wait on a new customer. I duck my head close to the wall. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Make it quick.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I hear: “Cal?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And man, that’s all it takes. I mean, my mind has been halfway there for days anyway. I press my forehead against the wall and shut my eyes. I see flickers of the house, the family, the old, paint-peeled barn. I see my father and my mother, and I see that piece of shit Pike (his meat-eater grin, grizzly-bear shoulders and black mustache), and then I see Julie in the hayloft, defiant and brave.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Cal!” Alvin says again.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I look at the stage, where Red is hunched over the keyboard, shaking his head and playing like there’s no tomorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Say something, man!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hey,” I say, finally. “Okay. Alvin.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Jesus, it’s about time.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m sorry.” I cover my off-ear with a hand so I can hear him better.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re not an easy guy to talk to, little brother.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Was that you this morning?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ve been trying all day. Finally had to track down your probation officer.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I picture the PO, a little man named Swanson who is probably fifty years old and still wears his hair in bangs. I remember he had potted plants in front of his window that he puttered with while we talked, poking his finger in the dirt, snapping off bits. He insisted on family information, so he could copy them in. I didn’t know if that was required, or just something he thought would help, but at that point I only wanted to get the hell out, and would have signed off on anything. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin got my work number from Swanson, and then Fats told him about the message from Henderson, and since the club was called Henderson’s, the rest of it was doable enough. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You went to a lot of trouble,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well, it was important.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Which is when I realize that there has to be a reason for the call, and something that looks like a sunspot, black-rimmed and fiery, goes off in my head. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Wait,” I say. “Not the old lady?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She’s fine.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I peek over my shoulder at Red, sitting upright now, banging the keys, an ashy cigarette in his mouth. Who knows how he managed to fish it out of his pocket and light it without missing a beat.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t tell me it’s Pike.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, it’s Uncle Gus.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, no.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Turns out he’d suffered a stroke—fell off his chair watching television and stayed on the floor until morning, when one of his music students spotted him through the window. Now he’s in the hospital, unable to speak, but, according to Alvin, able to focus when you talk to him. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Man,” I say. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah. I thought you’d want to know.” He waits, and when I don’t say anything more, he says, “So do you think you might come back?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I probably should, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re the one he liked.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He liked you, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah, but I didn’t play the trumpet.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("That’s true, and I don’t say anything.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“If you need money . . . ”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, I’m good.”  ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All right, then.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He goes silent again, and I know he’s waiting for me to confirm that I’ll be heading home, which we both know I haven’t quite done. And I would, if I hadn’t suddenly lost the ability to speak.  ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Uncle Gus was the only ally I had after things really went sour. He even let me move in with him when I had to leave home. So even though he never actually defended me—he was too afraid of Pike—I still always had feelings for him. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You still there?” Alvin says.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I clear my throat. “Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So I wouldn’t wait too long.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Got it.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Seriously.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All right. Is he in Portland?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah, Maine Medical. You could go right in from the airport. I could meet you there and bring you back. You’ll have to stay at the old homestead, though; I don’t have a lot of space left over, what with the kids . . . ”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t worry about that.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, I wasn’t.” He cackles, then goes silent, and after a minute or so I figure the conversation has pretty much run its course. But I want to end on a decent note, so I break into the silence to thank him for calling.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No problem.”  ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m glad everybody else is okay.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’re struggling along. How about you?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m doing all right.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are you playing much?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well, I’m playing tonight.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I watch Red and his crew walk toward the bar, where Hendu is setting them up with beers. Red looks at me and shrugs as if to say "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I couldn’t wait forever")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well, Alvin says, “I’ll see you if I see you.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then I’m listening to the dial tone. I shake my head. Fucking Alvin. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I hang the phone up, open the spit valve on my horn, shake a few drops out onto the floor next to the smudged mopboard. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Henderson comes down, leans on the short side of the bar, and looks at me.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“My uncle had a stroke.” I give the cornet a last shake.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m sorry, man. Were you close?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Pretty close.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Is it serious?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sounds like it might be.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He nods. “Go ahead and split, then.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I can’t do anything about it tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You go ahead. Get things together.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I fiddle with the valves, tempted to insist that I finish out the two nights. But then Henderson taps a finger on the bar and says, “You do what’s right, Calvin.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I go back to the stage and lay the Olds onto its worn velvet, then snap the clasps and swing by the bar again to tell Red what’s going on. It’s gotten noisy with bar chatter since the music stopped, and he leans in close and says, “Get in touch when you get back.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I shake his hand, nod to the other two guys, and walk across the room to Kincaid’s table.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What’s up, man?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Got a call from home.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“"), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Home")]), _vm._v(" home?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“My uncle. I guess he had a stroke.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The uncle that played?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We’d talked a lot in jail. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Anything I can do?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, but thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Celeste Boucher reaches out a small, mocha-shaded hand. “I’m so sorry about your uncle.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I love your playing.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thank you.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She smiles sadly. Smart eyes, world-class dimples, thin-strapped print dress square across her chest. I pull my gaze away from her and shake hands with Kincaid.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You need any cash?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m good.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All right. You know where to find me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I head out, winding through the tables, tapping the palms of a couple of guys along the way. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When I get to the door I see Henderson stalking the perimeter of the room, so I wait. He comes up and sticks a wad of bills into my hand.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Almost forgot.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You don’t need to do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nah, man, you helped me out on short notice.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Now I’m leaving you high and dry.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Take the bread; just keep your head on straight. Don’t fuck it up now that you’ve got this far, okay?” He nods and marches in his muscular way back to the bar. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I slip the cash into my blazer pocket and step out into the night. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Wispy steam rises from sewer grates, and cars cruise past with their headlights on, dragging thumping bass lines from souped-up stereos. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A young couple comes around the corner. The guy is air force, and his girl is dressed like a hippie, with a long skirt and a tight jersey. They go into the club and I think of my own crazy nights with various girls, and I feel a sudden, strong tug to step back into that life. It always looks less dangerous from a distance. You remember the carefree existence, you feel nostalgic for the parties and camaraderie and access to women that even a modestly successful jazzman can have (especially in New York), and you minimize the hazards.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("All I want at that moment is to get buzzed and find some lady to try and drunk-charm. I know it’s a false feeling, I do. But I still have to concentrate to keep it from taking me over like it’s done in the past. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I run away from the club, crossing the intersection, dodging past a low-slung car that isn’t about to slow down for the likes of me. I jump up on the curb, banging the case against my leg, and head for a shortcut between a used-clothing store and a boarded-up head shop. The clothing store has a nightlight on behind its plate-glass window, and I can see two well-dressed adult and a couple of kid mannequins, sitting around a picnic table, all smiling ferociously. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I trot down the alley and come out into a hardscrabble neighborhood of apartment buildings and beat-up old frame homes. There are some tough-guy adolescents on one corner, and they turn to look at me, but note the cornet case and only nod. I suppose they’re used to musicians coming and going from Henderson’s.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Once through that neighborhood, I make a left turn and stay in the shadows to skirt a liquor store with cars in its lot with their lights on. A few blocks later the buildings thin out and there are abandoned houses and weedy, littered, vacant lots with chain-link fences. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I keep going, and after another half-hour I’m on outer Dearborne. It’s darker without all the city lights and I have four miles to go to reach my Home Sweet (Tin) Home.")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Eight")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-9"
    }
  }, [_vm._v("Tampa, 1995")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("I hike along Dearborne and stick out my thumb, but no one shows the least interest in stopping. So after a while I just resign myself to walking the whole way. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It’s no big deal. I’m not going to waste money paying for a taxi, nor impose on one of my fellow cabbies when they’re hustling to finish off the night. It’s warm anyway, and walking makes it easier to think. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I walk along the gravel shoulder, passing rural homes with scruffy yards and ramshackle garages, some advertising small businesses (a vacuum cleaner repair shop; an outfit called Snowbird Auto Sales). ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It’s well after midnight now, and the good feeling from playing again has faded and I’m stuck in that loneliness that can crop up when you’re out by yourself in the wee hours. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I look up at the stars—bright pinpricks—and I think about how that light came from far in the past, and my mind sort of lurches sideways to my own past, and home, and I try to imagine going back after all this time. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It’s such an unexpected possibility. It’s been twenty-odd years, which until tonight would have seemed like a long time, but which now, suddenly, feels like hardly any time at all. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My thoughts go back to the old farmhouse on the river, and it’s good, at first. It was my world, after all, and I knew every corner of that building and every inch of the property. My family was everything, and for ten years there I felt invincible. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But it doesn’t take long to lose that good feeling. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The bad stuff—my father, my sister and Pike—comes crowding into the picture as usual. It boils and intensifies, and before long I have to stop, turn my cornet case on end, and sit down for a time-out. Sometimes you just have to have a cigarette and trust that those dark, squirmy thoughts will back off. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So I sit there, next to a spiky telephone pole. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It’s quiet, with the occasional car that you can hear coming from a long way off. The air is still and thick. My shirt is stuck to my back and now the mosquitoes have found me. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I blow smoke at them and take another drag and my mind begins to settle, and when I can think clearly again I consider the two halves of my childhood, how they split starting with my father’s death and then broke wide open after Julie’s. It was as if my father’s accident opened a malevolent door to all the other bad stuff; I think that if he’d only stayed alive, none of it would have happened. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But he didn’t stay alive, and I remember how my life was yanked off its rails that summer with him gone, and I remember, too, how awfully different things were when I went back to school in the fall. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was like being a new kid almost, since I was the only one in my class who had ever lost a parent. Other kids looked at me sideways and the teachers walked on eggshells, trying not to say the wrong thing. And I had my role to play, too. I could no longer be one of the rambunctious kids. I was already sad, and this made me angry, which only added to my problems. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There wasn’t much help at home, either. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My father had been our family’s center of gravity, and now that he was gone, everything was stretched loose and my mother just wasn’t capable of taking up the slack. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("That wasn’t all her fault, I grant you. She’d been brought up without any love, right? (Or maybe worse; I never found out for sure.) Then she’d finally found some with Jack Shaw, and now he’d stupidly taken that away, and she was really angry and lost (just like I was). ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It must have been overwhelming to try and deal with that and take care of three kids. She also had to go out and find a job, when she’d never had to work. So probably I should consider all that and excuse her to a certain extent.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But more than twenty years later—sitting on my cornet case, slapping bugs, squinting into the past—it’s still hard to go all the way with that. I’m still angry that she didn’t find some better way to cope. People do fight through their limitations when they have to rise to the occasion, do they not? ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I mean, there were kids involved.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I do believe her own cold-fish parents left her with a small, stony heart, and that my father had found the one piece of it still capable of love, and that when he deserted her by drinking and driving and dying, that little soft spot was torn apart and had to calcify to heal at all. And I also believe that when that healing took place, it didn’t leave much room for me or my brother and sister.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But I’m still not excusing her. Because even if that soft spot was gone, she should have known enough to pretend. She could have faked it, and we wouldn’t have known the difference. We were only kids, right? ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We were only kids.")]), _vm._v(" "), _c('p', {
    staticClass: "parts-head"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v("BIG MAN ")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Nine")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-10"
    }
  }, [_vm._v("Baxter, Fall, 1964")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _vm._v("She had no choice anymore but to get after it. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We would come home from school and she’d be at the kitchen table with the classifieds, circling anything that looked promising. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She’d have an ashtray there with stubbed-out cigarettes, and a cup of cold coffee with an oily-looking slick. When we came in she’d look up and say, “Hello, children. Have your snack and go watch TV, please.” There’d be a box of graham crackers waiting for us on the table, and a jar of Skippy peanut butter, the crunchy kind. Then she’d go back to the newspaper while we got glasses of milk and sat down with her to have our snack. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Anything good?” one of us might say.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Without looking up she’d say, “We’ll see.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("That’s how it went that first week. She pored over the classifieds, made phone calls while we watched our shows, and sometimes put on the gray Chanel skirt and jacket she’d bought because of Jackie Kennedy and drive off for an interview. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There seemed to be plenty of jobs in the newspaper—we were still in the postwar boom—and it only took a week for her to settle on becoming a nurse’s aide at the Pen Bay Medical Center. She went in to apply and was hired on the spot. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The following Monday morning, she told us that Julie would be in charge at home—which made Alvin and me scowl—until she got home from work. She taped Uncle Gus’s number on the wall by the phone in case of an emergency, then sent us out to wait for the bus. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was drizzling, so we waited in the old vegetable stand. I remember the rain pattering on the roof as we looked out at the wet road. When the bus stopped we waited until Mabel Morrison opened the door and ran for it. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We were almost to the bridge when our mother swooshed past, water spraying up from her tires, on her way to the hospital. She was going pretty fast, and my hopes raced right along with her. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But that job only lasted a month. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her Red Cross training didn’t stand up to the reality of blood, bedpans, and urine-soaked johnnies. The leaky fluids of strangers made her ill, and she couldn’t offset this through gallows humor or camaraderie like the other CNAs, because she didn’t know how, and because her husband had died. So she gave notice, and went back to the classifieds.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her second attempt was as an assistant to old Doc Weatherbee, the dentist, who sported the only goatee in the village. But that one didn’t last much longer than the hospital job. It just wasn’t a good fit. My mother was even less sociable than she’d been before, and Dr. Weatherbee’s patients soon decided she was snooty. Everybody knew she’d grown up in godless California, which made that no real surprise. And they understood that her husband had died, but they were a war generation that had lost lots of husbands, and they thought she needed to move on like everyone else. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So Dr. Weatherbee fired her and replaced her with an older woman who may not have dressed up the office like my mother but was much better with the patients. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I don’t recall what the third job was, but she failed again, and by that time nearly three months had passed with only a few small paychecks to show for it. So things had gotten very tight, and she was getting desperate when she spotted the new help-wanted"), _c('span', {
    staticClass: "CharOverride-3"
  }), _vm._v("ad placed by the Randall Pike Real Estate Agency. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Everybody knew old pig-eyed Randy Pike, who was something of a local legend. He’d gotten his real estate license while still in high school, had started his own business two years after graduating, and had been smart—or lucky—enough to buy up farmland along the upper river just before the big development push in Knox County. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("That made him a shitload of money, and also elevated him to Big Man status in our little town. Even a messy divorce—with rumors about an underage babysitter—couldn’t touch him. And after he broke Arthur Stimpson’s nose at the Neutral Corner bar for making a crack about jailbait, everybody decided to leave the topic alone.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So my mother knew exactly who she’d be dealing with, but it didn’t matter, she was desperate. And it didn’t matter that Pike was looking for a licensed agent, either; she was sure they could find a way to work around that. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She put on the Chanel outfit, drove straight to his office, and in a twenty-minute interview managed to convince him that it made perfect sense to let her start as a sort of receptionist until she could pass the real estate test and truly join the team. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At supper that night she said, “Let’s hope this pans out,” and explained that if it did and she sold lots of homes, maybe when the time was right she could go into business for herself. Then they wouldn’t have to depend on anybody. “So keep your fingers crossed,” she said, and it seemed to me at the time that some light had come back into her eyes. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I crossed my fingers behind my back, and I suspect Alvin and Julie did, too. And just in case it helped, that night I prayed hard on my knees for this one to work out. I prayed so hard that when Julie came up the stairs and passed my open door I didn’t even try to disguise what I was doing. I stayed on my knees and prayed that this job would be one my mother could keep and that would be the first step back for our family—or if not exactly back, at least away from what we’d become, which was basically just a collection of unhappy people. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("For a little while it seemed that my prayers might be answered. My mother studied hard and passed the written test on her first try. She went to the hairdresser’s for a short, modern trim and bought some more business-y clothes. And at first, with Pike feeding her clients and helping show the properties, she didn’t do badly. But eventually she had to go out on her own and then it all went to hell. It turned out she was no better at real estate than she’d been at dirty bedpans or crusty molars: her chilly personality again.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She never made even one sale by herself, and that put Pike in a bind. He was businessman enough to know he had to take her off the roster; she was losing business, and his other agents were starting to grumble.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But there was a complication: He and my mother had already become something of a couple. Maybe this was my mother cold-bloodedly hedging her bets, but however it happened, despite their difference in age (he was eight years younger), they’d become cozy enough that Pike was taking her out on Saturday nights, and doing chores for her, like plowing our driveway after it snowed. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("That wasn’t the only plowing he had in mind, but my mother managed to keep him somewhat in check, which wasn’t easy with a man who had trouble taking no for an answer. I saw this myself one evening when he’d come over after supper and I’d slipped out the side door to spy on them and caught them smooching on the porch, leaning together from separate rocking chairs.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Peering through the slats at the end of the porch railing, I saw him snort and paw, and my mother suddenly stand, tug at her clothes, and tell him she was sorry, but she wasn’t ready for that sort of thing, yet. After which he grabbed her by the shoulders. “You seem pretty ready to me,” he said, and pulled her close against him. She struggled and said, “No, Randy!” but he just held her tighter and tried to kiss her. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Before I could climb over the railing one of the rockers went over with a bang, and that seemed to snap him out of the state he’d been in. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He laughed and held up his palms. “Sorry, kid, I guess I got carried away.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll say good night.” My mother turned and opened the door.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When the door closed behind her Pike stared at it for a moment, then turned and smashed the heel of his hand against a porch post hard enough that I thought it might crack. It made me jump, but he didn’t hear me.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He marched down the steps and walked to his pickup, kicking a leg out to adjust himself along the way. I knew that had to do with men and women, and what he’d wanted to do with my mother, and I wished I’d had a rock that I could wing at his head.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Afterwards my mother didn’t tell him to get lost, and they kept right on as if nothing had happened, and that’s how things stood when Pike figured out what he had to do in terms of the workplace. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He liked to tell the story afterward—how he approached her at her desk and asked to talk to her in his office. How once inside the office, he shut the door and said, very seriously, “Have a seat, Betty.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I can see her sitting there, back straight, holding her pocketbook in her lap, no doubt in despair that she’d failed again. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are you going to fire me?” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not exactly.” Pike leaned against his desk with his arms crossed. Then he told her that she shouldn’t worry; it didn’t matter that selling real estate apparently wasn’t her cup of tea, because he had another position for her to consider. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My mother cocked her head. “What’s that, Randy?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike grinned and reached back to open his desk drawer. He fished something out, then pushed away from the desk, sank heavily to one knee and presented the pretty little box in both hands. ")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Ten ")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-11"
    }
  }, [_vm._v("Baxter, Late Winter, 1965")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("My mother told Pike that she’d need time to think, but I doubt he was very worried. He was Randy Pike, wasn’t he? Besides, he knew that she didn’t have a lot of options. She’d failed at working for a living, which meant that she pretty much had to marry someone or go bankrupt. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And it wasn’t much of a seller’s market either, not even for a looker like Betty Shaw; not if she was also pushing forty, with three kids and a mortgage. So I doubt he was shocked when she accepted a week later. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We were, though, when we found out about it the next morning. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("As I remember, it was almost time to head outside for the bus. It wasn’t spring yet, and still dark enough at that time of day that the light over the sink was on. We were slurping down our Cheerios (me) and Rice Krispies (Alvin and Julie) when our mother came over to the table and sat down. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We watched her, spoons hovering. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I have something to tell you,” she said, clearing her throat and looking seriously from one of us to the other. “And that is that Mr. Pike and I have decided to join forces.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What does ‘join forces’ mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My mother looked at Julie. “It means that we’re going to get married.” She was a little flushed around the cheekbones. “A few days ago Mr. Pike said he thought it was about time that we took the plunge. I told him I’d think about it, and last night I called him and said that the answer was yes.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I was too aghast at the idea to speak. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But Julie narrowed her eyes and said, “Shouldn’t you have asked us first?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No. It was a decision I had to make.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What if we don’t want a new father?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I thought I knew exactly how Julie felt: Pike dropping by or clearing the driveway or dating our mother was one thing. But Pike becoming part of our family was too horrible to even contemplate. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My mother quickly held up her hands. “Mr. Pike won’t be trying to replace your father. He’ll be your stepfather, is all. Now listen, I’ve invited him over for supper tonight—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, joy.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s enough, Julia. He’s coming over and we’ll all get to know each other a little better.” She looked at the clock over the stove. “Now finish up or you’ll miss the bus.” She stood, cinched her robe tighter, gave us a last look, and walked stiffly away. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We heard her going up the stairs. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Holy crap,” Alvin said. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie just scraped her chair back and took her bowl to the sink. Then she went to the coat closet in the hallway, banging the door open, looking furious. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin and I finished our cereal and hurried to catch up. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We threw on our jackets, grabbed our lunch boxes and ran out the door and across the porch. We trotted down the driveway, past the barn.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The sun was coming up over the trees, but it was still cold. We’d had a false spring—in like a lamb—but  then winter had come back crackling cold with sheets of ice forming along the banks of the river. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Our breath billowed as we walked down to the River Road. We piled our gear by the mailbox and stuffed our hands into our pockets and stomped our feet to stay warm. All the while we looked at each other as if to say "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I can’t believe it! ")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then Alvin said, “You know, we’ve actually got nobody to blame but ourselves.” He said this in the "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I’m-the-grown-up ")]), _vm._v("voice Julie and I both hated, but I knew he had a point.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How so?” Standing there in the cold, strands of blonde hair trailing out from under her knitted cap, still stiff with anger, Julie looked as pretty as our mother. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We shouldn’t have been so nice to him.” Alvin kicked at the foot of the new snowbank. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You and Cal, you mean.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You were just as bad.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Like heck I was!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin was right, though: We were all guilty. None of us had liked Pike from the start, but we’d pretended to because he was our mother’s new boss and she needed all the help she could get. So we said “Hello, Mr. Pike!” when he came around, and when he said “Hello, you termites” back, Alvin and I would fake laughter, and even Julie would pretend to smile. And we never let on that we saw through him; that we’d caught him hiding his real, mean face behind phony smiles. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The bus came rattling down the road then. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We grabbed our stuff as it came to a stop in front of our driveway. Mabel Morrison—the only bus driver we’d ever known—cranked the door open and said, “Here’s the Shaw tribe!” in the cheery voice she’d used since our father’s accident. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We weren’t in any mood to respond, and trudged past her single file down the gritty aisle. Alvin and I took one of the hard-springy seats—no matter how we were getting along, we always sat together—and Julie joined Becky O’Dell, who lived downriver and always boarded before us. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I heard Julie whispering her outrage, but Alvin and I didn’t speak. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Mabel ground the bus’s gears and we hugged ourselves against the chill and looked out the window at the icy river as we jostled up the road toward town.")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Eleven")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-12"
    }
  }, [_vm._v("Baxter, Late Winter, 1965")]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-4"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("I shoved Billy White at recess that day and when he fell he scraped his knee and burst into tears. The principal used it as an excuse to sit me down with the guidance counselor again—lanky Mrs. Coffin—and she kept me occupied the rest of the afternoon, answering questions about my family and how we were coping with my father’s “absence,” or sitting silently at her desk while I declined to answer a particular question, or listening to tapes other guidance counselors had made about handling grieving children. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So I didn’t get another chance to talk to Alvin about Pike until we were in line for the bus. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Okay,” he said then, “what can we do?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We decided on the ride home that first of all, we should stop pretending we liked Pike, so our mother would notice and maybe reconsider. (“It’s a woman’s prerogative to change her mind” was one of her favorite sayings.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("As soon as we got off the bus we told Julie what we’d decided, and it turned out she’d already come to the same conclusion after talking it over with Becky O’Dell. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We pinkie-shook on it on the porch before going inside, where our mother—unemployed again—was busy peeling potatoes—"), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("snick, snick—")]), _vm._v("into the sink. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hello, children,” she said. “Your snack’s on the table.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was probably too preoccupied to notice any signs of insurrection that might have shown on our faces, but we ate fast anyway and got the hell out of there. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We were watching TV when we heard Pike in the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No chickening out,” Julie said, and when Pike came into the living room and said, “Hello, you termites!” he was met with an uneasy silence, instead of the usual phony greetings. It was scary to do this, and I held my breath as the silence thickened in the room.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What’s the matter?” Pike said. “Cat got your tongues?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When we still didn’t speak, he walked in front of us, peering at our faces, and then squinted at the television. "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Rocky and Bullwinkle Show")]), _vm._v(" was on, and he snorted and said, “That stuff will rot your brains,” and lumbered on back to the kitchen. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We gave each other proud, anxious looks. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When our mother called “Supper’s ready!” an hour later, we squared our shoulders and went into the dining room, where we’d only ever eaten before on holidays. Pike was parked at the head of the table. Alvin and I sat to his left, with Julie across from us. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Our mother had cooked a chicken, and she brought a platter of sliced white meat, thighs and drumsticks in and put it in the middle of the table with the other serving dishes, taking the chair beside Julie. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike asked us to bow our heads, which was something new. We’d always gone to church on Sunday, like everybody else in Baxter, but had never been overtly religious at home, while he was one of those people who make a point out of showing how devout they are.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He mumbled one of those "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Lord, we thank thee for thy bounty")]), _vm._v(" prayers, and my mother said, “Amen,” and then Pike rubbed his hands together and grinned. I can see him now, wearing a white shirt with the sleeves rolled up on his hairy forearms. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All right, troops!” he said. “Let’s dig in!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We didn’t respond, and he gave us another speculative look. But then he shrugged and reached for a slice of white meat and a helping of mashed potatoes. He put a slab of butter on the potatoes and a heap of peas next to the potatoes, then passed the peas to Alvin. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We took silent turns with the various serving dishes. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("While I was ladling peas onto my plate I felt Pike staring. I looked up and he was chewing with a lump in his cheek, watching my face. He held up a finger while he swallowed and the lump went away. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So, Cal old pal,” he said then. “What does a man do around this establishment for fun?” He raised his bottle of Budweiser, one finger around its neck, and took a slug.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t know.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I slid my eyes over to Alvin, who was into his usual routine of arranging peas atop his mashed potatoes, making a pattern of three-pea triangles. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well, what about fishing?” Pike said. “Help me out here, son. You like to go fishing, don’t you? That’s a good-looking boat out there in the barn.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s our father’s boat.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well, yeah. But a boat needs to be in the water.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I looked at my food, then back at him. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He raised one eyebrow and turned to Alvin. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All right, what about Big Al? You must like fishing, don’t you? Or hunting? You’re a Maine boy, aren’t you? All these fields, I bet there’s woodcock around.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin—who hated to be called "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Al, ")]), _vm._v("let alone "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Big Al—")]), _vm._v("said, “I don’t know, maybe,” then went back to messing with his peas and potatoes. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike looked at our mother. He rotated the beer bottle by its neck on the table, and it made a sound like a big coin settling from a spin. Then he said, “Well,” drawing it out, and turned to Julie. “What about Miss Skinny Minnie, then? Are you gonna talk to me?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie just looked at her plate. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Julia . . . ” our mother said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Never mind, Betty, I think I get the picture.” Pike looked around at us. “So that’s how it is, huh? A little uprising by the termites? A little mutiny on the "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Bounty")]), _vm._v("?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m sorry, Randy.” My mother was frowning.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike waved a hand. “Tell you what, I don’t normally have much use for rude kids, but maybe just this once we’ll let it go, seeing as how this is such a big change and all.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t know what’s gotten into them.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike waved her off again, then leaned forward, pointing at us with his fork. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s today, termites,” he said, and he was grinning, but the grin—bristly mustache, lots of teeth—was more fierce than friendly. “Today you get a pass, so get it all out of your systems.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well?” my mother said. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin mumbled something that sounded like “I guess so,” and I said, “Okay.” Julie only cleared her throat, but Pike let that go, and with a satisfied sort of grunt and a scoop-and-stuff bite of mashed potatoes, let us know that the meal should resume. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("While we were eating he told our mother he’d sold a house that morning to a customer he’d thought they’d lost after one of her botched attempts. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m glad to hear that, Randy.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then we were done, and my mother went for the apple pie she’d made earlier—she wasn’t much for baking, so this was special—and we had pie and ice cream, and then we cleared the table. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("In the kitchen Pike leaned against the stove with his hands in his pockets, watching us set everything down and our mother run hot water into the sink. Then he said, “You know what? Let’s hold off on those dishes. Everybody into the living room.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He walked off in that direction. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My mother dried her hands on a dish towel. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You heard him,” she said, and nodded toward the hallway. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("In the living room we sat on the couch and she took the high-backed chair next to us. Pike was arranging crumpled newspaper and kindling on the brick hearthstone. He built a tent over the kindling with small lengths of pine, then opened the damper and lit the paper. When it caught he put a bigger pine slab on top of the flames. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He put the screen back in place, perched on our father’s recliner, and looked at the three of us on the couch. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So let’s hash this out,” he said. “I’ll work with you guys, okay? But you have to get with the program. And you need to know this straight up: I’ve never yet lived in a house where the kids were in charge, and I’m not about to start now. Okay?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin and I nodded. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie wouldn’t look at him. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike pushed against his knees and stood. He stuck out his hand. I wasn’t brave enough not to shake, and neither was Alvin. Julie still wouldn’t look at him, though, so Pike just snatched her hand out of her lap, pumped it up and down and then set it back. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“There now,” he said. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie tucked the hand under her arm.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("That made Pike frown, but he just gave her a look, nodded at our mother, and said, “I’ll let you talk amongst yourselves,” and strode out of the room. We heard him cross the kitchen—he made the floor creak—and open the door. Then we heard the door bang shut.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The fire snapped in the fireplace and a swirl of sparks flew up the chimney. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie looked at our mother and said, “You’re really in love with "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("him")]), _vm._v("?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t be rude, Julia.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“But you are? Like you were with Daddy?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Your father and I were very young when we got married. The war had just ended, too. With Mr. Pike, it’s different. It’s more like we’re partners. We just want to make life a little easier for ourselves.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Nothing about us, her kids.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Couldn’t you do that without getting married?” Julie asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not really. Now listen to me: We all miss your father, but we should be grateful to Mr. Pike. It’s not easy for a man to start up with a new family and take on someone else’s problems.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So you’re marrying him for his money?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I thought my mother might jump up and slap her. Julie looked like she was expecting it too and didn’t care. But then our mother just stood, smoothed her dress over her hips, and walked out of the room. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We heard her go outside to the porch, and after looking at each other we walked single file around the corner, through the hallway, and into the kitchen. The light was on over the still-sudsy sink, but through the reflection in the window we could see her in the rocker, and in the gloom we saw the cigarette ember move toward her face and away.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m not living here with that . . .” Julie stopped and hugged herself. I looked at her to see what she meant, and she stared back at me.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That what?” Alvin said. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie just turned and walked out of the room. We set off after her. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("In the living room she snapped on the TV. We’d missed one of our favorite shows, thanks to Pike, but it was always possible to find something to watch. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("As the show progressed, though, I had only the sketchiest idea of what was happening to secret agent John Drake. I was too busy wondering—like Julie—how someone who was not only beautiful but had been married to our father could ever "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("join forces ")]), _vm._v("with a phony like Randy Pike. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It really didn’t make a lot of sense. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Of course, when you’re ten going on eleven and your father has died and your world has turned upside down, there’s a lot that doesn’t make any sense. ")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Twelve")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-13"
    }
  }, [_vm._v("Baxter, Spring, 1965")]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-4"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("Little John Ladleigh was our local justice of the peace, and my mother married Randy Pike at his equally small house on Water Street, where the river narrowed and turned upstream toward the old iron bridge. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike wanted a church wedding, but his minister was away on a mission, and he thought the stand-in was prissy. So they went the JOP route, with the understanding that they’d try to have a proper church ceremony after the minister returned. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ladleigh’s little parlor was packed. We kids were there, of course, and Pike’s parents and siblings, who all lived in Baxter, along with Pike’s employees, a few fellow Realtors, and other local merchants. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It could have been even more crowded, though.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My Shaw grandparents weren’t there. They’d never had much use for Pike—those jailbait rumors hadn’t helped—and didn’t feel that marrying their son’s widow made him a legitimate member of their family. So they’d stayed home in Bath.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Uncle Gus had begged off, too. He claimed he couldn’t abandon his Saturday music students, but actually, he was still embarrassed that my mother had turned down his own stammering and red-faced proposal, after she’d flunked out of job number two. (“Oh Gus,” she’d said in her merciless way, “you can barely keep the wolf from the door as it is.”) ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And my mother’s parents weren’t there. She’d been glad to get away from them and come to Maine with Jack Shaw, and they’d never really reconciled. They were old, too—my mother had been an unwelcome surprise in their late forties—and not in good-enough health to make the trip from California anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So there were plenty of missing people. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But it was still overcrowded, and with all those people so close I had to shut my eyes and breathe deeply, so as not to feel sick, and they were still shut when Ladleigh said, “Speak now or forever hold your peace.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I looked then to see if anyone would speak, but no one did, although Julie sat up straight and looked like she wanted to. So Ladleigh pronounced them man and wife, and Pike bent my mother over and kissed her. (“Ugh,” Julie whispered then, and I felt even sicker to see him handling her like that. He was so much bigger and stronger, and I saw all at once that he could do whatever he wanted with her.) Then he pulled her upright again—she did her best to smile—and grinned out at the guests, who gave them a round of applause. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When the clapping trailed off, Pike slapped his paw into Ladleigh’s hand and gave him a manly handshake that threw the little man off balance. Then he said, “Let’s hear it for the bride!” and everyone cheered, and all the noise brought the swirls back to me, and I had to shut my eyes again. (It was all coming clear to me how much things were going to change. This guy was actually coming home with us. He would be there every night, and he would be sleeping in the same bed with my mother and putting his hands on her whenever he wanted.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There was a lot of shuffling around, chairs moving and people talking. Then Alvin knocked me lightly on the head and said, “Earth to Calvin—everyone’s leaving.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Outside in the cool air off the river I felt a little better. But there was a gauntlet of people throwing rice that we had to walk through on our way out. Someone had written "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Just Married!")]), _vm._v(" in soap on the back window of Pike’s car, and there were tin cans tied to the back bumper with string that clattered as we drove off. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I hated all of it.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We kids were squeezed into the backseat. I opened my eyes just enough to watch him clap a hand on my mother’s knee and grin. We paraded slowly through town to his apartment over the real estate office to pick up a suitcase, and I wondered what my mother thought about being on display like that; it was all so contrary to how she usually liked things. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When we got back to our house—his too, now, I realized again—the driveway was full of cars and pickups, and people were drinking beer on the porch. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Somebody’s kids were swinging on the swing so hard that I thought they might break it, and I wanted to order them off but didn’t know if I had the right anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("In the kitchen it was noisy and a little rowdy. Pike’s two brothers each had a Budweiser in one hand and were trading shoulder slugs with the other, and when Pike came within reach they punched him, too, and he roared and returned the favor. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("One of them saw me watching and feinted toward me with a grin. When I flinched he laughed and messed my hair the same way Pike did when he was pretending to be playful. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I didn’t like it any better from him. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I joined Alvin and Julie, who were standing at the foot of the stairway, watching Pike give his fellow Realtors a tour of the upstairs, pointing out things that needed fixing: dings in the drywall, separated pieces of trim (which pissed me off, because I took it as criticism of my father).")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They went into the big bedroom and one of them said, “Aha, the playroom!” and there were hoots and then Pike said, “Now, boys, none of that!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Beside me Julie said again, “Ugh.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Next Pike walked everybody down to the boys’ room and tossed open the door and his cronies stuck their heads in for a look. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin whispered, “Jeezus.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They came out of our room and went to Julie’s, and when Pike opened her door, Julie hissed under her breath and stalked away toward the kitchen. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Where’s she going?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How should I know?” Alvin still had his eyes trained upstairs. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike and his gang tramped back to the stairway, and we retreated to the kitchen. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Our mother was trapped in a corner by Pike’s sister, who wore jeans and a checkered hunting shirt and was explaining how lucky our mother had been to land such a wonderful hunk of man. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Excuse me,” our mother said. “Yes, children?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’re looking for Julie,” Alvin said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh. I think she went outside.” She sounded disappointed, as if she’d been hoping we’d give her a reason to ditch the sister. But now she fell back, smiling grimly. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We grabbed our jackets and went outside. It was still cool, but the sun—which had warmed some lately—felt good on my face. I looked across our field past the old bare-limbed apple orchard to the river and saw that the ice sheets had retreated almost all the way to the shady riverbanks.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We walked down the driveway past all the vehicles, and Alvin pointed at the barn and said, “Bet she’s in there,” and we ran over to the side door, crossing a snow-patched bit of lawn. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I pulled the door shut behind us and we walked past the old box stalls to the wide drive bay. We crossed the bay to the open haymow, but Julie wasn’t there, sprawled in the loose hay, where you’d sometimes find her reading.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hayloft?” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin looked up. The hayloft was a high platform way up near the barn roof supported by huge upright timbers, and from the middle two beams, parallel and three feet apart, ran across the bay to a door high up on the wall. My father had told us that was where the conveyer used to go that moved bales back and forth, but the flooring and the conveyer were both long gone.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Go check it out,” I said. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why don’t you?” Alvin smirked, because it was something he had over me. I’d fallen out of a pine tree when I was five, and it had taken a week for the headaches to go away. I’d been timid about heights ever since. That didn’t stop me from playing in the hayloft, but I wasn’t anxious to climb up that ladder if I didn’t have to. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When I didn’t say anything, he laughed and started up the ladder. But he stopped a couple of rungs up and looked back at me. I’d heard it, too: a rustling, as the feral cats that lived in the barn ran off to hide. We knew that meant Julie couldn’t have gone up, because they’d have already hidden. (The cats had come with the house, and our father had never had the heart to get rid of them, not even when they stalked the swallows. He claimed they kept the barn rat-free, which was worth the occasional dead bird.) ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He jumped down and we looked around again. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“There she is.” Alvin pointed toward our father’s boat—a twelve-foot Leavens Brothers, sitting on its aluminum trailer—where I could see Julie sitting on the middle seat. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We walked over. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie had on our father’s old fly-fishing hat with the floppy brim and the dry flies stuck into the band. Her hair fell down out of the hat onto her shoulders, and she had his pipe in her mouth and one of his paperbacks cradled against her heart. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She’d been crying; her cheeks were shiny. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When we came up she took the pipe out of her mouth, held the book up, and said, “This is where he stopped reading.” It was a Heinlein book—"), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Stranger in a Strange Land")]), _vm._v("—which I hadn’t read, although I wanted to now. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He was reading these words.” Julie hugged the book again, and the sorrow in her voice blossomed in my own skull. Then she broke down, and I didn’t know what to do except climb into the boat with her. Alvin did, too, and we sat silently in the bow (him) and stern (me)—slowly slipping down to sprawl against the gunnels—until she sniffled and laughed and said, “Remember the alligator in the toilet?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We all laughed, remembering when our mother, in the act of sitting, had looked down to see a rubber gator googling up at her and had let out a scream of terror, and how it had taken her a week to speak to our father again. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We took turns telling other stories. It was a huge relief to talk about him with no one else around, and once we got started we didn’t want to stop. It felt almost like he was back, and we were safe again. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But then we had to stop, because the double doors rattled suddenly, then squealed back on their rollers, and in the harsh bright sunlight our new stepfather came swaggering in with his cronies to show off his newly acquired barn. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text _idGenParaOverride-1"
  }, [_vm._v("“The bones are still pretty good,” he told them as they stepped inside, “but she needs about ten coats of paint.”")]), _vm._v(" "), _c('p', {
    staticClass: "parts-head"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v("STILL ON"), _c('br'), _vm._v("THE WAGON")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Thirteen")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-14"
    }
  }, [_vm._v("Tampa, 1995")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("I make it back to the Dearborne Trailer Park around one a.m., and drag my weary ass down the center lane—past beat-up, chevron-spaced trailers—to the far end, where my seedy little home sits next to the scrub brush. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I try to walk quietly, thinking of sleeping kids, but I’m not sure it really matters anymore. Their trailer still has that empty feel, and I think again that they might have moved on, which makes me wonder what their new home might be like. I hope it gets better for them instead of worse. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At the same time, though, I wish they were still around, because I’ll miss doing magic tricks for them. (I was working on a new one that involved moving a cotton ball mysteriously through a stack of paper cups.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But then I remember I’m not going to be around either, because I’ve decided I’m going back to Maine, and since I don’t want to pay rent while I’m away, I’m going to have to let my little tin paradise go. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Inside I slide the cornet case against the wall and flop down on the fold-out. Tired as I am I’m not ready to sleep, so I lie there trying to figure out what I have to do to get my ducks in a row before I leave. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It’s not that much: settle with my landlord, let El Gordo know and talk to my probation officer. Go to Goodwill and drop off paperbacks, my old portable typewriter, pots and pans, extra clothes, see if I can pick up some kind of a travel bag. (My father’s old navy duffel is still in New York, possibly at the apartment of a waitress I’d met at the Blue Note.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So only a day or two. Then I’ll take an overnight Greyhound to Portland. I’ll sleep on the way, go straight to Maine Medical, see what’s happening with Uncle Gus and when the time is right, call Alvin for a ride back to the old homestead. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Or maybe not; I’m not sure I want to be trapped in a car with Alvin for an hour, while he tries to get “caught up” on my recent history. Alvin can be relentless, and I do have options—have spent enough time on the road to consider myself a master hitchhiker, for one thing.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But I’ll get home somehow. I can’t go to Maine and not go home. How long I stay will depend on how many ghosts are around, and how bothersome they get. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Because I know there’ll be ghosts. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I hit my little tin bathroom, then brush my teeth. The tingle in my lips reminds me that I played pretty well tonight, and that gets me thinking again about my new piece of music.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I take the horn and stick my fingers in the bell to mute it, not expecting much, but open to anything. Because sometimes if you take yourself by surprise and just start playing, it gives you a different angle. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I sit on the fold-out, aim the horn down between my knees, and play, cruising quietly into what I already have, swinging up to where I left off, hearing piano chords (in Red’s rolling style) in the background. Then I jump to a place that works as far as scale and key, but just feels too ordinary. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I try something else, and that doesn’t work either.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But I keep trying, and then something nudges me just a half-step modal, and that leads me in a direction I’m not expecting, and I go out there a ways and manage to find my way back, and brother, when I do, it raises the hair on my neck. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I hold still a moment, feeling it. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I play it again and it still moves me, and once more, and this time the name drops into view. It comes to me about two bars past that new half-step departure: pale blue letters splashed across a blonde contour that is the shape of everything I know about this piece so far. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Blue Summer”"), _c('span', {
    staticClass: "CharOverride-3"
  }), _vm._v("is the name, and as I take that half step once more, it gets darker and more settled, and the shape curves around on itself and then snakes back through, and I’m past the new part and back to the melody. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It gets me all the way up to the coda before I’m stuck again. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I play it a couple more times and I’m still stuck there so I give it a rest. I don’t write anything down, trusting the shape of it, trusting that if any of it does happen to fall away, it’ll be because it needed to. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When the rapping comes on my door and I check my watch, I’m amazed to find that it is three-thirty in the morning. Suddenly, then, I feel very sleepy. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I cradle the Olds and wait. The knocking gets louder and more rhythmic, someone pattering with the knuckles of both hands, and I wait for them to wear themselves out and leave, so I can lie down and let “Blue Summer”"), _c('span', {
    staticClass: "CharOverride-3"
  }), _vm._v("carry me off. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then I hear, “Yo, Calvin!” and another thump, and I realize it’s Kincaid, and I nearly shuffle over to open the door just so I can see if Celeste Boucher is with him. But I really don’t have the energy. He’ll have a bottle with him and I don’t want to be tested. I’m still on the wagon and I want to stay there, and I want to take “Blue Summer” to bed. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So I stay put, and eventually Kincaid gives up and leaves; I hear the doors slam on his Supra and his tires squawk on the pavement as he drives off. ")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Fourteen")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-15"
    }
  }, [_vm._v("Tampa, 1995")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("It’s nearly 4:30 a.m. when I finally shut off the lights and lie down on my little bed. And tired as I feel, now that I’m ready to call it a day, I wonder if I’ll be able to. Sometimes the more tired you feel, the harder it is to get to sleep. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But I need to at least rest, so I stretch out under my old green blanket, figuring to just lie still and see what happens. Eventually the trailer park will come alive, and if I’m still awake by then, I figure I’ll give up and roll out of bed and see if I have the energy to start on my errands. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Turns out I shouldn’t have worried. I guess the long day caught up with me, because as soon as I put my head down I’m dead to the world. And I stay that way, right through the morning, and might have slept even longer if a neighbor didn’t decide to goose his backfiring jalopy just outside my door. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The racket brings me back, but not all the way. You know how it is when you’re jolted out of a deep sleep. I don’t quite know where I am, because I’ve been dreaming about home—I’m sure “Blue Summer” took me there—and that still feels real, and for the moment I can’t reconcile it with either the backfiring car or the cramped space around me. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I’m not in my bedroom, or anywhere else in the farmhouse, which doesn’t make sense, because I was about to sneak out and make a dash to the barn, where Julie was waiting. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I was plotting how to get there without alerting Pike, so he wouldn’t trail after me and give us a hard time (one of his main sources of recreation). Only just now I can’t figure out which way to go. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The doorway to the cellar seems to be missing, so I can’t steal out that way. And there’s no side door that lets you sneak between two blue spruce trees and sprint—like a soldier running for cover—for the barn’s side door. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Everything is different, and the damn noisy car is making it hard to think, and finally I kneel up on the bed and look out the window. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It’s overcast and gray. Everything is paved, and there’s no river, and a battered old Ford is stopped at a cross lane, trying not to stall, smoke roiling up from its exhaust. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Slowly, I come to recognize the trailer park, and the Ford as belonging to the double-wide three spots away, and as soon as that happens my head clears as if a damper has been opened. I’m back in the here and now.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The Ford revs one last time and sputters down the lane, and when it turns onto Dearborne I sink down away from the window. It hurts to be yanked back into the real world, where people you just dreamed about are gone all over again. It hurts to be this stumble-bum fool and not the kid in my dream, even if the kid in the dream had plenty of his own pain. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It gets worse as I sit there, a deep, lonesome ache, and I think how I’d give anything to be able to scramble out to that barn, to slip in through the side door past the cow stalls and climb (timidly) up to the hayloft, where Julie would be sitting on an old bale of hay, eyes shining in the dim light. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But unfortunately I’m all the way awake now, and I realize there are thirty years and far too many troubles between me and any such possibility. ")]), _vm._v(" "), _c('p', {
    staticClass: "parts-head"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _vm._v("PRINCESSES"), _c('br'), _vm._v("DON’T CRY")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Fifteen")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-16"
    }
  }, [_vm._v("Baxter, Spring, 1966")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("That wasn’t the first time I dreamed about Julie and the barn. Not by a long shot. And when I did, it wasn’t unusual for Pike to stick his ugly nose into the picture. After all, he was the reason we started hiding out there in the first place, because he wouldn’t leave Julie alone. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("See, Julie steadfastly refused to accept Pike as part of the family, and he couldn’t handle it. Everybody else was on board to some degree—my mother "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("had")]), _vm._v(" to pretend he was all right, and Alvin proved to be pretty flexible, and once the whole "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("joining forces ")]), _vm._v("thing was a done deal, I have to admit to taking the path of least resistance—but that didn’t matter, because in Pike’s world, things had to be unanimous. So when he became convinced that Julie wouldn’t warm up on her own, it only followed that he’d try to make it happen. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At first this was only creepy, because he thought he could charm her into changing her mind. He’d sit down in the living room while she was practicing and nod his head or snap his fingers (off-beat, of course). We’d be getting ready to head outside for the bus and he’d make some inappropriate remark about how nice she looked (“The boys are gonna like that little dress!”). He’d trap her into conversations about how school was going, or what she might be reading (“Nancy Drew, huh? I used to read those Tom Swift books when I was a kid!”), and he’d lean close to pester her at the table: “Can I reach you some more peas, sweetheart?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Sometimes he’d put his arm around her and walk her from one room to another, or take her by the shoulders and jostle her lightly, as if to jolly her out of her “mood.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie hated all of this, of course, and would shrink away from him, and dodge him when she could, and in general make it obvious that she wanted to be left alone. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But Pike wasn’t someone who could take a hint. And our mother was no help; she maintained that if Julie would only meet him halfway, everything would work itself out. So things went on this way, with Pike getting more and more “charming,” and Julie, more and more resistant, and then one day he crossed the line and blew everything up. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I remember it was early spring, and Pike had been living with us for nearly a year. The bus had dropped us off after school and we’d come kicking up the driveway through wet, brown leaves that the retreating snow had left behind. We’d walked into the kitchen to find Pike waiting, obviously with some new angle concerning Julie from the way he jumped up from the table—where he’d been sitting with our mother—and took my sister by the arm. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Have I got a deal for you!” he said, and launched into this “amazing” idea he’d had to have her play the piano at the open house he was planning for the real estate office that coming Saturday. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’re gonna have hors d’oeuvres and all that, and I’m gonna have an upright brought in so you can play some of that longhair stuff.” (It wasn’t really longhair that Julie loved best, but forties and fifties standards, the stuff my father used to play, but Pike didn’t know the difference.) “Give the old place some class, right? So what do you say?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He turned her loose and stood there beaming. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie rubbed her arm, said, “No thank you,” and headed for the stairs, walking like someone who doesn’t quite dare to run. But maybe she should have run, because before she made it out of the room Pike had taken three long steps and cut her off. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh no you don’t,” he said, grinning as if they were playing some sort of consensual game. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They stood looking at each other, and then Julie made a move to slip past him, and Pike—amazingly—hooked a shoulder into her midsection, grabbed her across the bottom and hoisted her up. Then he carried her right back to the table and set her down, dusting his hands and saying, “Don’t think you’re getting out of it that easy, sweetheart!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie yanked her dress back into place. Her face was bright red, and she looked beseechingly at our mother. But when all our mother did was say, “Oh, Randy, now you’ve embarrassed her,” she cried out wordlessly and bolted from the room. We heard her running up the stairs, and then her door slamming shut. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike looked at our mother. “What’s her problem?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You shouldn’t pick her up like that, Randy.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Like what?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Like she’s a little kid.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("is ")]), _vm._v("a little kid.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She’s almost fifteen now. She’s a young lady.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Give me a break.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I know you mean well . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What’s that supposed to mean?” Pike said. Then he waved a hand and said, “Forget it,” and yanked the door open and lumbered outside. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Our mother sighed. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin looked at me and shrugged as if to say "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The show’s over. ")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Come on,” he said, and headed for the doorway. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("In the living room we sat down on the sofa and I said, “Jeez, he picked her up like a sack of potatoes.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, he’s just not used to having kids.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s no excuse.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“According to Mum it is.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin sounded like he believed her. But he’d been thawing toward Pike, had even gone down to the river with him to try out a batch of new lures once the ice went out of the river. I thought he’d made up his mind—in his calculating way—to become the favorite stepson. (Which was fine with me at the time—I certainly didn’t want the honor—but which before long would only help to make Pike a more-confident tyrant.) ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We sat on the sofa and pretty soon he was watching the tube like an addict, with his mouth open. I couldn’t settle down, though, because no matter what Alvin said, I knew something bad had happened, and didn’t have any idea what to do about it. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I didn’t know what to do later, either, when after a few weeks Pike gave up trying to win Julie over and switched instead to showing her just who was boss. This was a mean and deliberate change that Alvin’s double cross and our mother’s willful blindness helped make possible. It freed up the truly ugly side of Pike’s nature, and brought a sense of dread into our house that you could feel the way you feel electricity in the air. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike had basically declared war on my sister. But he maintained the phony cheer, pretending that he was just using humor like anyone might if they were at the end of their rope with a recalcitrant child. (This allowed our mother to keep pretending that everything was hunky-dory.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He started calling her Princess instead of sweetheart, and merrily vetoing overnights at Becky O’Dell’s, and sending her outside “for some fresh air” when she wanted to practice. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Sometimes he’d make a point out of fondling our father’s personal property—golf clubs or guns, the boat, his fishing gear—knowing how much that would bother her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“This is one sweet rifle,” he said one day, bringing Dad’s .30-30 out to where Julie and I were reading on the porch swing. “Bambi’s in trouble now!” He levered it, sighted on a squirrel, and dry-fired (something our father always told us never to do, because it wore down the mechanism). Then he raised his eyebrows and grinned at us.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He’d “tease” (badger) her about how well she was doing her chores. One such chore was washing the dishes, and on another day I was spying from the hallway while he loomed over her and examined every plate and glass as she finished washing them, setting many of them back in the dishwater and saying, “That one’s no good,” or “Nope, still dirty,” until it was finally too much and she started to cry, which had obviously been his intent from the beginning. It was awful to watch and made me want to punch him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Come on, now,” he said. “Princesses don’t cry.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Which made her cry harder, and when she couldn’t stop, it gave him an excuse to take her by the arm, turn her toward the doorway, and march her out of the kitchen. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Go on up to your room,” he said, releasing her at the foot of the stairs. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He stood with his hands on his hips watching her make her way up.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When the coast was clear—Pike had gone outside—I ran upstairs, thinking to try and comfort Julie somehow. But I didn’t, because I couldn’t figure out what to say or do. So I turned into my own room instead of hers and sat on my bunk. I stewed about Pike’s bullying for an hour. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And that night is when I finally decided to get involved. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike had gone to town for a meeting of some sort and I tracked my mother down in the basement, where she was doing the laundry. When I told her what had happened, she said, “He just wants things done right,” and kept right on pulling the wet clothes out of the washer into a basket. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was the sort of thing she always said, but I wasn’t going to let her get away with it this time.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He picks on her all the time now.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, I wouldn’t call that picking on her.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well, I would.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He’s tried and tried to be nice to that girl.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He just pretends to be nice.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why would he pretend?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“To fool you.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She didn’t like that, and stopped with the clothes. “I think that’s quite enough, Cal.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You have to do something.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You go on back upstairs.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t tell me no, Calvin Shaw.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She wasn’t going to listen any more than she ever did, and I glared at her, drew my foot back, and kicked the side of the washing machine. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She looked open-mouthed at me. “What has gotten into you?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nothing!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You get upstairs or I’m calling your stepfather right now. Then he’ll come home and you can take it up with him.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We stared at each other, and I was going to cry if I didn’t do something, so I whirled away and stomped back up the stairs. I kicked the door shut, good and loud, so she’d be sure to hear. It was weak, though, because what I seriously wanted to do was kick her, for choosing Pike over Julie.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I went looking for Julie. She wasn’t in her room. I checked the living room, where Alvin was watching a soap opera. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Where’s Julie?” I said, and when he just looked at me and said, “How should I know,” I went out onto the porch and found her in the swing, sitting with her legs tucked under. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was holding a book but not reading, just staring out at the yard. When I shut the kitchen door she looked at me, and when I walked toward her she moved over. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I sat down and pushed off against the floorboards to get us moving, and while we rocked I told her about complaining to our mother, and how far it had gotten me. I wanted her to know I was on her side.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie’s eyes were shiny in the low light. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t bother, Cal,” she said, and there was a hitch in her voice. “She’ll never listen.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She doesn’t care about us anymore.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She’s still our mother.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She’s Mrs. Pike now, and that’s all she wants to be.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We rocked quietly for a minute or two.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Then who’s going to help?” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She looked across the yard at the river. “Nobody.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Maybe Nanny and Grampa Shaw might.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are you going to walk down to Bath?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How about Uncle Gus, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She laughed bitterly. “You know he’s scared of Pike.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What are we gonna do then?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nothing. They don’t let kids do anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We have to do something.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We can grow up,” she said, and her eyes narrowed as if she were looking three or four years down the road, when she’d be old enough to do what she wanted. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I didn’t know what else to say. I was still upset, but proud, too, that she’d spoken as if we were in it together. It was the start of us getting closer. Always before she’d been just an older sister—three years was a lot—and someone I admired from a distance. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie opened her book: a Nancy Drew. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I kicked at the floorboards, and we swung and she read and the chains creaked. I looked up at where they hung on hooks from the porch ceiling. Then the eaves with their old phoebe nests caught my eye.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The eaves were like little cubbies at the end of the slanted porch joists, and phoebes were always trying to build nests there, but it never seemed to work out. Something always scared them off or killed them. I could see three of the unfinished nests now, tucked sadly into the corners. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I sat with Julie until the sun dropped below the trees and it cooled off. Then I hopped off the swing and Julie did too and we went back into the house. She set off up the stairs for her room, but I headed for the piano. Saying Uncle Gus’s name had reminded me that I had to practice. It was Saturday, and we had lessons tomorrow, and I hadn’t put in the time I should have during the week. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I liked lesson day with Uncle Gus, and with everything going on in our house, it would feel like an escape to go there. Although I was never much for practicing (until I took up the trumpet, anyway), I wanted to make sure I held up my end of the bargain now, so nobody would decide it should end. ")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Sixteen")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-17"
    }
  }, [_vm._v("Baxter, Spring, 1966")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("Uncle Gus’s studio was in the basement of his little ranch house. Pike would drop us off there on the way back from church—he insisted the whole family go and listen to the Word of God—and after our lessons we would walk home along the River Road. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike would park in front of Uncle Gus’s one-car garage and say “Out you go.” He didn’t really like that we took lessons there and was always churlish about dropping us off. I thought it was because Uncle Gus had been my father’s best friend, and was a living reminder of our life before Pike showed up. But the lessons were free, and he hadn’t come up with a plausible reason to stop us yet. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We’d jump out and walk in our church clothes to the side door with its little porch. Inside, Uncle Gus would be making coffee, listening to jazz on the stereo system he had set up on the credenza in his living room. (The stereo was one of his few extravagances, another being a Martin Committee trumpet like the one his hero Clark Terry played.) ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Go on down,” he’d say. “Be right with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He’d divided the basement into two sections—one with the furnace and water heater, and one he’d finished with that fake-pine paneling that everyone used back then, and by laying down shag carpeting. There was an easy chair on one side, adjacent to the piano, where he sat with his coffee and cigarette. The only natural light came from narrow cellar windows, so he’d added a couple of fluorescent fixtures, one at each end.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Across from his chair were three student-type desks he’d salvaged from somewhere, and at the far end of the room were his other instruments on stands—trumpet, trombone, saxophone, clarinet—and a cabinet where he kept supplies of music books, reeds, and mouthpieces. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Some of the wall panels weren’t flush, and he hadn’t put a mopboard down to hide the carpet edges, and you could tell a professional hadn’t put in the drop ceiling (which was yellowed above his chair from cigarette smoke), but I thought it was a fine room anyway, because it was all about music. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Uncle Gus would start off with our homework. But he wasn’t intense about it, and there were no real consequences if you hadn’t studied and practiced. (If I hadn’t studied, I should say; Alvin always had his done, and Julie didn’t have to study. Uncle Gus would look sadly at me when I was unprepared, would say something like “I don’t want you to work on the scales for me, Cal, I want you to work on them for "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("you")]), _vm._v(",” and I would feel guilty and do better for the next week or two.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Next, we’d take turns playing. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I always led off, then Alvin would have a go, and finally Julie would finish. Uncle Gus liked saving her for last, because while I had some keyboard talent and Alvin wasn’t bad, Julie was amazing. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She played elegantly, with her hands moving gracefully up and down, as if she also made ethereal music in the space above the keys. (Sometimes they would linger there until you would think she couldn’t possibly get them back to the keys in time, but she always managed.) ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Young lady,” Uncle Gus would say, “you have a gift.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("After we played he would discuss how we’d done, and then would stub out his cigarette and go to the piano and play our assignments himself, for clarity. (He was a trumpeter, but always said he could get by with any instrument that didn’t have strings. I thought that he did much better than “get by” on the piano, though; he was actually pretty good.) Then he would set the cover down over the keys and the lesson would be over. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We’d go upstairs and he would drive us home if it was raining or snowing, but otherwise nobody thought anything of us hiking that couple of miles back to the house. We’d walk on the river side, where there was a well-trod path through the tall pines. We’d take our time and talk about the lesson and maybe make affectionate fun of Uncle Gus’s size or the way he talked, and we’d laugh and all feel pretty close walking along the river, even Alvin. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But that feeling of normalcy, the sense of respite we took from Uncle Gus’s basement, only lasted until we passed the Old Settlers Cemetery, which was a cluster of vestigial gravestones from the colonial days in a pine grove, set off a few yards toward the water. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The cemetery was our halfway point, and meant we’d be home soon. That always put a damper on our high spirits. I remember we’d walk more slowly, as if to hold on to the good feeling as long as possible. But it wasn’t as easy to talk and laugh, because we knew that when we got home, nothing would have changed: Pike would still pick on Julie; Alvin and my mother would still pretend everything was fine; Julie would resume her role as the unreasonably stubborn holdout against family unity. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And as for me? ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I was in limbo for a while—taking that path of least resistance—but after my mother ratted me out about talking behind Pike’s back, I quickly joined Julie on the official shit list.")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Seventeen")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-18"
    }
  }, [_vm._v("Baxter, Summer, 1966")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("Pike didn’t waste any time confronting me. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He came into the living room, took me by the arm and hoisted me off the sofa, and then marched me out onto the porch. He pulled the kitchen door shut with a bang, held the screen door open with a foot while he swung me out of the way, and let it slap shut behind us. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Still holding me by the arm, he said, “So you’ve been sticking your nose in where it doesn’t belong.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I hated my mother for betraying me. “She’s my sister.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So what?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So stop picking on her!” I yelled this at him, then wished I hadn’t, because he squeezed my arm, hard, and brought his face down so close that I could smell his sour breath. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You really want to start up with me?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There was a meanness always lurking in Pike, and sometimes you could feel it bubbling up, like I did now. It wasn’t something you wanted to trigger. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re damn right you don’t.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He held me there, daring me to say something else, but I’d used up my small store of courage and kept my mouth shut until he laughed his nasty laugh and shook me loose. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Afterwards I joined Julie in doing my best to avoid him. That worked sometimes, but not if he’d come looking for you because he felt like pushing somebody around. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He liked stiff-fingered shoves to get you moving, and taking you by the arm to walk you to your next chore. And there were always plenty of chores. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There were dirty floors, dusty corners, and smudged windows; grass that needed mowing and leaves to rake; and as long as you had the rake out, there was a driveway to smooth, and there was this, and there was that. And he was always deceitfully cheerful about it, which let our mother ignore the underlying bullying. (I was convinced by now that she would always be on his side, and you can’t imagine how desolate that made me feel; or maybe you can.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Sometimes Pike would have a red-letter day, when he found a way to harass both Julie and me at the same time. I remember one Saturday when we were sitting together on the porch swing reading (she was rereading her all time favorite: "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Wind in the Willows")]), _vm._v("; I had one of Dad’s mythology books). We’d finished our chores and Pike had gone golfing—Dad’s clubs rattling in the back of his pickup—and we’d thought we were in the clear.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But then he came back down the River Road, turned into the driveway, and skidded to a stop in front of the house, raising dust that drifted up onto the porch. He’d forgotten something—his wallet, maybe—and had had to about-face, and he wasn’t happy about it. But when he climbed out of the pickup and saw us there—still swinging, books in our indolent laps, undeserved guilt on our faces—that displeasure gave way to a sort of heartless joy that you could easily read in his face.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He stood beside the pickup, big as a grizzly, golf polo stretched tight across his chest, and we stopped rocking and the swing swung shorter and then halted. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Time on your hands, huh?” Pike crossed his arms and thought for a moment. Then he gave us one of his narrow-eyed smiles and pointed with his thumb over his shoulder. “Come with me.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He set off down the driveway. Then he called out: “Snap to it, termites!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We slid off the swing and walked after him. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At the barn he shoved the double-door back and disappeared inside. We got there in time to see him lifting the boat trailer by its hitch. He leaned backwards, the muscles in his arms flexing, and slowly got the trailer moving. Then, taking quick little backward steps, he pulled it outside. He dropped the hitch and went back for the hose that was always coiled next to the spigot by the cow stalls. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Playing the hose out he walked back, then returned for a bucket and sponge and the bottle of vinegar/detergent mix left over from our father’s last season with the boat. He set the bucket and bottle down on the grass in front of us. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“There,” he said. “Now you’re in business. Let’s see how clean you can get this battleship.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He picked up the end of the hose and held it out to me. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why do we have to clean it?” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike smiled, leaned forward, and tapped me on the head with the brass fitting on the end of the hose. “Because I’m telling you to.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I wanted to hit him back, and he could tell; he took a quick look at the house, then tapped me again. This time he hit a soft spot and I wanted so much to slug him in the mouth, but I didn’t dare, so I just stood there and tried not to blink, because then he’d know my eyes were filling. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Stop it,” Julie said. “We’ll do it.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike grinned and handed her the hose. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I knew I could count on you, Princess!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then he went marching back up the driveway. He climbed inside his pickup, turned around on the grass, and drove back, still grinning out the window at us. He swung onto the River Road and headed off fast. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I rubbed my head. “Jerk!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Double jerk!” Julie said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She went into the barn, turned on the water, then came back and dribbled some of the cleaner into the bucket and splashed water in from the hose. She dipped the sponge and got to work wiping the boat’s hull. When she finished a section, I jetted it clean with a thumb over the hose. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We’d been working for a half-hour when I spotted Alvin sitting on the porch steps, his glasses glinting in the sunlight. When he saw me looking he got up and started down the driveway, hands in his chino pockets. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He came up and stood beside the boat. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Join right in,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thanks just the same.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie reached the stern and wiped that down and moved around to the other side. I followed with the hose, and it wasn’t long before Alvin walked around to join us. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All right, I’ll take a turn.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie gave him the sponge and sat down on the wet grass, flexing her right arm. Alvin knelt on the weedy old hay-wagon tracks and started scrubbing in this wide-sweeping, showy way that he obviously thought was much better than what she’d been doing. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("With the two of them switching off, and me following with the hose, it went faster. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then Becky O’Dell came up the driveway on her bicycle—she’d ridden to town—and after she dropped her bike and hobbled over to pitch in, looking like Raggedy Ann in her blue jumper with her mop of red hair, we really made some time."), _c('span', {
    staticClass: "Annotation-reference CharOverride-15"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We were done with the hull before noon and sat down on the grass to take a break. I watched Becky claw her hair back and twist it into a ponytail, which she fixed in place with a rubber band. She hated her hair and was always trying to corral it somehow. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“There!” she said when she was done.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Do you think we have to do the inside?” Julie asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Better rinse it out at least,” Alvin said. He got up and pulled the drain plug, and he and Becky—who was strong, like all the O’Dells—held the bow end of the trailer up so I could lean across the transom and hose it down, the water running out at my feet. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When it was done they let the trailer down and we stood back. It was nice to see the boat clean again. Pike and his brothers never even rinsed it; just stuck it in the barn.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How come you’re cleaning the boat, anyways?” Becky said. She was pretty in a tomboy sort of way, with her dark eyebrows and ice-blue eyes. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It wasn’t our idea,” Julie said. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Becky looked at her. “Oh.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah,” Julie said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We shut the water off and Alvin drained the hose by holding it over his head and passing it through his hands while he walked across the drive bay. Some of the water dripped out behind him, but most of it ran out the other end.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We put the hose, the bucket, and the rest of the cleaning stuff away and went back out, climbing into the boat and arranging ourselves on its two forward seats (Alvin and Julie) and aft bench. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We sat there enjoying the sun and not talking. I was thinking about my father and how he’d take us upriver to town, how he’d tie up at the town dock and lead us up the hill to Main Street. He liked to make us laugh by pretending he was a tour guide, as if Baxter were some tourist Mecca. (“Now folks, this little park bench is the very spot where in 1958 Mr. Early Blake sold his first batch of illegal clams!”) ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("After we’d been sitting in the boat for a couple of minutes, Becky, who could never still for long, said, “Hey, want to go up in the hayloft and make a fort?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Cal’s scared of the hayloft.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Shut up, Alvin.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t want to anyway,” Julie said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Want to come over to my house? I can use the outboard by myself, now.” Becky sounded proud. “We can go fishing; the mackerel are running something wicked!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Is your father home?” Julie asked. (Becky’s parents weren’t much better than ours. Her father was a lobster fisherman who didn’t like other people’s kids, and we knew if he was home he’d find some reason to say no about the boat. Then if we played a board game or something he’d hang around looking annoyed until we gave up and went home.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Becky said, “Okay, never mind.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sorry,” Julie said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s okay.” She rocked onto a hip, got a leg under her, and stood up. “I guess I’ll mosey along.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thanks for helping.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No problem!” Becky put her arms around Julie—the only kid I knew who hugged other kids like that—and looked at me as if I might be next. But I said, “Oh no you don’t,” and she stuck out her tongue and limped over to her bike. (She didn’t try with Alvin, and maybe he looked a little wistful about that, although it was hard to tell with him.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We watched her coast down the driveway and lean onto the River Road—she looked normal riding a bike—and then we started back to the house. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well, that was fun,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin said, “I guess he gets a little carried away sometimes.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You think?” Julie said. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We came up to the house. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Maybe if you tried being nicer to him.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Maybe he should try being nicer to us,” Julie said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He can be half decent.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“To you, maybe.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah, to his little pal.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Shut up, Cal.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We climbed the porch steps.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You guys can’t win against him anyway.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He can’t win against us, either.” Julie opened the screen door.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t know about that. You cleaned the boat.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Shut up.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We went into the kitchen. Our mother, at the table, sipped from her coffee cup and turned a page of the newspaper over. “Was that Rebecca O’Dell I saw helping you clean the boat?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, that was Raggedy Ann.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t be smart, Calvin.” She gave me a look that meant I shouldn’t get too big for my britches again, or she’d tell Pike. I’d had a hard time not being smart with her since the laundry-room episode.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Anyway, that was a nice thing, to help out like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Uh-huh,” Alvin said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It was nice of all of you to clean the boat.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He told us to,” Julie said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It was still a nice thing to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie looked at me. I shrugged. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We followed Alvin out of the kitchen and into the living room. He switched on the TV and we all sat on the couch. There was nothing really good on, but we sat there watching anyway until Pike came home. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We heard him in the kitchen, bragging about his golf game, and then he came hulking into the living room. You could tell he’d had a couple with the boys after his round; his cheeks always got pink when he drank. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What the hell are you termites watching, cartoons?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Uh-huh,” Alvin said. “The boat’s all done.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good,” Pike said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I went down and helped.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good for you.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike was staring at the TV. “We can do better than that garbage.” He walked over to the TV and started switching through the channels. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When Julie and I got up to leave he smiled at us over his shoulder. ")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Eighteen")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-19"
    }
  }, [_vm._v("Baxter, Fall, 1966")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("So that’s how that spring and summer went, and then suddenly it was the first Saturday in September, just a few days before school was to start again. It was Saturday the fourth, actually; I know the exact date, because it was the worst day of my life, which is really saying something. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I’ve never been able to talk it about very well, and even typing it won’t be easy, but there’s no point in setting this all down if I shy away at this point.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie and I were alone in the house for once, because Pike had taken off fishing, and our mother had gone to pick up Alvin from the school science fair, where he’d won a prize for this little electric motor he’d made out of coils of wire, a bolt, and a battery. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We were watching "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("American Bandstand ")]), _vm._v("(which Pike had banned as being sinful) and giggling while we twisted and turned on the couch, making fun of the city kids’ dance moves. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then something changed in the room and we stopped. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was Pike, standing in the doorway, sunburned and red-eyed, wearing khaki shorts and a yellow Pike Agency"), _c('span', {
    staticClass: "CharOverride-3"
  }), _vm._v("sweatshirt, with the sleeves cut off. We hadn’t heard him come in—because of the music, or because he could move very quietly when he wanted to; he liked to sneak up and see what he could catch you doing. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He just stared at us at first, then took two big steps over to the TV and snapped it off. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Garbage,” he said, and he was slurring just a bit. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He turned to see how we’d react, but Julie and I just got up from the sofa and headed for the hallway. If you didn’t make a fuss and avoided interacting, it would sometimes be all right. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But this wasn’t one of those times. I made the mistake of glancing back as we turned the corner—which narrowed Pike’s eyes and pretty much drew him after us—and then when we were both in the hallway, Julie said, “God, I hate him.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She said it quietly, but two more stealthy strides had brought Pike close enough to hear. He barged into the hallway behind us and barked, “What’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We felt his words like darts, and walked faster. But we didn’t run, because it might provoke him even more. He caught us in the kitchen, brushing me out of the way and grabbing Julie by the arm. He turned her so they were face-to-face. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Got something on your mind, Princess?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie said, “No!” and tried to pull away, but Pike wouldn’t let go. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When she kept struggling, he took her under both arms and brought her face up close, giving her a shake in the process. “I asked you a question, missy!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I couldn’t breathe, the air was so charged. I couldn’t move, either. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But then Pike shook Julie again, and I jumped him. I threw my arms around his bull neck and yanked. But scrappy as I’d become lately, I was still just a skinny boy, and it was no trouble at all for him to twist and snap his shoulders and send me stumbling across the room into the kitchen table.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I slid to the floor and tried to cry out, but the table edge had knocked the wind out of me. I was gasping and then Pike was looming over me. I kicked out and caught him on the knee, and he hopped and growled and raised his fists.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But Julie screamed, “Stop it!” and that seemed to startle him. He lowered his fists and looked at her. His eyes were still slits and his teeth were bared, but maybe he realized that he was about to do something impossible to explain away. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He looked at me and said, “You get outside, now!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I grabbed the tabletop and pulled myself up. My breath had come back in a rush, and scared as I was, I was also still looking to kick him again. He saw it in my face, and turned his hips defensively, waiting for me to try it. He was still right on the edge. But Julie saw it too and said, “Cal, don’t—please.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was the "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("please")]), _vm._v(" that got me. I thought it meant that things would be better for her if I left, and worse if I didn’t. I tried to keep an eye on Pike and look at her too, but it was hard, and then she said again, “Please, Cal.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So I said, “You better leave her alone,” and started around Pike to the door. When he just looked at me he didn’t seem so wild, and I thought that he wouldn’t shake her again. He might bully her into crying, like with the dishes, but maybe the worst was over. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At the door I turned to watch Julie walk out of the kitchen, with Pike behind her. He said, “Get up to your room and shut the door,” and then he came back into the kitchen to see what I was doing, so I went outside. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I sat on the porch swing to wait. It was a surprise to see it was still daylight, like coming out of a movie theater. I felt stunned and alone, and so helpless. I was scared and furious and didn’t know what to do with myself. I wished I’d ignored Julie and attacked Pike again, even if he’d have beaten me into a bloody pulp. Only, who knows what he might have done to Julie then. I didn’t care about myself, but that might have been worse for her. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was so hard to know anything for sure.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I pounded my fists onto my knees and stood up from the swing and walked back and forth along the porch. Then I walked down the steps and around the side of the house to where I could look up at Julie’s window. I couldn’t see into her room, and I couldn’t hear anything. I went back around the house to the porch and sat on the swing again, and a few minutes later, the door opened and Julie came out.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I jumped up. “Are you all right? What did he do?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She said, “I want to go up to the hayloft,” and set off down the steps without another word.  When I caught up I heard her breathing in little gasps and I said again, “Are you all right?” but she didn’t answer, just walked faster down the driveway.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We crossed the grass, entering the side door into the barn. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It had been bright outside, and for a moment we couldn’t see. When our eyes adjusted we crossed the drive bay past the dirty-again boat and walked over to the hayloft ladder. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie said, “Go ahead,” and I started climbing, and halfway up I heard the cats slipping away through the loose hay to hide among the bales. ")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Nineteen")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-20"
    }
  }, [_vm._v("Baxter, Fall, 1966")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("We sat on our old, saggy bales in the dusty hayloft without talking. It was warm up there. Julie had stopped gasping but looked wilted and sad. She looked like I felt. It’s completely demoralizing to have an angry man put his hands on you when you’re just a kid, and it’s even worse to have him put his hands on your sister. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie was staring at the hay door, outlined by leaking sunlight. Every now and then she’d sigh. There were dark emotions radiating out of her and billowing around the hayloft. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("After a while we heard the side door creak open and we held still, thinking he’d come after us, wondering if he’d haul himself up the ladder. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But then we recognized the uneven footsteps. “Anybody in here?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie looked at me. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was Becky O’Dell, stopping in again, but neither of us wanted to see her just then, so we stayed quiet, and after a moment we heard her leave.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Limp-thump, limp-thump")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When she shut the door it got gloomy all over again in the barn. Julie was staring at the hay door. Then she stood up and walked to the edge of the platform, stopping there and looking over the edge at the long drop to the floor. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What are you doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m going to walk it.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’d better not.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her shoulders went up and down. “I’ve done it before.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“When?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Lots of times.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Just like that she stepped onto the two parallel timbers, one foot on each, and I got very queasy in the pit of my stomach. Then she started across. There was a two-foot gap between the timbers and she had to move each foot a few inches at a time, holding her arms out for balance. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My heart squeezed in on itself. I would no more have gone out there than I would have walked a tightrope over Niagara Falls. But Julie managed to shuffle all the way across. Then she hooked her hand over a board that had been nailed across two of the studs, reached with the other hand and turned the piece-of-wood latch that held the hay door shut. She leaned back to let the door open inward, then hung herself over the doorway and looked out at the driveway, the yard, and the river. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A breeze came past her into the barn, ruffling her hair. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She looked over her shoulder at me. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What do you think you’re doing?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What I want to do.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She turned back to look out the door. Then after a minute or two she slipped her hand behind the nailed board, leaned out of the way again, and pushed the door shut. She re-latched it, turned carefully and sat down on the beam. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You better be careful!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I told you I’ve done it before.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I never saw you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You weren’t here.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie put her hands flat on the timber, took a peek over the side, then tipped her head back and tossed her head. “You wouldn’t understand, Cal.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Maybe I would.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t think so.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I sat still and didn’t say anything. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All right,” she said. “I do it because nobody can tell me not to, okay? Nobody can stop me or make me do something else.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You mean Pike?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She shut her eyes. “Anybody.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All right. Will you please come back now?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“In a minute. Turn around first and don’t look.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Just do it.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Tell me why, first.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Please, Cal?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Since she said "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("please")]), _vm._v(" I turned around. But then I cocked my head to look at her out of the corner of my eye. I saw her take something from behind another board nailed low on the studs. She put it down flat on the timber and then saw me watching and said, “Turn around, Cal!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I looked back at the stacked bales and waited. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All clear,” she said after a little while.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What were you doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Never mind.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She started back then, but not on her feet. She inched along, grabbing the edges of the beam and hunching her bottom a little ways forward.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I can walk over,” she said, with a short laugh, “but I can’t walk back.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Just be careful.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She came closer, reaching and hunching, but when she was within a few feet of me—almost close enough to lean and stretch and grab the edge of the platform—she got wobbly and had to stop. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She gripped the edges of the beam and I could see the muscles in her legs. She peeked over the side, immediately straightened and looked at me. I should have done something then, but I was waiting for her to figure it out. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I think I’m stuck.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m stuck, Cal.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Just keep doing what you were doing.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I can’t let go to do it!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What should I do?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t know.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I couldn’t think of anything. I was scared and my mind wouldn’t work. But finally I slid a little forward. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Better hurry.” Julie’s eyes were wide, now. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I crawled a little closer to the edge. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Cal, hurry up!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I grabbed the edge of the platform, stuck my head out, and pushed until I could hook my elbows over the edge beam. Then I reached as far as I could. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie made a grab for me, but our fingers barely touched and she almost fell. She hugged the beam again, hard. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I forced myself forward until I was balanced on my belly. It was terrifying. I thought if I did get ahold of her, we’d both probably fall. But I reached out anyway. I reached as far as I could and said, “Come on!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("This time I got ahold of her fingers. But they were damp, and when she started over sideways they pulled free. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie said, “Oh . . . !” and held onto the beam for another instant with just her legs. But it was only for a split second, and then time stopped, and only started again when she landed with a dull thump.")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Twenty")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-21"
    }
  }, [_vm._v("Baxter, Fall, 1966")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("I don’t remember climbing down from the hayloft. Julie was on her side on the floor with her knees bent. Her hair was spread out around her head and her eyes were closed. She was breathing in little hitches. I couldn’t think of anything to do but run for Pike. I ran to the side door of the barn and then sprinted for the house. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("In the house I yelled, “Help!” and ran upstairs. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike came out of the master bedroom. “What are you doing back inside?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Julie fell out of the hayloft!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She’s hurt!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I ran back down. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike charged down the stairs and ran through the kitchen ahead of me. When I got to the barn he was kneeling beside Julie. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He looked at me and put his hands on the floor and stood up. “I’m calling the ambulance. Stay here and don’t touch her.” His voice sounded funny because he was out of breath.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He ran back out of the barn. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I stood next to Julie, my heart squeezed small. She hadn’t moved and her eyes were still shut. She was still breathing, at least. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My head was buzzing like hornets. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike came back with a blanket, which he draped over Julie. He sat back on his heels and looked at his watch. Then he said, “How did this happen?” His voice was jumpy and strange. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I tried to tell him. When I stopped at the part where Julie got stuck, his eyes narrowed. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why didn’t you come and get me?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I was afraid to leave!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He didn’t say anything more. We just waited together, standing five feet apart, not looking at each other. The whole time I felt like puking. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Finally the ambulance came rushing down the River Road with its lights flashing. It turned up our driveway and stopped. Two men jumped out, grabbed a stretcher from the back, and brought it into the barn. The taller one put a kind hand on my shoulder as he walked past and over to Julie. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My eyes flooded at his touch; everything went blurry ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They moved around Julie, knelt, and shined a little pencil-sized flashlight into her eyes, then carefully put a brace around her neck and slowly moved her onto the stretcher. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The tall EMT held her head and neck while the other man eased her legs over. They strapped her in, picked up the stretcher at each end, and carried her out. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Wait here and tell your mother to meet us at the hospital,” Pike said as he walked after them. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They slid Julie into the back of the ambulance, and the taller man took one step up to ride with her while the other walked around to the driver’s door. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike opened the passenger-side door and got in. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The doors slammed and the flashing lights came on and then the siren. The ambulance rolled down to the end of the driveway, swung into the right lane, and accelerated off toward town. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I watched until the lights were gone, then walked up to the house and sat on the steps. The sun was low over the trees, and it was beginning to cool off. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I looked at the barn, at the apple trees, across the field to the river. It all felt different. I sat there for an hour or so, until my mother showed up. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She came up the driveway in the station wagon, and my heart shrank even more because I was going to have to tell what had happened now, and she would think it was my fault, too.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They stopped and my mother got out one side, and Alvin the other. They slammed their doors and came up the steps. Alvin had his little motor in one hand and a certificate in the other. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He held them out. “Read it and weep!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why are you sitting there?” My mother peered at my face. “What’s wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "parts-head"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v("BURGUNDY CITY")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Twenty-One")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-22"
    }
  }, [_vm._v("En Route, 1995")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("The night before I’m to leave Tampa, I try to get ahold of Rocky Kincaid to see if he can give me a ride into town. But he isn’t answering his phone, so I call El Gordo. I didn’t want to, because he got pissy when I quit. But I’m not going to hitchhike with two bags to carry and a bus to catch.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I had the phone in the trailer shut off, which means I have to walk down to the corner and use the pay phone. I feed in a quarter and wait for a rush of cars to go by and dial the number.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Airport Taxi,” Fats answers.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Emile, how’s it going?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He sucks in his breath, and I picture him behind his beat-up desk in a shiny Hawaiian shirt with his face getting blotchy red because he’s all worked up.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m a driver short on a goddamn Friday night! How do you think I’m doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m sorry about that.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well, get your ass in here and help me out.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I can’t, Fats, I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Then what the hell are you calling for?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I need a ride downtown.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Jesus,” Fats says. “You take the cake, Shaw.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t want a freebie.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Doesn’t matter, we’re all stacked up.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, I don’t need it until tomorrow.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why didn’t you say so?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His other line rings, and he puts me on hold. When he comes back he says, “Where you going tomorrow?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Greyhound station.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So you’re really leaving?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah, just like I told you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I thought you were bullshitting.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why would I do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Figured you had a drunk planned and wanted some time off.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nope, I’m still on the wagon.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“"), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Todavía hay milagros")]), _vm._v("!” His other line rings again, and he says, “Hold on.” A minute or two later he comes back and says, “So what time tomorrow?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Five-thirty.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Mother of God.” I hear him flip the page of his schedule book over. Then he says, “All right, I’ll put you in the book. But you better not no-show on me!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I wouldn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I gotta go.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hey, Emile.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Aren’t you going to wish me luck?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I can hear his other line ringing again, but he doesn’t switch over, and finally he coughs, the way he does when it’s either that or show some sort of emotion, and he says, “Listen, "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("pendejo")]), _vm._v(", just take care of yourself, okay? Try not to be stupid.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll do my best—” I say, but he’s hung up. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It’s Neal the Nazi who shows up the next morning, roaring up the aisle between the trailers and skidding to a stop in front of where I’m waiting on the stoop, bags on the grass next to me. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He heaves himself out in all his black-leather-jacketed, tattooed, studded, and bearded glory, walks back to open the trunk, and nods toward the kids’ trailer.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Where’s all your little pals?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“They’ve moved on.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I heave the duffel I found at Sal’s Army in, then stick the cornet case between it and the side of the trunk so it won’t bounce around.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Just like you,” Neal says.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He slams the trunk, walks back and falls heavily into his broken-down driver’s seat. He smooths his beard down onto his camo shirt, throws the gearshift and yanks us around in a U-turn. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We jounce down to the entrance and run the red light onto Dearborne, and as we start off I take a look back at the trailer park. It always feels strange to move on from a home, even one as shabby as this. Not that I’m all broken up about it, but I have spent part of my life here. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We charge down the road, and I watch the city ahead, all lit up by a burgundy-colored sunrise. We cruise in through the outskirts, ramp up onto the Interstate, and shoot into town. We exit before we get downtown, and at the bottom of a little hill, turn onto the Parkway. Closer to downtown the city is coming awake: people jogging, walking dogs. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Going back to the boondocks,” Neal says.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yep.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He blasts his horn at a pedestrian lollygagging across the street in front of us. The guy flips him off, and Neal laughs. “You’re in for some culture shock.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well, I grew up there.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah, but you been out in the world.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We turn out of that neighborhood and drive a couple of blocks and he lets me out at the curb in front of the stone-boxy old bus station. He takes my money, drops it into his blue cash bag, and climbs out of the car. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Neal pops the trunk and pulls my gear out, then surprises me by carrying the duffel inside while I take the instrument case. In the terminal he sits the bag down by one of the pew-like benches. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I put my case down and stick out my hand. “Thanks for the lift.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Y’all take care up there in the sticks.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He nods, then about-faces and stalks out. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I wait for him to look back and give me one of his faux salutes, but he just keeps going. So I turn away and step up to the ticket window. I pay for my ride and go back to the bench to wait. There are destination posters on the walls and a couple of homeless guys stretched out on benches with newspapers over their faces. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The bus doesn’t leave for a half-hour, and I look at the vending machines lined up against the wall, and think about coffee. But then I imagine how nasty it will likely be, and I stay put. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I hold the cornet case in my lap and wonder what the old farmhouse looks like now. I guess Pike will have kept the property up, being a Realtor and all. My stomach stirs then at the thought that soon I’ll be able to see for myself, because I can’t really go back to Maine and not stop in there. Even if it means seeing the asshole. And seeing the barn. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I hope I’m ready to see the barn, ready to feel everything that happened that day all over again. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I look down at my instrument case and fight off the urge to take the cornet out. “Blue Summer” is in my head, looking to be heard. But then a heavyset woman comes into the terminal with a young kid who’s maybe thirteen, lean and slouchy in jeans and a faded Gators sweatshirt. He gives me a sidelong glance when they walk by, and they go on up to the ticket counter. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I shut my eyes again, listen to the woman talking to the ticket agent. Her voice is low and velvety, and listening to it, I doze off, and don’t wake until they call my bus over the intercom. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At the gate, the woman and the boy are waiting. The gate stays closed, and after looking at their backs, I say, “You guys aren’t going up to Maine, too, are you?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The woman turns and smiles. “Lord, no, just to Boston.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When she speaks the kid looks over his shoulder. His eyes slide down to my cornet case. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The woman notices and says, “Georgie here plays the trumpet, too.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Is that right?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Plays in the band back home, don’t you, Georgie?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Georgie says “Yeah,” without turning. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I used to play in my school band, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Was that in Maine?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Uh-huh.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So you’re going home?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s a good thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I guess so.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She squints at me. “Well, Georgie going home is definitely a good thing.” She’s turned sideways to talk; now she puts a hand on the kid’s shoulder and says, “Gramma loves you, Georgie, you know that, but she ain’t as young as she used to be.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Uh-huh,” Georgie says.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The bus driver finally shows up: gray uniform, shiny shoes, ticket puncher hanging from his belt. He opens the gate, walks us over to the bus. We’re the only ones getting on. He unlocks the baggage compartment and puts my traveling companions’ bags inside. Then he shoves my duffel in and without straightening looks at the cornet case at my feet.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I was hoping I could keep that with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He stands up with a grunt, looks at the lady and the boy. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well, seeing how we’re not that crowded, I guess as long as nobody objects and you don’t decide to play reveille at two o’clock in the morning . . .” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll be sound asleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We don’t mind,” the heavyset lady says.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The driver nods sideways toward the bus’s steps. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Georgie and his grandmother board, and I carry the case up after them. It’s roomy and dark behind tinted windows. The driver’s military-style hat with the shiny brim and big badge sits on his seat. Georgie’s grandmother steers him into a seat and works herself in beside him, and I take the one in front of them. I slide my case under the seat in front of me and turn around. “I’m Cal Shaw.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Loretta McCarty. This is Georgie. We’re pleased to meet you, Cal.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She looks at her grandson, and he nods and says “Uh-huh,” very softly, and then looks out the window. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Kids fascinate me, especially odd kids, outsider kids—there’s a kinship I always feel—and I wonder what’s up with this one.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Pleased to meet you, too,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’re going to be riding a long way with Mr. Shaw,” Loretta says to the kid, “so we might as well be friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Uh-huh.” Georgie looks down at his hands. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He’s just shy.” Loretta smiles. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I turn around so Georgie won’t have to look at me anymore. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("About two minutes later the driver comes aboard, puts his hat on carefully, takes his seat, and levers the door shut. He picks up a clipboard and goes through his checklist. Then he puts the clipboard aside, turns to look over the cabin and finally starts the engine and backs us out of our parking spot. He shifts gears and drives out of the back lot of the bus station and onto the street.  ")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Twenty-Two")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-23"
    }
  }, [_vm._v("En Route, 1995")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("Back in Pinellas County Jail, they had a free-paperback rack at the library, donated by a local church group. I’d started rereading an old, dog-eared copy of "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Stranger in a Strange Land")]), _vm._v(" in the pokey, but hadn’t finished when I got released, so I took it home with me. And when I was packing I grabbed it to keep me company on the trip to Maine. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Now, reading it on the bus, I see in my mind’s eye my father in his recliner with his pipe and the very same book. I see him turning a page reluctantly, like he’s sorry to be done with that particular part of the story. I miss him so much it hurts. But I keep reading, and eventually I’m drawn back into Valentine Michael Smith’s story, and it keeps me occupied through Orlando and Jacksonville, but then we have a long stretch before our next stop and I fall fast asleep. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I doze right through the rest of Florida and most of Georgia, too. I don’t really wake up fully until we cross the river into Savannah. This is early afternoon and it’s raining; I can hear it on the roof. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I cock my head this way and that, my neck stiff from leaning against the window, and look at the oil derricks along the riverbanks. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I remember the paperback and pick it up off the floor, find my place, and mark it with a turned-down page. We drive into the low city and go a couple of blocks to the bus station and it’s all wet, shiny, gray stone, much bigger than the one in Tampa. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We circle the block and pull into a dock behind the building.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When our driver says “Welcome to Savannah,” and opens the door, an older couple who boarded in Orlando walk down the aisle, thank the driver and get off. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The driver turns in his seat to tell us we’ll be there for thirty minutes, and can either wait on the bus or go inside. There’s a cafeteria inside if we’re hungry, but we need to remember that the bus can’t wait for anyone who’s late coming back. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then he gets up and follows the older passengers inside. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Would you mind keeping an eye on Georgie?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I look at Loretta McCarty and the boy. They’ve been quiet—maybe dozing, too—and between my book and my dreams, I’ve sort of forgotten about them. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m going to get us something to eat,” Loretta says, “and Georgie, he doesn’t like being alone very much, so it would be wonderful if I could leave him here with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t mind if he doesn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He won’t—will you, Georgie?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He looks at his hands and shakes his head. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Can I run in and use the restroom first?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Surely.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I double-time it off the bus and find the washroom. I scrub my hands and leave the bathroom and walk around the corner up to the cafeteria, thinking about a burger. But then I decide to save my money and settle for a couple of Snickers bars. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Back on the bus Loretta thanks me again and maneuvers down the aisle. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When she’s gone I look around at Georgie. He’s sitting with his hands in his lap, staring out the window. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You doing all right?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He nods, hunches himself a little closer to the window. I can see uneasiness on his face and in the way he holds himself. There’s definitely something going on with him, something that makes him different, and knowing as much as I do about that sort of thing, I feel a bit of kinship. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She’ll be right back, don’t worry.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He looks at me, then out the window.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Want to check out the cornet?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He looks at me. “Ain’t it a trumpet?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nope, cornet.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I pull the case out from under the seat and snap it open. I take the horn from its molded bed and lean over the seat to show it to him. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Th-that’s nice—an Olds.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What do you play?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Conn.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Student horn?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He nods, his eyes on the cornet.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Go ahead.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He’s nervous about touching it, but can’t resist. I lay it in his hands and he sits back and turns it this way and that. It gleams like gold in the weak light.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Want to give it a try?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“In here?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I take the mouthpiece from its slot in the case and wipe it on my shirt and hand it over. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll keep a lookout.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He looks toward the front of the bus, then sticks the mouthpiece in. He smooshes his lips around to warm them up, then raises the cornet. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He flutters the valves, blows an open B flat, then runs a quiet little minor scale. I can tell right off that he knows what he’s doing.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Very nice.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He looks at me while he keeps playing, still very quietly. There’s pride in his eyes because not everyone can play softly. He plays the first couple bars of “America the Beautiful,”"), _c('span', {
    staticClass: "CharOverride-3"
  }), _vm._v("and I like that he can do it so quietly and still be quite pure. Then he lowers the cornet and says, “That’s what we played at the assembly.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Your first trumpet?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Second.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That doesn’t sound right.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s ’cause I can’t read music.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You play by ear?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He nods. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Chet Baker used to play by ear.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He did?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So they say.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He smiles a little. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Let me see it a minute.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He hands it over and I wipe off the mouthpiece and open the spit valve and blow a little moisture onto the floor. Then I start into “Blue Summer,” trying to be just as quiet and pure as he was. It’s still in my head all the time, and I’m glad for a chance to play it in front of someone, but I still haven’t figured out exactly how it’s supposed to end. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then Georgie whispers, “Uh-oh.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I turn to see the bus driver coming up the stairwell with a little brown bag in his hand. He glances our way and nods, sits down, and pulls out a wrapped sandwich. He peels the waxed paper away and takes an incongruously dainty bite. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I sneak the cornet back into its case, slide the case under the seat, grin at Georgie. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Close one.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah.” Softly.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What he doesn’t know won’t hurt him.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Georgie swallows a smile. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Loretta comes up the steps then with a shallow cardboard box full of sandwiches. She sidesteps down the aisle and wriggles in beside her grandson. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She gives him a look. “Now what have you been up to?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“N-n-nothing.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t kid a kidder.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Loretta looks at me. “I think you and Cal might have been up to something.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Georgie lets that sly smile show and Loretta laughs. Then she picks out a sandwich and hands it to him. They’re all wrapped in waxed paper like the driver’s. She peers at another one end-on, then holds it out to me. “I hope you like chicken salad.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You got me one?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“For watching Georgie.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He didn’t really need watching.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Georgie looks at me as he takes another bite. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All the better.” She shakes the sandwich.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thank you, then.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You are so very welcome.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I turn around and wolf my sandwich, and a little later the driver comes down the aisle, holding his clipboard. He checks us off with a nod and keeps walking and checks a couple other passengers off and leans over to punch somebody’s ticket. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then he walks back to his seat, announces over the intercom that we are on our way, next stop, Richmond. He turns the lights down and starts the engine. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When we’re moving I look behind me. Loretta smiles. Georgie has withdrawn again and is staring out the window at the lights of the bus station. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I get it completely. For a few minutes he was able to forget himself. But now the cornet’s put away and Loretta’s back and he has to remember who he is again. That’s the way it goes when you feel separate from everybody else. I don’t think it matters why. It’s just that you can never forget for long, because there’s always someone or something around to remind you. ")]), _vm._v(" "), _c('p', {
    staticClass: "parts-head"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v("WALKING BOSS")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Twenty-Three")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-24"
    }
  }, [_vm._v("Baxter, Fall, 1966")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("Not that forgetting is always a blessing, though. Sometimes it can be anything but, like when I forgot the morning after Julie died. I really did. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Looking back, I know there were reasons. (There were shrinks in the lockup, and one in particular I’d been able to talk to.) I was a kid who’d been traumatized, and who’d only slept for a couple of hours to boot—but in the moment, I didn’t understand any of that. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Nobody else had forgotten. They were all in the kitchen—my mother and Alvin at the table, Pike leaning on the counter—and when I walked in, soft-whistling a piece I’d been studying for Uncle Gus, they all stared at me in disbelief. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then it hit me and I remembered everything. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("First I remembered fighting with Pike, and then I remembered Julie falling and the hospital, and that was all I could think about. It was as if she had died all over again. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I saw her suddenly arching her back in the hospital bed, opening her eyes wide, and falling back. I heard an alarm begin to ring. Nurses and doctors came running, and we had to leave while they tried to save her, and I prayed the whole time we were in the waiting room by the nurses’ station. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But there was no miracle, and when the doctor joined us a few minutes later we could see it in his face; he didn’t have to say a word. But he said “I’m so terribly sorry” anyway, and then led us back to Julie’s room and held the door so we could walk past him and say good-bye. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike stood aside while we went to Julie in her bed. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin touched her shoulder, and I brushed the hair off her forehead. She wasn’t cold, but seemed small and lonely with the blankets and those starchy hospital sheets bunched around her. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My mother took her hand and knelt beside the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I don’t know how long we were with her. But eventually the doctor came back and spoke to Pike, who nodded and took our mother by the shoulders and eased her away from the bed. Then he looked at Alvin and me and said, “We have to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We followed them out of the room and down the corridor, past nurses who knew what had happened, but not how to speak to us about it, and we walked outside and found our car, and we waited while Pike went back to make arrangements. Then he returned and drove us away through the dark. It was a clear night, with thousands of stars low and bright in the sky, and it was silent in the car all the way back. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I remembered all that in a flash, and then, in the kitchen that morning after, I looked at my mother and said, “Oh no, Mum, I forgot. I’m sorry!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She put a hand over her mouth, jumped up and ran to the door. Alvin and Pike followed her outside, and I stood there, hating myself for being such an idiot. Then I went out onto the porch too. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m sorry!” I said again, and my voice cracked. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My mother said, “I know you are, Calvin,” and rocked her chair forward to put an arm around me. But when I tried to throw my arms around her, so that she could hold me closer, she caught them and held me off. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m sorry,” she said. “I can’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I backed away and stuck my hands in my pockets. It felt like they all wanted me to leave, so I walked down the steps and across the lawn to the field. I moved slow, hoping my mother might call me back, but she didn’t, and I walked all the way down to the apple trees by the river. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I found out later that Pike made the most of my absence by planting his own version of the tragedy in my family’s heads. According to him, I could have helped her in the hayloft, but I’d been too scared and had frozen; had even been unable to run and get him, until it was too late. He didn’t want to actually blame me, because I was just a kid, but it all could have turned out very differently if I’d fetched him in time. He might have talked her down from that beam, or even caught her when she fell. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was a calculated attempt to make sure all of the guilt and blame belonged to me. And it worked, because there was no one to tell my side of the story, and because I’d already been guilty of forgetting. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It worked also because Pike, my mother, and Alvin "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("needed")]), _vm._v(" it to work. Pike, for obvious reasons, and the other two, because they’d stood by while he’d bullied Julie and now she was gone and that would never change. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And there was one final reason why it worked. I never tried very hard to defend myself. I couldn’t, because I agreed. In my heart I knew that I’d failed Julie. I still do, even now. I can hate Pike for what he did, but there will always be a broken part of me that believes he was right—that Julie died because of me. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("That night, when Alvin looked down at me from the upper bunk and said, “Why did you have to chicken out, Cal?” in a choked voice, I couldn’t think of a single thing to say back.")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Twenty-Four")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-25"
    }
  }, [_vm._v("Baxter, Fall, 1966")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-4"
  }, [_vm._v("So I was cast adrift all over again, a little more than two years after my father had died. Only it was even worse this time, because there was no Julie to help me get by. It really wasn’t easy to be that kid. Nobody liked me anymore, and nothing I did seemed to make any difference. I tried more apologies, but they didn’t help. “Cal,” my mother finally said, “I’m sorry, but I can’t keep talking about your sister.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then I tried "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("showing")]), _vm._v(" I was sorry. You remember the movie "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Cool Hand Luke")]), _vm._v("—how they punished Lucas Jackson by making him dig a ditch and then fill it back in, over and over, until he couldn’t take it anymore? Remember how afterward he trotted around in his ankle chains, doing everything the Walking Boss wanted, like his broken little pet?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Well, I was pretty much like Lucas Jackson with my mother for a while. But it was all wasted effort. Eventually she said, “Cal, stop hovering!” and then I didn’t know what to do with myself. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I missed my sister with a stone-cold ache, and I felt like a stranger in my own home. One day I couldn’t stand it anymore and just walked out of the house and took off along the riverbank. I was pretty sure no one would care that I was gone, or how long I stayed away.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I hiked all the way up to the Old Settlers Cemetery and sat down next to one of the ancient stone markers and I just gave up. I let it all flood out—all the shapes and shades that had been prying at corners and testing gates since I’d gotten up that morning. I groaned and wailed until my stomach hurt, and when it finally let up and the old Mean Troubles had slunk away (not far; I could still feel them nearby, like coyotes around a campfire), it made me feel a little better. Not for any good reason, but in practical terms. See, I’d still had this tiny hope that my mother would like me again somehow, and losing that had been the price of their departure. When they took that last bit of hope with them, it freed me up to finally see a way forward.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Sitting against the old slab, drained now and clearheaded, I decided that I would be stoic, like the tragic and noble heroes in my dad’s mythology books. I would accept my fate as the outcast because I deserved it, and while accepting it wouldn’t make me happy, maybe I wouldn’t have to be Luke Jackson anymore either. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I thought this through a couple of times, sniffling and sighing. Then I got to my feet, wiped my eyes on my sleeve, spat on the ground by the grave marker, squared my shoulders, and started walking back to the house. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When I got there I went silently past my mother sitting in her rocker with a magazine and a cigarette, and when she looked up I met her eyes just long enough to let her know silently that I wouldn’t be bothering her anymore. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I looked in the living room and saw Alvin with his eyes glued to the TV. He didn’t even notice me, so I decided to skip the meaningful look I’d prepared for him. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I went straight up to my bedroom. On my bunk I stared out the window at the field. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s that,” I said, and it felt correct to have decided to be tragic and noble, to move on from any sort of misguided hope that my family would ever love me again. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Afterwards I would join them for meals, but not much else, and I went for longer and longer walks in the woods, and bike rides. I would walk down to the river and sit under an apple tree and watch the water go by. I spent a lot of time in the barn. That part of it was useful, at least. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Music was the one thing I couldn’t "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("not")]), _vm._v(" care about, and I’d take my horn to the barn to practice. I began to learn a lot faster, because I was more serious. Over the next few months I discovered that if you played with everything you had, it could become a conversation, or an exclamation, or a lament. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Sometimes that could get a little dangerous. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I’d be playing something slow, in a minor key, and it would hit me. I’d put the horn down and look up at the hayloft, and I’d think about Julie, and sometimes I’d wonder about taking that walk myself. Because I might fall, and that would be the perfect ending, right? They’d have no choice but to forgive me. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But I never quite had the gumption to try it. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So I settled for staying on my separate path. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I suppose in the back of my mind I still wondered if my mother would notice how distant I’d become and would care enough to do something about it, but that never happened, and after a while I let even that wisp of a hope go and it all began to seem normal. I got used to it, I guess. It was less trouble, and there was a certain sense of relief. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Everybody else seemed fine with it, too.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Mostly they left me alone. Pike even laid off about chores. He’d won. I wasn’t important enough to bother with any more. And as time went by things got pretty well fixed, with me as more of a boarder than a family member. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was another distinct stretch of my youth. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I got a little older and still felt sad sometimes, but for the most part, it was better this way. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And there was always Uncle Gus. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He’d been demoted by Pike from "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("family friend ")]), _vm._v("to "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("just the music teacher")]), _vm._v(", but still knew most of what was going on and understood that I was getting a raw deal. And maybe he didn’t have it in him to confront a guy like Pike, but he helped in his own way by making clear I was welcome to come over anytime I wanted. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("With all my barn playing I got good enough that he’d let me use his Committee—a huge privilege—while he grabbed the alto, which meant we were going to play together, which also meant that we would be trading off solos. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He wasn’t as proficient on the sax, so I could keep up, and when we were trading and I hit something cool, he would point at me and grin, and I would have one of those forgetful moments where I felt happy for a little while.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So I was a lodger at home, a musician at Uncle Gus’s and a little of both everywhere else.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At school I was stuck mostly by myself, because the kids I’d grown up with had pretty much written me off. A kid’s world can be cruel, and sometimes it doesn’t take much. I’d changed after losing my father, and that had started it: The other kids gave me a certain amount of sympathy, but then, being kids, moved on.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Maybe they’d have come back once I was myself again, but Pike showed up before that could happen, and then Julie fell out of the hayloft, and when the story went around that I might have saved her if I hadn’t been a weakling and a coward (thanks, Alvin), my odds of bouncing back took a pretty serious hit. (And of course, it didn’t help that I mostly agreed.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Even when new kids moved to town, nothing changed. Someone would always fill them in, and they would be only too happy to join the rest of the pack—still including my brother—in leaving me to fend for myself.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("On a couple of occasions a new boy would decide to take it a little further and pick on me, to grease his own skids. I’d always been fairly scrappy, and even as guilt-ridden as I was, would only take so much before pushing back, which led to fights, which made things worse, because the school authorities figured since I was the common denominator, I must be the problem.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Which of course I found unfair.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Which made my attitude and behavior worse.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So on it went, and after a while I became fixed into an odd sort of position: decent student (I couldn’t help it), talented musician (my trumpet was everything), and at the same time, surly loner who often seemed "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("mad at the world ")]), _vm._v("(as my principal put it during one of his one-on-one lectures). ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Sometimes people tried to see past that facade. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When I got to high school, Mr. Wilkins, the senior janitor, spotted me right off as needing a friend, and would wink and say, “How we doing today, kid?” when we passed in the corridors. And our band director, Mr. Booker, treated me well enough, which encouraged the other kids in the band to give me a certain amount of respect, too—at least while we were together. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But otherwise, I’d have to say the tide was definitely against me.")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Twenty-Five ")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-26"
    }
  }, [_vm._v("Baxter, 1970")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("A tide can work in different ways, though, and while this one may have carried me away from the popular crowd, it also eddied me into places where the other marginal kids tended to wash up: the dead end of the corridor by the boys’ room, the unofficial smoking zone in the birch grove behind the school, the All-Purpose Room (which was dark and empty between assemblies and gym classes). By the time I was a sophomore that actually gave me a niche—a few of us began slouching around together—and made the next couple of years a little more bearable, an interlude of sorts. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There never was a time when I got over Julie’s death or my failure to save her: It could hit me like a thunderclap at a moment’s notice. But just having cronies meant there would be moments of distraction and even pleasure, like a spirited four-bar riff where you let it all hang out, even knowing that you’ll have to bring it back to the melody. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There were two guys I regularly hung out with: Chuck Lamar—a rugged boy who lived on Depot Street, down by the train tracks; and Bobby Berube, a snarly near-midget who lived with his mother, two houses down from Chuck. They were "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("poor kids ")]), _vm._v("I’d known since first grade who were now wannabe hoods. They wore trucker jackets with the collars turned up and combed their dark hair back into greasy pompadours. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We were wary with each other at first, but as time went on, we got friendlier, and then one day in the cafeteria it all came together. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Chuck, who’d been carefully tending his DA with a comb, said, “Look at the cool kids watching.” And after Bobby and I turned to look (at a table of smiling jocks and cheerleaders), he said, “They think we’re all shitheads.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("After which we began calling ourselves the Shitheads. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Naming ourselves was another kind of giving up, but a cheeky one. And like my earlier noble/tragic persona, it gave me some respite from the gloom. There’s strength even in small numbers, and now we got bolder, grinning insolently back at the cool kids, Chuck even trading punches with one of them in study hall after the teacher had stepped out. (The guy quit after taking one square in the nose, which we considered a great victory, and which elevated Chuck to Walking Boss.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We were Baxter High’s first attempted gang. After school, unless I had band, we’d walk to the pool hall uptown, careful not to piss off the "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("actual")]), _vm._v(" hoods there: lean and sallow guys who worked at the shoe shop in Emery Falls, two miles upriver, who carried their cigarettes in turned-up T-shirt sleeves, and who would buy us beer, but only on impulse, nothing to depend on. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Or sometimes we’d gather at the iron bridge over the Baxter. There was a space under one end of the bridge, formed by girders and concrete braces that had been added to the original granite footings. We would muster there—cars thumping across above us—to smoke and cuss, and when we snapped our cigarette butts into the water they would hiss like three-dimensional exclamation points.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Mainly it was the three of us, but other boys would come and go, and sometimes the odd girl who was working her way toward not giving a damn. Becky O’Dell even joined us in my sophomore year, after she’d lost her place with the cool kids. Over time it had become important that she lived in a double-wide, that her father was a second-rate lobsterman, and that she was mysteriously knock-kneed and not lithe cheerleader material. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The capper was when she came down with a case of mononucleosis that cost her most of a school year and put her back in my class; after that we began to bump into each other more, and started exchanging smiles. No doubt she was lonely, too, because one day she came hobbling up in the cafeteria and said, “So what are you little kids up to?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She ate with us after that, and joined us when we skipped study hall to hang out behind the stage curtain in the All-Purpose Room, and behind the school when we snuck out during lunch to have a smoke. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You smoke?” I said, looking over Bobby’s head at her—he was grimly sucking the life out of one himself—and she tapped the pack against her palm, pulled a skinny cig out with her lips, and said “Sure do” out of one side of her mouth. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How long’s that been going on?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Since I started working on the boat.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Your father lets it go?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What’s he gonna say? They all smoke, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She joined us under the bridge, on afternoons when the wind was howling and she didn’t have to haul. (When I asked how she’d discovered our hideouts, she said everybody knew about our little juvenile delinquent gatherings.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I wasn’t entirely sure how I felt about Becky coming on board. She triggered lots of Julie feelings, of course, and she’d never tried to close the distance that had opened between me and my childhood friends. But the Julie stuff wasn’t her fault, and she’d never been mean to me; plus, she was as natural and likable as ever. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So I kept my doubts to myself, and then one day she saved us from Chief Foss, head of the Baxter PD, and how could I have doubts after that? ")]), _vm._v(" "), _c('p', {
    staticClass: "parts-head"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _vm._v("I WOULDN’T BE"), _c('br'), _vm._v("AT ALL SURPRISED")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Twenty-Six")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-27"
    }
  }, [_vm._v("Baxter, 1970")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("We’d gathered at the old stone pier down past the Old Settlers Cemetery, because Chuck had heisted some Black Label beer from his parents and we didn’t want to drink it at the bridge; that was too close to town, and Chief Foss liked to roust us from there when he was in a fractious mood. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("That afternoon Chuck passed a note in study hall for us to meet after supper. (Passing notes cut across social lines; even the cool kids would honor a note.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Getting out of our homes wasn’t any trouble. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Chuck and Bobby’s parents didn’t care what they were up to, and I pretty much came and went as I liked, as long as I didn’t do anything to call attention to myself. (Things had worsened between Pike and me recently, but I was still trying to make it to graduation.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So after supper that night I just said “Going out—see you later” to my mother, grabbed my jacket and left. I rode my Schwinn down the River Road and hid it in a tall culvert that took a little stream under the pavement. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Chuck’s and Bobby’s bikes were already there, tires in the dirty water, leaning against the corrugated wall. I left my bike and walked the rest of the way, then ran through the graveyard and the pine groves to the river. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was low tide, and dark mudflats spread out from the old stone pier to the pinched flow of the water. The sun was behind the trees, and it was shadowy and mysterious. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They were sitting on one of the granite slabs that made up the pier, and hadn’t started in on the beer yet. It made me happy that they’d waited.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“About time, asshole,” Chuck said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I took a beer from him. He handed Bobby one, too, and we all popped the tops—that wicked hiss—and leaned forward to click the cans together. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Drink, Shitheads,” Chuck said. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We lit cigarettes and nursed the beers. It was piss-warm, but that was all right. I hadn’t really developed a taste for the stuff, but I could get it down, cold or warm, because of how it made me feel. (After a whole sixteen-ouncer I’d get a glow and my mind would settle amazingly. I thought it was something, that beer could do that.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We sipped from our cans.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Did you catch Dana Knight’s dress?” Bobby said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Chuck raised his beer to toast Dana’s mini-dress, which I’d gotten a better look at than the rest of them. I was still in the Academic section, like her, and I’d gone up to sharpen my pencil in English class so I could check her out. (I was sixteen now, and the idea of sex was everything to me, even though I knew nothing about it.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The sun dropped lower and it was getting dark by the river, and we sprawled on the warm granite slabs, enjoying our little buzz, and complained about school, and argued Beatles versus Stones. We talked about the Red Sox and whether Tony C. would ever make a comeback, and then Chuck lifted his T-shirt and showed us the purple and yellow bruise where his old man had slugged him. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It made me wince. “What’d he hit you for?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Smart-mouthing. I called him a drunk.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He is a drunk,” Bobby said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah, but he don’t like it when you call him one.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That stinks.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah, but what can you do?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Chuck was telling us about his plan to get his parents to sign off on joining the marines next year, after he turned seventeen (“They’ll be glad to get rid of me”), when we heard an outboard boat chugging up the river. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("In case it was the Clam Cops we stomped the empty cans flat and slid them into cracks between the granite slabs. Then we hid behind the pier until the boat should pass. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But it didn’t motor past. It swung in close given the low tide and throttled back, and then Becky’s raspy voice came to us across the flats. You could always tell her voice.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Ahoy, Cal!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Ahoy!” I yelled back.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hey listen, Foss is onto you guys!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Foss is coming! I came to get you out of here.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We heard a car driving down the road then, and the hair stood up on my neck. But it went right on by. Only seconds later, though, another car came along, and we all held our breath to listen. I could hear the car coming and the water splashing lightly against Becky’s boat. The car turned into the little gravel parking lot by the cemetery.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Holy shit!” Chuck said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hurry up!” Becky yelled.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We yanked our shoes and socks off, rolled up our pant legs, and went slopping through the mud, hoping we wouldn’t step into a honeypot and disappear. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Becky held the boat steady while we splashed through the thigh-deep water and crawled over the side, rocking the little boat, and as we were still getting settled she turned to run carefully out into the channel. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She wagged a thumb, upstream or down-, and when I pointed toward town, she fed it some gas and the bow went up a couple of inches and we plowed ahead, overloaded and low in the water.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was dark enough now that the water was silvery. Back toward the pier we could see flashlights moving through the trees. I looked at Chuck and we laughed. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I turned back to Becky. Her chestnut mop—dark in the weak light—was snapping around and she had a big grin. She was wearing jeans and a fisherman’s sweater and you couldn’t tell she had bum legs; with her hand on the throttle she looked wild and pretty, and my mind shifted suddenly to see her that way. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How’d you know?” I yelled above the engine noise.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I heard my old man on the VHF!” (Her father was a reserve police officer, and apparently Foss had called his boat in to be part of the posse.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How’d they find out?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Somebody peeked at the note and squealed.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Becky had waited until her father left for the police station, then told her mother she was going fishing and ran down to their dock and shoved off in the outboard. She knew the river, so it was no problem running up in the twilight. In fact, she’d thought it a pretty cool adventure.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I told her we’d hidden our bikes in the culvert, and when we got up to where the little offshoot cut through the flats, she swung us in until the boat scraped softly on the mud. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We stood in the shallow water. I had my shoes and socks under one arm. I said, “Becky to the rescue!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t ask me why.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thanks, Beck!” the other guys said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Let me go so I can get home before he does!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We shoved her off and she throttled up and raced off downriver. Her father had a fifteen-horse on that boat, and it moved along pretty well.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We splashed through the shallows and slopped over the mudflats to the riverbank, wiping our muddy feet with handfuls of marsh grass, putting on our socks and sneakers. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We rolled the bikes out of the culvert and headed home, my friends toward town, and me, the other way. I chortled all the way back at our narrow escape, but stopped when I rode up the driveway and saw Pike waiting on the porch. It was still pretty early, so it wasn’t that.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I swung off the bike and let it down on the grass. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike had put on some belly weight and looked more than ever like a bear. And like a bear, he still looked capable of moving his mass fast enough to hurt you. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("That was a concern, because I’d felt that old meanness trying to resurface in him lately. I thought it was tied to me becoming a Shithead and the attitude change. I still tried to keep a low profile, but it hadn’t been as easy lately, and Pike’s antennae were up in case he might have to make sure I didn’t somehow gain a little confidence in some way.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Where you been?” he said as I walked up.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I stuck my fingers in my jeans pockets, shrugged with my elbows. “Nowhere special.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He looked down at me from the top step. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well, we had a little visit from Chief Foss.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Foss and Pike were pals who went shooting rats together at the sand pit; I should have figured they’d talk.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Is that right?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah. Seems they had a report about some kids drinking down by the river. He was wondering if you might be one of them. I told him I wouldn’t be at all surprised.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Had my back, huh?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("This was sassier than usual, and I could see the surprise in his little porcine eyes. I guess I was surprised, too. But I was still fired up after escaping from Foss and his posse.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike came down the steps. “You smell like a brewery.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I elbow-shrugged again and didn’t say anything. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He came up close. We were the same height now, and I didn’t think he liked that I could look him in the eye. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So who were you out with?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nobody.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Lord, I hate a liar.” He reached out and gave me a two-fingered poke in the chest. “That Lamar kid, huh? That Berube, right? Those greasy little punks.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He jabbed me again, hard enough to knock me off balance. I caught a whiff of alcohol from him, then.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Keep your hands to yourself,” I said. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What’s that?” Jab.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I said, keep your hands off me.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My chest was starting to hurt, and it was pissing me off. When he tried it again I knocked his arm away. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He grinned and held two fingers out, tauntingly. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I thought he’d had a few, had decided it was time to let me know who was boss again, and I’d just given him the perfect opportunity. Normally I would have backed down at this point; I would have thought about how little time I had left at this house. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But I’d had a couple of beers, and I was fresh off an adventure with the boys, and I’d listened to Chuck talk about not taking any shit from his old man. So when he tried another two-fingered poke, I pushed him in the chest, hard, with both hands. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Leave me the hell alone!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He lost "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("his ")]), _vm._v("balance, and stopped grinning. His piggy eyes narrowed, and I wanted so much to step up and punch him in the face. But Pike still outweighed me by a hundred pounds, so I hesitated. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He lunged and got me in a headlock. I wrestled with him, tried pushing his arms away, but I was helpless. He walked me around in a circle, squeezing until I couldn’t breathe, muttering things like “You think you’re a tough guy, huh?” and finally I stopped trying to get free and let myself go slack. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He held on a little longer—my head grossly tight against his damp armpit—and then slung me down onto the gravel. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I sat up, coughed and hacked. He was breathing hard and his shirt was untucked. I got a knee underneath and stood up. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He pointed at me and said “Consider yourself grounded.” Then he walked back to the porch, still panting, tucking his shirttail in, his fish-belly-white skin showing and then disappearing. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He went into the house and a minute later came back outside with my mother. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I was standing with my bike, shaken, contemplating riding up to Uncle Gus’s. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“There he is,” Pike said. “Our very own delinquent.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I let the bike back down.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Calvin? Is it true?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why ask me?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I want you to tell me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You always believe him anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Watch your mouth.” Pike looked at my mother. “So he’s grounded.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, Calvin,” my mother said. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“For a month.” Pike stood up straight like a drill sergeant. “We clear? And that includes your so-called uncle.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What’s he got to do with anything?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Grounded means grounded.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Should we really take away his music, Randy?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He doesn’t give a damn about anything else.” He put his hands on his hips. “A month. And if I hear you’re still sneaking around, we’ll talk some more.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He hocked and spat over the porch railing, then turned and went hulking back into the house, stepping sideways past my mother in the doorway. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nice guy you got there,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re underage,” my mother said, and went inside. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I looked at my bike and thought about riding to Gus’s. But I knew Pike would come after me, and Uncle Gus would back down. I thought about running away. But back then they just caught you and took you home or put you in reform school. Nobody thought about taking you away from your parents, especially if your stepfather was a big shot and best buddies with the chief of police.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So I was stuck. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I picked up a rock from the driveway and threw it as hard as I could. It hit the grass and bounced into the barn a foot from the side door. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When he heard the bang Pike opened the kitchen door and we looked at each other. Then he smiled and shut the door.")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Twenty-Seven")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-28"
    }
  }, [_vm._v("Baxter, 1970")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("I served my sentence and did my best to not trigger Pike at home, but I wasn’t going to stop seeing my friends, especially now that they included Becky O’Dell. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("See, after the river rescue, I was a goner. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I didn’t care about her legs, or that she was a year older, or even about the rumors that she’d slept around a bit when she’d been in with the In-Crowd. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("None of that mattered, because I’d seen her perched on the aft seat of her father’s boat as she snatched us away from certain doom, like some pretty Dunkirk hero, and just like that, I was madly in love. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Not that I knew what the hell to do about it. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I’d never been any kind of Don Juan even before I was a Shithead. So it was Becky who had to get things moving, which she did on our gang’s last under-the-bridge meeting before summer vacation. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was cool under the bridge, and we’d been there a couple of hours. Then Chuck decided he’d go and see the man recruiting blueberry rakers, who was holding a sign-up session that day on the town hall lawn. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Bobby Berube thought he might give it a try, too. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Chuck looked at me, and I said, “Nah, I don’t think so.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Raking blueberries was a good way to make money, but I’d been dying for a chance to be alone with Becky. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Suit yourself.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Chuck and Bobby levered themselves up and out of our alcove, sneakered feet levitating last. We listened to them run along the footbridge, and then I lit a cigarette and offered it to Becky, rumpling the empty pack so she’d notice I was giving her my last one. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, thanks.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was sitting cross-legged, wearing jeans and a boy’s white T-shirt. She’d gotten pretty curvy. I swallowed and looked at the water. It had a greenish cast out where the sun hit it, but was a cool, thin blue under the shadow of the bridge. I threw the crumpled cigarette pack into the water, turned my head and caught her looking at me.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How’s things at home?” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Peachy keen.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She laughed. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Two more years.” I watched the water splash against the cement pilings.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are you going to make it?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I hope so.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She moved and I looked over. She was rocking up on one hip so she could straighten her legs and hang them over the side. Then her feet were inches above the running water, and her hands flat on the concrete, and she put her cheek against her raised shoulder and looked back at me. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When I only swallowed and sat there, she laughed again under her breath. I was afraid then that she’d be disappointed in me, and managed to blurt out, “Becky . . . !”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My face felt hot. “Shit. I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well, if you don’t, I don’t either.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I gritted my teeth. “Becky . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You already said that.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I hung my head, shook it back and forth.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re something else, Shaw.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hell,” I said. “Damn it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t worry about it. You’re just a kid.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m not that much of a kid.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah, you are.” She crossed one leg over the other and leaned toward me against her stiff arm.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I just . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Shut up.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She hunched herself sideways until we were shoulder to shoulder. It was a challenge, and I was just brave enough to put an arm around her. After which she put a hand on my chest and looked into my eyes. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Oh, my heart went soaring. A car thumped by above, which made us feel even more secluded, and then she lifted her lips to mine. We kissed, and I looked at her and she grinned. I fell a long way into her eyes. Our lips came together again, and when we stopped I could feel her heart beating. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Egad,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re pathetic,” she said, and pulled me close again. ")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Twenty-Eight")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-29"
    }
  }, [_vm._v("Baxter, 1970")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("After that Becky and I were a duo, together whenever she wasn’t helping her father, and I wasn’t studying with Uncle Gus or mowing lawns with Bobby Berube (who’d failed at blueberry raking because, he claimed, his arms were too short). ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We couldn’t hang out at my house even if Pike wasn’t around, because he was always liable to show up and be an asshole. And I told you about her father. So we’d meet on the River Road and walk through the woods to the stone pier, and we would sit on the grass near the remains of an old homestead (relics of a stone foundation) and watch the water drift along.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We’d smoke cigarettes and drink beer if we’d managed to cop some, and we’d talk about everything. We even talked about Julie. I’d never talked to anybody about Julie before, but I told her about the fight with Pike and the truth about how I’d tried to grab her on the beam. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I could have saved her.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You were a little boy.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She would hold me until I felt better, and after a little we’d kiss, and the gentle kisses would gradually turn into make-out sessions that got us both all worked up, and then I would try to grab something I shouldn’t and Becky would pull away. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m sorry,” she’d say.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s all right.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("was")]), _vm._v(" all right with me at first; I was thrilled just to have a girlfriend. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But as I got more comfortable I couldn’t help but feel disappointed. I saw her as experienced, after all; she could teach me. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Sometimes I even got cranky. And one day when I did she decided she should try to explain. She’d said, “No, Cal!” and I’d taken my fingertips out of the waistband of her panties, had slid away from her on the sand and had lit up a Lucky Strike. I wasn’t saying anything and I wouldn’t look at her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Try not to take it personally, okay?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Okay.” I blew smoke at the river.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s just that with you I want things to be different.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“From what?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“From the way it’s been sometimes.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I took another drag, looked out at the water. A heron lifted up from the marsh grass fifty yards away and flew slowly away from us, looking prehistoric. I thought about Alvin and dinosaurs. Then I let the smoke out and said, “We could try it and see.” I looked back at her then and we smiled. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We can’t,” Becky said. “Because you can’t just let a boy do what he wants. I learned that the hard way. Because then that boy will like you less. You’d think it would work the opposite, but it doesn’t.” She shook her head. “And I don’t want you to like me less.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I never would,” I said, but I wondered, because I’d heard guys talk about their supposed conquests, and none of them had seemed the least bit concerned about jumping from one girl to another. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s not that I don’t believe you, Cal.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Then what’s the problem?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ve believed boys before.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I watched the heron disappear around a bend in the river, flying below the tree line. Then I took a last drag on the Lucky and snapped it away. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All right,” I said, and I meant it, too. Maybe I was desperate to make actual love (I was sure it would be more than the rutting guys bragged about), but I was also grateful just to be able to hold her, to kiss her, and sometimes—when she got "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("really")]), _vm._v(" worked up—even touch her breasts. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The important thing was that she’d busted into my loneliness in a way that the Shitheads never could. I knew she was thinking about me when we were apart. I knew I could tell her anything without fear. One afternoon at Memorial Park in Baxter I even told her about the scary shapes and colors that sometimes invaded my mind, that I’d never mentioned to anyone else. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That sounds horrible,” she’d said. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, you get used to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Where do they come from?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I told her about falling out of the tree, and how after the headaches had finally gone away the other stuff had started showing up. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re a strange one, Shaw,” she said, and put her arms around me on the park bench. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Sometimes if Becky didn’t have to go fishing, she would meet me at Uncle Gus’s. After my wrestling match with Pike in the driveway, I’d been spending time at his house, sometimes even sleeping over. Pike was just as glad to be rid of me, but I was careful not to overdo it, because I didn’t want to impose—Uncle Gus had his solitary routines—and because I was afraid Pike would think I was getting away with something.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Uncle Gus had always liked Becky, though. As far as he was con-cerned she was welcome anytime. If he had a student we’d hang out upstairs and play cribbage on the board he and my father had nearly worn out during their days in the navy. And we’d put on his Blue Note"), _c('span', {
    staticClass: "CharOverride-3"
  }), _vm._v("and Riverside"), _c('span', {
    staticClass: "CharOverride-3"
  }), _vm._v("records. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Becky had never listened to that kind of music—they only played country-and-western on the boat—but she was willing to give it a chance, except for the more radical stuff, and after a while even mused about joining the school band. (“Maybe I could play the triangle!”) ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But her father vetoed that idea: too time-consuming.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Anyway, we were together, and I was thrilled, and it really didn’t matter that we weren’t doing everything that she might have done with some of the In Crowd Boys. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Until school started again in the fall, that is, when suddenly, it did.")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Twenty-Nine")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-30"
    }
  }, [_vm._v("Baxter, 1971–1972")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("Things can change fast in high school, and it was different for me that next year. I had a girlfriend, along with my pals; I was taller, and had somehow added a few muscles. The other difference was that I got a little full of myself. (Yeah, sometimes it doesn’t take long.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Other girls would say “Hi,” now, and smile at me. It was as if I’d crossed some threshold over the summer. One of these girls played clarinet in the band. Her name was Donna York, and she’d been part of the In-Crowd at one time, but had become a free agent after several family vacations in San Francisco, where she’d discovered the counterculture. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She and her two best friends wore shapeless dresses and carried books by Ferlinghetti and Kerouac. They flashed the peace sign instead of waving see-you-later, and that fall gave each other Age of Aquarius nicknames like “Rain” and “Peace.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Donna called herself “Dharma.” She was tall and confident and wore headbands over her long sandy-blonde hair. She went braless when she could get away with it, and was supposed to be a free-love hippie.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was also a good musician, and when Mr. Booker asked her to join our band’s jazz combo, we were together after school three days a week. Before long I was wondering what it would be like to kiss her. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We’d make eye contact during band sessions, and sometimes leaving practice she’d bump me with her hip at something I might have said, and then things took a big leap during a band trip to the state capital to compete for a chance to go to DC, for the Cherry Blossom Festival. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Halfway to Augusta, Dharma left her seat with Peace and Rain, walked down the aisle, and asked me where Becky O’Dell had been that day in school. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And when I told her Becky had stayed home with the flu, she took my hand, held it between her uniform-bound breasts, and said, “Poor Cal—you were alone all day!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We sat together the rest of the trip, and after the competition (second place, but I won First Trumpet), we walked back to the bus together and took the same seat for the ride home. I knew I was doing wrong, but couldn’t help myself. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("On the way back Dharma leaned against me while we talked, and looked up at me with her sleepy eyes. After the sun went down and it was dim enough inside the bus, I kissed her. It felt terrible to do, but I loved it. She kissed differently than Becky, more aggressively, which made it a whole new thrilling thing. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We weren’t the only ones paired off, and when all the heavy breathing got noticeable, Mr. Booker had the driver snap the inside lights on. Then he said, “Hands where I can see ’em!”, and we all raised our hands. But then Mr. Booker laughed and had the lights turned off again.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I could barely walk by the time we pulled into the lot at Baxter High, because over the last mile or two I’d slipped my hand between the brass buttons of her double-breasted uniform and she’d put her hand on my leg and squeezed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“See you around?” Dharma said when we got off the bus, and then she and her friends walked off, heads together, chattering, looking back at me.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I rode my bike to school the next day instead of taking the bus with Becky. I was afraid my face or manner would give something away. But when I saw Becky between classes, I could tell she already knew something had happened. There’d been too many witnesses for someone not to have said something. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She’d caught me at my locker, had given me a hard look, and said, “So how was the band trip, Cal?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It was all right.” I felt like a traitor. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Better than all right, from what I heard.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So I confessed that I’d sat with Donna York, and we’d flirted during the bus ride. But I swore it was only because I was lonely without her, and told her I loved her and that it wouldn’t happen again. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Becky went off to her next class, and took another two after that to decide she’d give me another chance. We spent lunch period together outside by the birch grove behind the school. She was still standoffish for a while, but eventually when I kissed her, it felt right, like we were already halfway back to normal. When the bell rang I held her close and said I was sorry and told her I loved her. I swore to myself that I wouldn’t screw up again. I wouldn’t be weak, and I would do my best to avoid Donna York.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But I still saw her after school, for combo practice. And she could talk jazz, and had those sleepy eyes and that feline confidence, and there’d been all that promise in her touch on the bus, and I couldn’t help being friendly with her. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("One day after practice she couldn’t get her clarinet apart. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Cal, could you help me?” Dharma said, and I snapped my own case shut and went over to take a look. It came apart easily, and she laughed and said, “I guess I wasn’t doing it right!” She put it away and we walked together out of the All-Purpose Room and down the corridor to the front door.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Outside I started right off for the bike rack, but Dharma’s ride wasn’t there yet, and she said, “Aren’t you going to keep me company?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I should get going.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Wait a little while, at least. Please?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So I walked back to wait with her. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Let’s go sit on the bench.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We sat on the bench next to the flagpole, and pretty soon were the only kids left. All the staff had gone home, too, except for the janitors, and we were pretty much alone. The sun was shining over the brick school onto the bench, and us.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dharma clasped her hands together and stretched her arms out. “Isn’t this nice?” She leaned against me and smiled. And then she lifted her chin and kissed me. I’d known since walking back from the bike rack that I’d let her do it. I kissed her back, and with that, everything that had started on the bus trip was rekindled. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When the kiss ended, she looked at me and let her hand rest on my thigh. I could feel myself nudging her hand, and then she let her hand nudge back, and I nearly passed out.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When her mother showed up, Dharma brought me over to the car—a red MG—and introduced me. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Cal’s in the jazz ensemble, Mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Wonderful! Cal, you’ll have to come to dinner!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sure,” I said, and then Donna kissed me on the lips—her mother only smiled—and walked around to the passenger side. She looked amusedly at me before getting in. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("After they drove off I strapped my trumpet case onto the bike carrier and pedaled home. I was ashamed and excited, and wondered if I could put this behind me as another slipup, and then I wondered what would happen next. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("What happened next was that Dharma got bolder. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I’d be walking with Becky, and we’d pass Dharma in the hallway and she’d give me an open look. Sometimes she’d even sashay up and talk to me in front of Becky. And she would stick near me after band period, which meant that we’d be together when Becky showed up to walk me to my next class.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Later, man,” Dharma would say, and then she would glide off, all sleek hips and long hair, and I would feel Becky’s discomfort as we wobbled along after her. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pretty soon the writing was clearly on the wall. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Becky got older-woman with me and said I was getting too friendly with Dharma, and I said we were just friends because of band, and Becky said I should tell her to back off, and I said that was silly, and Becky began to get sarcastic, and I got defensive, and then we outright quarreled. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Things went downhill from there, until one day Becky cornered me at my locker with a me-or-her ultimatum. When I only looked apologetically back at her, she brushed her eyes with the sleeve of her sweatshirt and waded away. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I knew I’d been a shithead for real. I never actually stopped caring about Becky O’Dell, or feeling guilty about doing her that way. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But I was a teenaged boy, full of juice, and I’d only recently been released from my long isolation, and none of that slowed me down with regard to Donna York. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Once we became a couple, it wasn’t long before she made all those erotic promises come true. The first time was in the pine grove behind her house. Her parents lived in a big, gabled place on a property that had been cut out of the woods a mile from Baxter village. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was two weeks after I’d broken up with Becky, and Donna had taken me there for a picnic lunch. She’d also grabbed a bottle of her mother’s Chablis out of the fridge, and after a couple of glasses of wine and a lot of petting, she let me know the time had come by pushing me gently away, looking into my eyes, and unbuttoning her peasant blouse. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She leaned toward me concavely, so that the wide neck of the blouse fell off her shoulders, and gave me a moment to gape before crossing her arms to pull the blouse over her head. Then her pretty breasts were pointing my way, and she gave me another moment and fell into my arms. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Oh God: holding and kissing a girl with bare breasts! I lost my mind and forgot that this was just the preamble, and finally Donna had to push me away again, looking at me heavy-lidded and touching the tip of her tongue to her lip. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I ripped my jersey, yanking it over my head. We kicked our jeans off and quickly were naked. Donna lay back and reached for me; after I poked and missed a couple of times, she pushed me over onto my back, swung a leg over, and let herself exquisitely down onto me. I felt the incredible clutching softness of her, and she began moving and threw her head back. I held her waist and looked up at her breasts and the underside of her jaw and she kept moving and I never wanted it to stop.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But then she moaned, and that sound coming out of her because of me was too much. She kept moving, and moaned again, and my mind shattered. Then my mind came back together and she slowed and stopped, still clutching, and then she lay down flat against me and we held each other. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was over too fast to have been very impressive to a worldly girl like Donna, but she sighed deeply as if I were indeed Don Juan, and softly kissed my neck. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That was so far out, Cool,” she said, which was the nickname she’d given me after we’d been together for a few days, because Cal, she said, was way too old-fashioned. (“I mean, it was the name of one of those old-time presidents, right?”)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah,” I said, and it "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("was")]), _vm._v(" far out, not least because it had smoothed the last stubborn textures out of my mind, the tiny, furtive ones that were almost always lurking. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Lying there with her, I was at peace in a way I’d forgotten was possible. It was even better than beer, and afterwards, although I might have been embarrassed to be called “Cool,” and I might have still felt ashamed about Becky, there was no chance at all that anything was going to go back to the way it had been. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Besides that, I was now a guy who had done it with a girl. I was a man, not a kid (good thing Pike wasn’t standing in front of me), and that gave me a whole new persona to live up to, one which couldn’t include someone like Becky.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Part of that persona required at least pretending to be Dharma’s counterpart. And from then on we were Cool and Dharma, romantic and talented, and I have to admit that as phony as that often felt, it still seemed better than being Becky’s puppy-love boyfriend, or a Shithead in Good Standing, or even some lesser member of the high school In-Crowd, like Alvin. (He’d gotten himself a grudging sort of acceptance by throwing me under the bus with the story about the barn, and he’d clung to that niche ever since by being the kid who laughed at everyone’s jokes and played the piano at parties.) ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I started reading the Beats, and Kurt Vonnegut, and James Baldwin, and my hair got longer, and after a couple of months, at Dharma’s prompting, I splurged on bell-bottoms and a buckskin vest from my lawn-mowing cash. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At home things shifted again. Pike figured I was now a drug-addled hippie not worth the time of day. It also wasn’t clear to either of us what might happen if we ever came nose to nose again, so we tried to avoid that possibility. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Betty didn’t quite know what to make of the new me, but it didn’t cause the problems it might have because graduation was a year closer, and we all knew I’d be saying good-bye soon (if I even bothered). ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("As for Alvin, he graduated early, got a job at Dad’s old employer—sort of a legacy deal—and was never around the house anyway. Then he moved into an apartment with another of the car salesmen, and I never saw him at all.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dharma and I spent that summer riding around in the Volkswagen Bug her daddy had bought her. She’d painted it with flowers and peace symbols, and we took it to protests and concerts and the coffeehouse in Rockland (Trouble Brewing, it was called), where one day we saw Alvin and his roommate on a field trip to observe hippies. (Alvin saw me come in and gave me a smirk, but didn’t come over to talk.) ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Oh, and we did a lot of drinking, Dharma and I. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We drank everywhere, pretty much. (She talked me into trying pot, but it brought out the old swirling meanies a little too vividly.) Her parents would rather she drank than "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("use drugs")]), _vm._v(" anyway, and were cool with us having a glass or two at their house, which made it easy. (Probably too easy, considering my future lack of sobriety.)  ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I took her over to Uncle Gus’s a couple of times, but though he thought she was okay, he loved Becky, and that came through clearly enough that we stopped going. (Also, Becky was still visiting him, and one day we met her coming out of his house, something none of us was happy about.) ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So no Uncle Gus, but Dharma’s parents were enlightened enough that I could sleep over there (supposedly in separate rooms, but nobody ever checked). ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then our senior year arrived, and we were still Cool and Dharma, only more so. We were small-puddle luminaries, despised by the more-conventional students, but admired as antiheroes by new-age freshmen and sophomores. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I remember sitting at a cafeteria table while Dharma lectured on My Lai and Kent State and the Pentagon Papers. (And nodding wisely in agreement, although I never actually dug into the issues like her; I was still a self-conscious wannabe—happy about the side benefits, but still, in my mind, mostly about jazz and the trumpet. They’d been everything to me when I needed them, and still seemed far more authentic than anything else did.) ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("That senior year went fast, and after it was through, everything changed once again. (Sometimes it seems my life has been just one key change after another.) ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dharma and I had a few weeks before she went off to Berkeley, and although she promised nothing would ever come between us, it wasn’t long until she fell under the spell of one of that school’s firebrand radicals, which brought an end to my second-ever romance.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("With no Dharma, no Becky, and no school, I had to struggle not to revert to the Shithead I’d been. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I didn’t want to even think about college; had been dying to be free of school for years. My dream was to apprentice somehow with a jazz-meister, but that would be hard to do in Maine. It was something to figure out down the road, after I’d settled into an adult existence somewhere.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It helped that I moved in full-time with Uncle Gus and joined a little jazz combo that he took around to nursing homes and Legion Halls. (Alvin, who still played the piano, joined us a couple of times, and there were actually moments when the salty old bond we’d once had briefly resurfaced.) ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Drinking beer, and sex (when I could find it), continued to be reliable comforts. I’d gotten a stopgap job at the shoe shop in Emery Falls, pushing racks of half-made shoes around the dim old building, and the guys I rode to work with didn’t mind stopping at Blackstone’s Market on the way home and buying me a six-pack, so I had a steady supply of that, anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("One thing I didn’t have to worry about was Vietnam, because I’d gotten a high number in the draft lottery, so with no need for a school deferment (fake hippie or not, I wasn’t going to involve myself voluntarily in that mess), I had time to try and figure things out.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Over the course of a couple of months I decided that when I’d saved enough money for a grubstake, I’d move to Portland and see what was up there. It wouldn’t be a radical departure—I’d still be in Maine—but it would be in a city with a lot more going on than Baxter.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I waited until I had five hundred bucks—a decent amount back in the day—and then I did stop in to the old farmhouse on the river to say good-bye, making sure Pike would be at work. (Unfortunately this meant Alvin would also be at work; after the gigs with Uncle Gus, I wouldn’t have minded shaking his hand and saying adios.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My mother was sitting on the porch, reading the newspaper, smoking a cigarette. She was still a good-looking woman, although there were crow’s feet at the corners of her eyes now, and erosion starting to show on her cheeks. She’d gone partly gray over the past couple of years, too. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hey,” I said, laying my bike down, climbing the steps.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hello, Cal.” She put her newspaper aside. “It’s been a while.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah.” We both knew why; nobody had to spell it out. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So,” I said, “I’m leaving town; thought I’d come over and say good-bye.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Leaving for where?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Portland, to start with.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She nodded. “Clean slate, huh?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s what I figure.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We looked at each other, and all at once I could see the younger Betty in her face, and it started me thinking about what it had been like when Julie and my father were still around, before everything turned to crap. Maybe she was thinking that, too, because after a moment she stubbed the cigarette out and stood up to give me a stiff little hug. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I hope things work out for you, Calvin.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That makes two of us.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We managed to smile, and that was pretty much that. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I said, “Tell Alvin I said good-bye,” then walked down the steps, grabbed my bike, and set off along the driveway. When I got to the barn I looked over my shoulder, and she was still sitting in the rocker, watching. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I waved and she waved back.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I pedaled past the barn and down to the River Road and started up the long incline to Uncle Gus’s. I had a last night there—he broke out a six-pack of his prized Woodchuck Hard Cider, and we drank it listening to Clark Terry—and in the morning he gave me a ride into town—the river, the village buildings, the tall flagpole by the town office, the little park with the Civil War monument—and pulled over by the Route 1 bridge just south of Baxter.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There was a shower passing through, so we sat in his used Buick to wait it out. He hadn’t gotten any slimmer and took up a lot of room in the front seat, and it got a little claustrophobic with him clearing his throat and drumming his fingers on the steering wheel. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He finally looked over at me and said, “Shoot me a note when you get settled in?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sure. I’ll give you the lowdown.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We’re gonna miss you in the band.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll miss it, too.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You can sit in when you visit.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sure!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We watched the rain on the windshield. I could tell he had more to say, but he couldn’t seem to spit it out; he just sat there with his face getting redder. It was never easy for Uncle Gus to talk about anything. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When the shower passed I shook his hand and came away with a fifty he’d pushed into my palm. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Come on, Uncle G,” I said, but he wouldn’t take it back, and I shook his hand again and got out of the car. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I grabbed my stuff out of the backseat, shut the door, and stepped back to the shoulder. He waited for traffic, then pulled a U-turn and saluted going past, and I watched him cruise back toward Baxter on the wet road.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Past him I could see the outskirts of the little town. I took a deep breath: This was something I’d been looking forward to since Pike had stuck his snout into our lives, and now it was happening. It was exciting, but also made me a little nervous, and when a few bat-like shadows decided to come alive in my head I dug a beer out of the duffel, walked down behind the guardrail onto the riverbank, and chugged it. Then I tossed the empty into the water and climbed back up. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I stuck my thumb out and tried to make eye contact as each vehicle approached. The first few ignored me as they swept past. But the fifth one that came along—a black Ford Ranger—slowed as soon as he saw me and pulled over.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I trotted up to the passenger side and looked in the window. He was an amiable-looking guy only a little older than me. He wore a Red Sox cap and a canvas duck jacket, and there was a carpenter’s tool chest built into the back of the truck, and some power tools loose on the floor. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hop in,” he said. “Where you heading?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Portland, if you’re going that far.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re in luck.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I threw the duffel into the back and climbed into the front seat with my instrument case. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He stuck out his hand. “Raymond Lane.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Cal Shaw.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He nodded at the case. “That’s not a machine gun, is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Just a trumpet.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I guess that’s all right.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hold on.” I got out and leaned over the side of the cargo bed to pull the rest of the six-pack out of the bag. Back in the front he took one and stuck it between his legs. Then he looked over his shoulder and spun the tires, scooting onto the road ahead of a bulky dump truck. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I probably would have waited, myself. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We accelerated across the bridge, and when the dump truck began falling back instead of gaining on us, he settled in, held the wheel with his knees while he twisted the cap off his bottle, and held the bottle out for me to click it against mine. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We drank and he turned up the radio—which had been quietly playing country-and-western music the whole time—and we charged down the road away from Baxter. When we got to Damariscotta we opened another couple of beers. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was turning into a fine morning, all the low scud blown through and the sun out. The sun climbed into the sky behind us as we rode past the little towns on Route 1, and in Bath we cracked two more beers and clicked them together. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The sun got higher, while in front our shadow got shorter. It had disappeared altogether by the time we passed the B&M Baked Beans plant and crossed the bridge into Portland. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Raymond Lane dropped me on Marginal Way, and drove off beeping his horn. I knew I’d never see him again, which made me a little sad because we’d had a good time. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I walked across Forest Avenue to Deering Oaks and sat in the open on a park bench. The sun was warm and high now overhead, and there were pretty girls walking the park paths and squirrels running between trees. Dignified geese were swimming in the pond. Everything was bathed in a warm glow, thanks to the beer. It was really the first time I’d gotten buzzed like that in the morning, and I decided I liked it quite a lot. It was another restriction gone. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I nodded to myself, lit one more cigarette, and drew in the smoke, looking around at my new town, my new life. ")]), _vm._v(" "), _c('p', {
    staticClass: "parts-head"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _vm._v("TAKE A QUICK"), _c('br'), _vm._v("BREAK, BROTHER")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Thirty")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-31"
    }
  }, [_c('span', {
    attrs: {
      "lang": "fr-FR",
      "xml:lang": "fr-FR"
    }
  }, [_vm._v("Bolduc Correctional Facility")]), _vm._v(", 1997")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("So a lot happened in the next fifteen years that I could talk about. There was the little rooming house on Valley Street, where I spent the first of those years, whose proprietor—an old-timer named Tate Cummings—told me about living in Harlem and listening to Ornette Coleman and Clifford Brown and Wayne Shorter at the clubs. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There was the Pancake Kitchen on Congress Street, where I met Jack Doyle—trombonist and cabbie—who not only took me to the all-night club on State Street and introduced me to most of Portland’s little jazz community, but also got me in at Norman Finkelstein’s Star of David Taxi Service, where I learned the town as only a cabbie can: the bums sleeping on cardboard under the Million Dollar Bridge; the Shaw’s on Congress where the register girls would come out and flirt; the Dunkin Donuts on Congress and High where in winter the working girls would spike-heel over to warm up in your cab; the pipeline in South Portland where you could bootleg for the sailors on Sunday.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Driving a taxi turned out to be one thing I was good at besides the trumpet, and also allowed me to support myself while I got going musically. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I remember my first trips to the Free Street Pub on Middle Street, where on Wednesday Jazz Night I’d sit in with the people I’d met at the all-night club—which led to actual gigs there and at Mordecai’s on outer Congress and the Top of the East in the Eastland Hotel and Little Willie’s on Market Street . . . which in turn got me invited to Don Doane’s jam sessions at the Bridgeway in South Portland, and later to fill-in gigs with his orchestra . . . which eight years along—it went fast!—got me a letter of introduction from Mr. Doane to his old friend Bradley Cunningham in NYC . . . which got me a job bartending at Bradley’s, where you could listen to some of the biggest names around—think Freddie Hubbard, just starting out—and even sit in with them after hours in the back room after they’d gotten to like you enough to believe you were serious.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There are a thousand things I could tell you about Portland, and then another thousand about New York, and along the way I could fill you in on my drinking career and how I slid from self-medicating boy to party animal to mostly functioning alcoholic, to not-doing-so-well "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("sot")]), _vm._v(", to the drunken mess who staggered out of the Big Apple for Florida with a girl named Gigi Archambeau, who smartly ditched me once we got there. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I’d truly like to try and tell you all that. Maybe I will some time. But I’m not sure I’m up to it just now. ")]), _vm._v(" "), _c('p', {
    staticClass: "parts-head _idGenParaOverride-1"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v("IT JUST DEPENDS")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Thirty-One")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-32"
    }
  }, [_vm._v("En Route, 1995")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("Loretta McCarty, Georgie and I spend about twenty hours together, asleep and awake, stopping in Richmond and Baltimore, playing with the cornet when we have a chance. I decide Georgie is serious enough to learn about false fingering, how to get around the edict that you must never play any note using the third valve by itself, how if you ignore that nonsense you can go right up a high-note C scale without playing a single two- or three-valve position (which does leave some notes a shade off, but that’s true of the trumpet in general, and all you have to do is listen to Louis Armstrong’s intro to “West End Blues”"), _c('span', {
    staticClass: "CharOverride-3"
  }), _vm._v("to know that it works anyway).")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Georgie is worried to go there at first, but while we’re in Baltimore I convince him to at least give it a try, and after playing for a while on a bench outside the station, he decides he likes it. He feels bold and a bit naughty, too—you can see it in his eyes—and by the time we have to re-board the bus, he’s become something of a convert. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Who knows if it’ll last, but it makes all of us happy for the time being, and we ride the rest of the way to Boston like friends—so much so that when the bus finally pulls into South Station and we have to go our separate ways, it’s unsettling. I feel like there’s been an interlude that’s coming to an end.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We wait in our seats while the other passengers squeeze down the aisle, and then Loretta takes a notebook out of her purse and writes down Georgie’s home address and phone number—he lives in Chelsea—and hers, back in Plant City. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I give them the phone number of the farmhouse in Baxter, but say I’m not sure whether I’ll actually be staying there when all is said and done. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re not going to stay at home?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It just depends on how things go.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She touches my arm and says, “I’m sorry it’s like that, Calvin,” and just like that I get choked up. I’ve been holding it off since we got to Boston, but a kind touch has always rendered me pretty much helpless. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’ll be all right, honey,” she says. “Just don’t make up your mind in advance. You never know for sure what’s going to happen.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I swallow and say, “Uh-huh.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Promise you’ll give me a call when you’re back in Tampa.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I will,” I manage to say, but I’m afraid it won’t actually happen, that we’ll just have been ships passing, et cetera, and that makes it even worse. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When Georgie says, “You can call me too,” I can’t even speak, but I hold my hand out so he can high-five me, which he does in his own unique way, kind of like a karate tap.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They wriggle out of their seats and walk down the aisle, and after a last smile from Loretta at the top of the little stairwell, they climb down off the bus. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Through the tinted window I watch them walk away. It gives me a certain feeling; like Raymond Lane and a few others, they’re people who have flicked through my orbit that I’ll likely never see again, but who I know will be in my mind off and on forever.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A few minutes later there’s a knock on the bus door. A man in a tan uniform steps up to say something low to our driver. He leaves and our driver walks back to tell me and two others also waiting that we’re switching buses for the last part of the run up to Portland.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How come?” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He lifts his shoulders. “Ours is not to reason why.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I get off and grab my duffel when he unloads it onto the pavement. There’s some time to kill now, and I use the facilities, buy a couple of Snickers bars to get me through the last leg, and then find the gate for my next ride. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We have the same driver for this bus, which is newer than our old one, and after he loads our baggage we climb up the steps past the fan mounted on the dash above the "), _c('span', {
    staticClass: "small-caps _idGenCharOverride-1"
  }, [_vm._v("watch your step")]), _c('span', {
    staticClass: "CharOverride-3"
  }), _vm._v("sign and sidle down the aisle. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I take a place about halfway back. The seats—two on each side of the aisle—are plush compared to the bus we started with. It’s overcast and dark, and with a half-hour to wait, I recline my seat the few inches it allows and shut my eyes. I get drowsy right away—it’s been a long ride—and my mind drifts between thoughts of Baxter and home and Portland and Uncle Gus, all hooked up to his machinery. The different shades of these thoughts mingle into a smoky sort of blend, and I go a long way away, and the next thing I know the driver is standing next to me, asking to see my ticket, as if we hadn’t been riding together for the past however many miles. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Seriously?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Protocol.” He shrugs.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I fumble in my pockets, then squeeze out of my seat—the driver stepping back—and finally I manage to find it in my back pocket. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He gives it a cursory glance and hands it back.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I sit back down and he works his way to the last seats next to the lavatory and then returns to the front and plops down in his seat. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He yawns and stretches, toggles switches like a jet pilot, then levers the door open to see if anyone is waiting to board. There’s no one there and he shuts the door, checks his wristwatch, and cranks the engine. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There’s a slight lurch when he puts the bus in gear. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I look at my watch too and try to figure when I’ll get to Portland. My stomach clenches at the thought, and I can feel the anxiety jittering through my body. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("More than twenty years, and almost over.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We back out of the parking space and pull forward away from the boarding gate and then we’re moving down the street, heading for the Interstate. ")]), _vm._v(" "), _c('p', {
    staticClass: "parts-head"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _vm._v("LOOK WHAT THE"), _c('br'), _vm._v("CAT DRAGGED IN")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Thirty-Two")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-33"
    }
  }, [_vm._v("Portland, 1995")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("I try to doze again during the ride, but it just doesn’t happen, I’m too nerved up. My little drink demon is whispering sweet nothings in my ear; fortunately, there’s no way for me to fall off the wagon while I’m on this bus. Then the notion to sneak a cigarette in the lavatory crawls into my mind. But I hold off there, as well. I don’t really want to ruin my sober return to Maine by acting like some kind of punk. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So I stay put, watching out the window, checking the time.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The two-hour ride seems to take forever. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Finally, though, we cut through Portsmouth and cross the high-arcing Piscataqua River Bridge into Maine. I sit up straight: It feels momentous. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Through the window the pine trees look friendly and familiar, and like a good omen the overcast is tattering away, the sun peeking through tones of grayness here and there. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I pull my cornet case out and hold it in my lap, and as we roll up I-95 I whisper to this New York instrument; I tell it all about Maine. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We cruise up to Portland, skipping past the small towns—Kennebunkport, Biddeford, Saco, Scarborough—and then we sort of burst out of the spring-green woods to the sprawling Maine Mall and the roundhouse Dunfey Hotel, and I know we’re getting close. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We exit the turnpike and go cross-country for a couple of miles, and then we swoop down to the Veterans Bridge and cross the Fore River. Ahead I can see the Maine Medical Center on the Western Prom bluff—a mix of old gothic spires and new brick walls—and I think about Uncle G lying in his hospital bed. Then we’re off the bridge and slowing past the old brick railroad offices and turning into the low-built Greyhound station. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We snub up against the padded stop-guard next to the double doors. The driver sets our luggage on the pavement, tells us to enjoy our visit to Portland and walks off, lighting a smoke. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It’s sunny out now, and warm for May. I walk over to check out the Star of David taxi parked by the curb, but the driver is no one I know, which doesn’t surprise me, since it’s been a decade now, and the turnover rate for cabbies is never low. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Need a cab, buddy?” he says.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Just wondering how old Norman’s doing.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not too good,” This cabbie is chewing gum and smoking at the same time, flicking the ash out his window every few seconds. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Is he sick?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Dead,” the cabbie says, looking up at me. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The diabetes got him.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m sorry to hear that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He shrugs, flicks ash. He’s not exactly all broken up over Finkelstein’s demise. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Did you drive for him at all?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“For about a week.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Who’s running the show now?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“His kid, Bugsy.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well, tell him Cal Shaw said hi, would you?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There’s a call on his radio before he can answer. He grabs the mike and says, “Roger,” hangs the mike back up by its clip, starts his cab, says, “Watch your toes,” and drives off. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nice meeting you, too,” I say. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then I hoist the duffel over my shoulder, pick up the cornet case, and set off walking up Congress Street. I look at the familiar buildings and signs and side streets—even the people seem like people I should know—and all kinds of little memory shapes dart and swarm around me. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I pass Valley Street, but the rooming house where I lived all those years before is gone, just a weedy lot there now. Old Tate must have passed on—he was in his eighties when I knew him—and maybe there wasn’t anyone to take over. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then I’m opposite the Sportsman’s Grill, where I ate spaghetti-and-meat-sauce meals, and consumed gallons of house wine—I remember how I’d leave there and walk on air down the street to Tate’s—and I continue on up to the old Rines Mansion (the Roma Café, another favored watering hole, in its basement) and turn right on Bramhall, past the nurses’ housing, and I keep climbing toward the Medical Center. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("By the time I finally reach the entrance I have to stop in the lobby and set the duffel down to catch my breath. Then I step up to the reception desk to get directions to Uncle Gus’s room. I ask the lady there if I can leave my bag with her, but she tells me they’re not allowed to be responsible for people’s things. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So I tow it to the elevator and ride up to the ICU. There’s a large woman at the nurses’ station with big round glasses and a quick smile. She confirms Uncle Gus’s room number, tells me how to find it, and then says, “You can leave your bag here if you don’t want to haul it around.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I tried that downstairs.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She rolls her eyes and flutters a hand. Then she gets up from her chair and opens the little waist-high door so I can slide the duffel bag in. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll keep the horn with me.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are you going to play for him?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Is that allowed?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She pretends to whisper behind her hand. “I won’t tell if you don’t.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“If I do I’ll be quiet.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She gives me a thumbs-up, plops back down in her seat.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I take the long corridor to the left of the nurses’ station and walk almost to the end. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Everything’s in warm colors; there are paintings on the walls, and a big window at the end that lets the light in. It’s not that bad for a hospital. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Uncle Gus’s door is open, and at first I think they’ve given me the wrong room. Or maybe the guy lying asleep in there is the roommate. But then I register the bird’s-nest eyebrows and potato nose, and I know it’s him. He’s lost weight, and most of his hair. He has big, pallid bags under his eyes. His eyes are shut, and he’s breathing with his mouth open.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There’s an intravenous rack with a tube that runs down to his arm; also, a complicated-looking machine on a shelf behind him, with wires connected to the back of his left hand. The machine is beeping and clicking. There’s a glass of water with a straw on the side table. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I’m still in the doorway, a sickly, greenish shape rolling through my mind, and for a moment I’m not sure I’ll be able to get myself to move any closer. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But I force a foot forward, then the other, and it loosens me up enough that I can walk in and set the cornet case down next to a folding chair beside his bed. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Uncle Gus doesn’t seem to notice my arrival. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I sit down to wait, feeling bad about my poor job of keeping in touch. (I had good intentions, and did call a couple of times, but we were never that proficient at small-talking with one another, and it was always awkward.) ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll do better if you get better,” I tell him, and he stops halfway into an inhalation. At first I’m happy that he might have reacted to me, but the pause lasts a long time, until I stand up, ready to run for help, but finally he resumes breathing with a little gasp, and after watching for another minute, I sit back down. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I’ve been there for an hour when a young nurse comes in, looking about nineteen but giving off an air of efficiency and capability. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hello!” she says. “Are you here to see Augustus? Oh, he’s one of my favorites.” She bends over Uncle Gus and says, “Aren’t you, honey?” Then she looks at me again. “Are you another nephew?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Uh-huh,” I say. “Sort of.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She cocks her head a little at that, but doesn’t comment. She takes Uncle Gus’s pulse, checks the fluid level in the intravenous bag, twiddles a couple of dials on the monitor on the shelf, then walks back and jots something on the clipboard at the foot of the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How’s he doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“About as well as can be expected.” She hangs the clipboard back on its hook. “He’s been through a lot, poor man. He’s a fighter, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“My brother thought he was pretty aware of things.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He’s had a little setback. Haven’t you, Augustus?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I lower my voice. “Is he in a coma?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She answers in the same kind of voice. “Not exactly.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What does that mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He’s sort of in between.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Do you think he can hear us?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s hard to say.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She leans over the bed and says, “Bye, Augustus; you behave yourself now,” and with a quick smile scoots out of the room and heads off down the corridor. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I sit a while longer, but it makes me uneasy, watching Uncle Gus, and I get up and walk past the divider curtain to the window. There’s an old brick spire with gabled rooftops around it and a courtyard way down at ground level. There are a couple of interns down in the courtyard, smoking. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I go back and sit down again, take the paperback out of my hip pocket, and try to read, but there are ripples of feelings bouncing around Uncle Gus—mine or his, I’m not sure which—and they’re roiling the air. It’s hard to concentrate.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I close the book and look at him again. He needs a shave, and a lot of the stubble is white. His eyelids are twitching as if he might be dreaming. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I wonder if I should leave and come back, maybe head out to Baxter and get that over with, then return and see if anything’s changed. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But I can’t decide, so I try the book again, and after I force myself through a couple of paragraphs, it goes easier. I’m right there with this space orphan raised by Martians and ghosts when the young nurse comes back in and tells me apologetically that visiting time is over for that afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I go back to the nurses’ station for my duffel. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Did you play for him?” the nice lady asks. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I listened for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Maybe when I come back.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She gives me another thumbs-up. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I ride the elevator down, and after thinking it over in the lobby, decide I’m not ready for Baxter, so I lug my gear the seven or eight blocks to Forest Avenue and down the hill to the YMCA. They have a transient room available, so I fork over a few bucks and stow my gear. I spend the rest of that afternoon and the next few days revisiting old haunts between trips to the hospital. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The Pancake Kitchen is still in business, and one morning after breakfast there I set out to find Jack Doyle, but he’s not at the hole-in-the-wall apartment on Cumberland Avenue, and when I hike over to Little Willie’s, they tell me he hasn’t been around for a few years now.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Any idea where he went?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Back to New York, I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I hit the Old Port—which I liked better in my day, because it was full of artists and musicians—and wander down to Commercial Street—nodding at Blake’s Plumbing Supply, where I had a warehouse job for a little while—and then I hike all the way up Munjoy Hill to the Eastern Promenade, where we’d play drunken softball on Sunday afternoons. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I’m enjoying being in Portland again, but by that Saturday, with no change in Uncle Gus, I decide I might as well get Baxter over with. I’ve thought about skipping it altogether, but that would be weak, and I’m trying to be strong. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I check out of the Y, lug my stuff over to the Medical Center and tell Uncle Gus all this, and that I’ll be back to see him again after I’m done in Baxter. Then I ask his advice as to whether I should call Alvin for a ride or hike down to Marginal Way and stick out my thumb. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He doesn’t answer, so I mull it over on my own, and have pretty much decided to make the call and suffer the third degree. Then it’s only inertia keeping me there until someone taps politely on the door and comes walking into the room. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I look up expecting to see the young nurse, but there’s a tallish woman standing there instead, leaning on a cane, wearing a faded blue SMVTI T-shirt and jeans and a Red Sox cap over a thick shock of chestnut hair. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her eyes widen, and I recognize her at the same time, but my tongue is tied just long enough for her to speak first.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well, look what the cat dragged in,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Thirty-Three")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-34"
    }
  }, [_vm._v("Portland, 1995")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("She comes into the room, and it takes me a second to realize something: She might be using a cane, but she’s not knock-kneed. She’s standing up straight like I’ve never seen her before.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hey!” I stand up too and point at her legs. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She stops to bow and sweep an arm out—which is funny in itself, Becky O’Dell curtsying—and then comes the rest of the way over to the bed. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I step aside and gesture her toward the chair, mimicking her curtsy, and she smiles as she sits down. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Back again, Uncle G,” she says, and lowers her pocketbook to the floor. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s nice you come to see him.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He’s my friend.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Do you mind if I stick around?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s a free country.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I grab another chair from behind the curtain and plunk it down beside her. She takes Uncle G’s hand and studies his face, looking for signs of life. She ignores me until I lean forward and say, “I think I should apologize.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nah, forget it,” she says. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ve always wanted to.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’d rather not talk about it.” She taps the cornet case with her cane. “So have you played for him?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah, a couple of times.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Did anything happen?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Maybe. It’s hard to tell.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Try it again so I can see.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She turns back to Uncle Gus, ready to watch closely. There are flecks of gray in her hair, which is otherwise as thick and pretty as ever, and her skin still has that outdoor ruddiness that always made her seem so healthy.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Anytime now,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I take out the cornet, fit the amber mouthpiece in, and flutter the valves. I stick my fingers into the bell and play the first few bars of “Blue Summer,” soft as I can manage. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Nothing happens, though.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“One more time.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I shut my eyes and take it up to the bridge, willing it into Uncle Gus’s mind, wanting Becky to hear it, too. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“There!” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I stop and look. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Becky is leaning close. “That was something.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What’d he do?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Something in his face.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“His eyes?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“His whole face.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I play a little more, watching this time, but whatever it was doesn’t repeat, and when Becky says, “I guess he’s being difficult, now,” I put the cornet away. We get back to watching him, and after a little while I say, “So tell me about the cane.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nah.” She pats Uncle Gus’s hand. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Come on, tell me.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why would you care?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Because I do.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She laughs under her breath, then shrugs one shoulder and rattles it off: “Broke my leg on the boat, got tangled up in a trawl line, and almost went overboard. Slammed my leg into the transom to stop it and ended up with a spiral fracture, had three operations and a cast for almost a year.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Jeez,” I say, “when was this?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Four or five years after you took off.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What happened then?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She shrugs again like it’s nothing. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“When the cast came off I had to learn to walk all over again, and I guess this time I managed to learn the right way.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How long did that take?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Another year.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s amazing!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Another shrug. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Come on, you must have felt like a new person.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh yeah,” she says. “A regular Donna York.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I wait while that rattles around in my head. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Becky clears her throat, stares at Uncle Gus. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Finally I say, “Listen, I was a shit, but it wasn’t because of your legs.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“If you say so.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I do say so.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good, I’m glad we got that cleared up.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She still won’t look at me.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I was sixteen, Becky.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So what?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sixteen-year-old boys don’t know anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She looks at me, finally.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ve always been really, really sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All right.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I mean it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I said all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Friends?” I stick out my hand.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Let’s not get carried away.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I can’t help feeling a little stricken at this, and I guess it shows in my face, because her own softens a bit. But then her chin comes up and she says, “Nope, don’t even try.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Making me feel bad.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I could burst into tears.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("This almost gets me one of her old crooked grins. She swallows it quickly, but I can tell. Then she says, “You’re pathetic, Cal Shaw,” and this is so much like what she would have said twenty years before that it makes both of us laugh. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Becky shakes her head and looks back at Uncle Gus. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I tell her what Alvin had said, and she agrees that when she first came to see him he was definitely awake and could let you know he was listening. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He’d give my hand a squeeze, wouldn’t you, Uncle G?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Uncle Gus breathes steadily and gives no sign, and after a few minutes we settle back, and now everything has changed and we’re just hanging out together with him. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then Becky says, “So what have you been up to?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We spend the next hour swapping stories. I pick up where she left off, tell her about driving a taxi in Portland and playing around town, about Don Doane and Bradley Cunningham and getting started in New York, and my musical career there, such as it was, and I describe lighting out for Tampa and driving a taxi there, too, and playing at Hendu’s the night Alvin called. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She tells me how her father wanted to finish setting the traps before steaming in and how he waited another day before taking her to see a doctor. “He never had any money,” she says. Then she talks about using her convalescent time to get a two-year fisheries degree, and how afterwards she took a job at the same lobster co-op where her old man traded.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He had a new stern man by then, anyway. And I liked it at the co-op. Still do. I’m around boats and outdoors, but I don’t have to work as hard, and I’m not quite so "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("aromatic")]), _vm._v(" when I get home, either.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What about the cane?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She says that sometimes her hips get tender, which is a result of using them wrong all those years. It’s nothing much, she says. “Just something that comes and goes.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We decide to run for coffee. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I tell Uncle Gus we’ll be right back, grab my horn, and we head down the corridor. We pass the desk with a wave for the nice nurse, and at the elevator Becky presses the down button and I watch the floor numbers light up above the door. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The elevator dings and the door slides open. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("On the first floor we walk along another corridor to the cafeteria. The counter is closed, but there are vending machines, and we buy cups of muddy coffee and carry them to a table by the windows that look out at Vaughn Street. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I set the cornet case down and take a seat.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You still carry that everywhere?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Pretty much.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I guess it’s good you’re still playing.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah, most of the time.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I smirk, remembering when it wasn’t so good—how during one epic binge I convinced myself I was Bix Beiderbecke come back to life, and how I decided to let everyone else in on the news by having a one-man show in downtown Tampa at two o’clock in the morning, and how in the ensuing fracas with the cops I took a wild swing at one of them with my cornet, which was enough for them to charge me with assault in addition to my other offenses. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I’m trying to get another laugh from her, but Becky doesn’t think it’s very funny, so I move quickly on to the kick tank at Pinellas and getting sober despite myself.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good for you,” she says. “How’s that going?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All right. Ups and downs.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I know it’s not easy.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Turns out her brother went to AA a few years back, and she sat in on the meetings to try and help, because his wife had left him and he didn’t have anyone else. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He didn’t last, though. Decided he liked drinking too much.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I know the feeling.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It used to sneak up on him.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah. It’s insidious. You get clearheaded and start feeling strong, and that makes you think you’re all better and you can handle having a drink or two.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We get back on the subject of Uncle Gus, and reminisce about how we’d hang out at his place when I had my lessons, and how later we would dodge each other coming and going. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I lived with him, too, for a while.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You did?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“After I got divorced.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You were married?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Believe it or not.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She tells me that they’d been living at her husband’s parents’ house, and when they split she thought she was doomed to move back in with her own parents, but then she bumped into Uncle Gus at the Esso station. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I was crying on his shoulder, and he just up and offered me the guest room.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sounds like him.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Doesn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Did it spark a few rumors?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You know Baxter, silly as it was. But we didn’t care.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She lived there for almost a year, but dropped in often even after she’d moved into a little apartment over the hardware store in the downtown block. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“And you’ve stayed single.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah, I learned my lesson.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What lesson is that?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Guys are shits,” she says. “Sixteen or not. But now I don’t worry about it. It is what it is, and you just have to realize that and not let yourself get too carried away.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You sound kind of cynical.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s the new me.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We sip our coffee and look out the window at the street. It’s rush hour and there’s a lot of traffic, and I remember counting cars with Becky and Julie, and when I bring that up—and board games and croquet, and playing in the barn—Becky gets misty-eyed and blows her nose on a napkin. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Julie’s still the best friend I ever had. That’s probably what made it so bad about you: I thought you were going to be the next best thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I wish I had been.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re a guy.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Some of us must be all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You couldn’t prove it by me.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She holds up her hand with its unadorned ring finger. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Same kind of deal as with you, Cal. You’re all hopeless. The grass is always greener or some darn thing. What got me about Scott was that it was after my broken leg and all that. I wasn’t even damaged goods!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“When did this happen?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Six years and . . . two months ago.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I hold up my own bare-fingered hand. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Divorced?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Never took the plunge.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How come?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I was "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("always")]), _vm._v(" damaged goods.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She gives me a funny look, then laughs. “Well, that’s over with.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You deserved better.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“"), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Now")]), _vm._v(" he gets it.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She grins, but it’s a slippery one, because she’s still weepy about Julie, and now about me too again, and seeing that vulnerability, my heart makes a sudden wobble in her direction. But that’s plain silly. It’s been a long time, and besides, I’m still drying out, and no prize for anyone. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So I make some pitiful joke about finally being old enough to figure out one or two things, and she snorts and says, “I’ll believe it when I see it,” and we look out the window again, and I finally break down and ask about my mother and Pike, and she says, “Still going strong, as far as I can tell.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We finish our coffee and go back up to Uncle Gus’s room. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He’s cranked up to a sitting position, with the young nurse helping him eat chocolate pudding. She touches his lips lightly with the spoon, and when he opens his mouth, wipes the pudding off on his lip. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I told Augustus you were here. I’m not sure he heard, but he’s in there somewhere, aren’t you, honey?” She gives him another taste. “He’s got an eating reflex, anyway.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She feeds him the whole container, then pats his chin and mouth with a damp cloth, gathers up the container, the lid, and the spoon, and stands up from the chair. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“When do we have to clear out?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You still have some time. I’ll be back later.” She smiles on her way out of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“There’s a girl for you,” Becky says.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That baby?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That baby was checking you out.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“If you say so.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Uncle Gus touches his lips with his tongue. His face is still impassive. He feels around and then stops. Then he takes a big breath, holds it a moment, and lets it out.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We stay with him for another hour, talking about Baxter, trying to do it in a way that includes him, just in case he might be listening. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Becky tells me that when she sees Pike and my mother around town, they never speak to her, and then the baby nurse comes back in to tell us visiting hours are over.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At the nurses’ station I grab my duffel. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Did you play for him this time?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“A little.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I thought I heard something!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We’re riding down in the elevator when Becky says, “How long are you here for?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m not sure.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are you coming back tomorrow?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I tell her it depends on what happens in Baxter.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re going out there today?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Figured I’d better.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Do you have a ride?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, but I’m working on it.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We reach the first floor and the door opens. I follow her past the desk to the exit. Outside she faces me, and I notice we’re almost eye to eye now that she can stand up straight. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I suppose I ought to give you a ride.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You don’t have to do that.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m going there anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("An ambulance comes up Bramhall Street and swings toward the Emergency entrance. I hope it’s a good sign for someone that its lights and siren aren’t on. It disappears around the corner and I look back at Becky. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well?” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I wouldn’t have to call Alvin.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s reason enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She starts off, barely letting the cane touch the ground. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I shoulder the duffel and follow her across the street. When she gets to the other side she turns and tells me I can stop lagging and watching her walk anytime.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re sorry all right.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She waits until I’ve caught up and sets off again. At her Silverado I put my bag in the back with various buckets and tubs, then climb up into the passenger seat. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("In ten minutes we’re turning off Franklin onto Marginal Way, and then we’re crossing Back Cove, cruising past the baked beans factory and heading down Route 1.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So which Scott did you marry, anyway?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not one you’d know.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She tells me he was from one of the islands, a lobster buyer, and they were hitched for about a year and a half before he started cheating on her with a barmaid from the Old Port. Then she asks me if I’d heard about Alvin quitting the dealership and going to work for Pike at the realty. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, I hadn’t heard that.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m surprised he never told you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We haven’t been in touch, really.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Next she tells me Chuck Lamar and Bobby Berube joined the Marines together the year after we graduated, and that Bobby was killed during boot camp in some kind of training accident. I couldn’t believe I hadn’t heard about that, but it just goes to show you how out of touch I’d been.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Aw, man.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I know. I liked that little twerp.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Riding down 295, she fills me in on other notable goings-on in Baxter. She makes it funny, and before I know it we’re crossing the Route 1 bridge into Baxter. Then we’re riding down Main Street and I spot Chief Foss in his cruiser by the big flagpole. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t tell me he’s still around.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah, and just as dumb as ever.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He doesn’t spot me, or he’d probably hit the lights and come after us for old times’ sake. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We turn down Water Street to the bridge, and I start to feel the ghosts stirring, and then we thump off on the other side and another mile along come up to where my father had his accident. And even though you can’t tell anymore that anything ever happened there, I get a jolt that shoots right up through all the other little jolts this visit has produced, and things start boiling around in my head. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It’s more powerful than I expected, as well as I’d been doing. But those old shapes and colors have always had a way of jumping out to surprise me, and I suppose I should have known they wouldn’t stop now. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I figure I’ll just let it ride itself out, as usual, but the closer we get to the old farmhouse, the worse it becomes. By the time we pass Uncle Gus’s I’m feeling pretty well surrounded and trapped, and I guess I’m not doing a very good job of hiding it, because all at once Becky slows and pulls over onto the shoulder. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What is it?” I say through the bedlam.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You were making a noise.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What kind of noise?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Some kind of groan.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I try to laugh. “Are you sure I wasn’t just humming?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You don’t hum, Cal, you whistle.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sometimes I hum.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You weren’t this time, trust me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I shake my head. “I’m sorry, Beck.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t be sorry. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We went by Dad’s spot.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I figured.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That, and everything else.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Uh-huh.” She nods in the direction of my former home. “So are you sure about this? Because I’ve been thinking. I still have a key to Uncle G’s. Why couldn’t you stay there tonight, let yourself settle down a little.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You mean go over in the morning?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I try to think it through, but it’s still too noisy in my old bean, and Becky watches me struggle with it for a minute or two and then just goes ahead and throws the truck into gear, pulls a U-turn, and heads back toward the sun just setting below the trees between us and the village.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I guess I’ve decided, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I guess you have.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We pull into Uncle Gus’s driveway. The house hasn’t changed at all except the shingles are more weathered, and there’s a copper trumpet weathervane on top of the one-car garage. Becky throws the gearshift and says, “Do you want me to come in?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And I "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("do")]), _vm._v(" want her to come in. Some trace of our old bond seems to be trying to breathe itself back to life, and I’m afraid if I let her get away that’ll be the end of it. But I also know that in my present state I’m liable to do something stupid to kill it off anyway. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It’s a tough call when you’re not thinking clearly. But then I realize I’m taking too long to decide, which might hurt Becky’s feelings all over again, and I can’t take a chance about that so I say, “Yeah, please, I wish you would,” and after hesitating for only an instant she shuts the engine off and we get out of her pickup and go into the house through the side door. ")]), _vm._v(" "), _c('p', {
    staticClass: "parts-head"
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v("FOOLISH")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Thirty-Four")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-35"
    }
  }, [_vm._v("Baxter, 1995")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("Playing chords on the piano can be soothing—something about the way they resolve themselves—so I head right down to the basement to see if it’ll help. Uncle Gus was still teaching right up until his stroke, and his studio hasn’t changed much. It still has the paneling and the carpet and the drop ceiling with its smoke-discolored space above his recliner, and the same upright piano and the other instruments on their stands, and the student desks. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I sit down at the keyboard and noodle a little of “Blue Summer,” using Tampa Red–style chords and a single-note melody line. It’s actually the only tune I can bring into my head at that moment.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s what you played for Uncle Gus.” Becky is sitting at one of the student desks. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yep.” I play a little more, wanting her to hear it, and that stirs something in my mind, a possibility, but there’s still a commotion up there—furtive shapes and dark colors—and I can’t really focus. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I stop so as not to use it up and lose it. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I get up from the piano and smile at Becky and we wander back up the stairs. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("In the kitchen she fires up the coffeemaker and we take a couple of mugs into the living room. On the couch we sip the hot coffee in unison, lower the mugs and look at each other. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Unbelievable,” Becky says. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Back at Uncle Gus’s.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How are you doing now?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“A little better, maybe.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I go over to the credenza next to the window where Uncle Gus’s turntable and speakers sit, and I look through the albums until I find an Art Pepper with “Everything Happens to Me”—one of my favorites, and also a sort of inside joke with myself. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But when I sit down to listen the joke isn’t working, which leaves just the mood, which is melancholy, and even desperate, the way Pepper plays it—those painful squawks and squeals—and after a bit I get up again and turn it off. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No good, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not quite.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How about something to eat?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Worth a try.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We head for the kitchen, Becky still sipping her coffee. I rinse my mug out, open the fridge and take a look inside. And right in front of my face on the top shelf is a six-pack of Woodchuck Hard Cider. Immediately my little devil starts whispering about how cider is practically apple juice and really nothing to worry about—in fact, might possibly be a drink that I could use to calm my frazzled nerves without any lasting problem! (I know this is bullshit, but I listen anyway.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Anything good?” Becky asks.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nah.” I shut the door, lean against it with my arms crossed. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There’s a sudden fierce battle raging inside me now, a really tough one, all the meanies pushing me toward drinking, and I wonder if it shows on my face. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How about a couple of Italians?” I say. “I’ll buy if you fly.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Italians, huh?” She’s looking at my eyes. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Blackstone’s still sells them, I imagine.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You couldn’t find anything in there?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nothing exciting.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She reaches for the door handle and pulls gently until I move aside. She looks in, then back at me, and I laugh like a kid with his hand in the cookie jar.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Woodchuck Cider? You must be pretty desperate.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s not that bad, actually.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She shuts the door. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I was just tempting myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yeah, I know how that works.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I lean back against the counter.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She wanders toward the door and looks out. It’s still odd to see her moving so well and standing so tall. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So tell me something,” she says. “Am I just being foolish again?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Getting mixed up with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are we mixed up?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We seem to be.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Well, I don’t think it’s foolish.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I mean, I’m not your mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thank God for that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Or anything else.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She takes her pocketbook off the doorknob and slings it over her shoulder—a preparatory move. She’s looking out the window again, and I’m not sure what I want. It would be a huge relief to knock down a couple of those ciders. I’ve come all this way, and if it could help me just get some sleep; but I know I can’t do it in front of her. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Becky’s not sure either. I can see it in her profile. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She shifts her weight restlessly, and for a moment I think she’s as good as gone. I’m hoping for it, actually, and I wait expectantly for her to turn the doorknob and leave. I’m already rationalizing: If she’d only stayed, I would have been all right. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But then she turns and scowls at me, and instead of leaving, she walks back to the table and puts her pocketbook down. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All right,” she says. “It’s true that I’m not your mother, or anything else, but you’re still Julie’s brother.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At first I’m disappointed. Crushed, even. But then my little drink-devil slinks off, muttering darkly, and I climb back from that pit he wanted to lead me to. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good,” I say. “Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So let’s get rid of this stuff.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We open the bottles and dump them into the sink, and the smell of cider fills the room. She rinses the last bottle out, sets it on the counter, and says, “Just so you know, you can still tell me to leave if you want to.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I shake my head. “Nope.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Then I’ll take one of the bedrooms.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What about work?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Tomorrow’s Sunday.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I’m surprised to hear it. I’ve lost track.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She points at me. “But don’t get any ideas.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I won’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m not foolish "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("that")]), _vm._v(" way anymore.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You never were.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Right.” She rolls her eyes. “So are you really hungry?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Maybe a little.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She looks in the cupboard, finds some stale bread and peanut butter and jelly. We load up a couple of PBJs and take them back to the other room and turn on the television. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I give Becky the remote and she goes through the channels. We try a couple of sitcoms, but neither is any good, and about ten minutes into the second one she says, “The heck with this, let’s walk down to the river.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good idea.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She shuts the TV off and we head for the door.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Your cane?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I seem to be doing all right.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We cross the road and follow a path down to the riverbank. She is moving well. It really is a kind of miracle, and I hear something—an augmented chord, then another. They sound again and fade and resolve, taking on Becky’s new, upright shape. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Cool,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll show you later.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We walk along another path through the marsh grass to the old stone pier. Downriver there are gulls circling and squawking over something I can’t see. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Scene of the crime, remember?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How could I forget?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We sit on the big granite slabs, facing the river. The rock is still warm from the sun. I think it must be near high tide, as the darkening river is wide, with no mudflats left to speak of. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thanks for doing this, Beck.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t mention it.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s a good thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s good and it’s bad.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What do you mean?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, I don’t know.” She looks out at the river. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I ponder her strong profile and remember when we were first together, how she would catch me studying her face—I was memorizing it for later—and it would make her laugh and she’d throw a headlock on me, and we would wrestle until it turned into an embrace. And I realize I wouldn’t mind that happening again. Then I tell myself I’m an idiot, and to take my mind off it, I fish my cigarettes out. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Want one?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh, I quit a hundred years ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good for you.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I fire it up and blow smoke toward the river. We sit watching the silvery water and the gulls until I’ve smoked it down and then I rub it out against the granite and drop the butt into a crack between two of the big slabs, where there are still flattened old beer cans.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It’s full twilight when we get back to the house. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I take her down to the basement and play the augmented chords that had come to me at the river, and she says, “What’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Do you like it?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yes. It’s kind of shivery.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I heard it down by the river.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I always liked it when you heard things like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I don’t tell her it’s about her. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We dig Uncle Gus’s cribbage board out and play like old times. She’s ten games ahead—some things never change—by the time she yawns and decides it’s time to wrap it up and call it a night. I tap the deck of cards on the table and put the elastic back around them and put everything away. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The two bedrooms are next to each other at one end of the house, and I insist Becky take the guest room, because the bed hasn’t been used. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t worry, I intend to.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good. Sleep tight.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t let the bluenotes bite.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I laugh, and she smirks and goes into the room. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I take a quilt out of Uncle Gus’s closet and lie down on top of the blankets in the unmade bed. But I don’t fall asleep. My brain’s still tender, and I can feel Uncle Gus in this room—his Committee is in the closet—and I can’t help picturing him on the floor. I think about him living here alone, and it strikes me how lonely he must have been at times, after his last student of the day left, my father gone, and access to our family shut off by Pike. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I think I could have been a better friend to him, and my old lurkers start to creep out again, and then they turn my mind toward home, and I think about being back there with Julie’s ghost swooping around, and my father’s ghost, too, and my mother not knowing what to make of me. And Pike, of course; no doubt he’ll stick his nose into the picture somehow. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It all starts to pile up on me again. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I pull the quilt up over my head, but my little on-call demon finds me anyway and starts whispering his bullshit, and it’s really hard not to listen, and the next thing I know I’m throwing back the quilt and tiptoeing to the doorway. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I look down the hallway to the kitchen, where I know if I search hard enough I’ll find another stash of cider or an old bottle of Jim Beam—"), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("something")]), _vm._v("—and I pretend I’m just tempting myself and that at any moment now I’ll laugh and go back to bed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But the longer I stand there the weaker I get. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My devil is whispering that it’s a special circumstance, this return home, and just because I have a touch of whatever to calm my nerves now doesn’t mean I can’t get right back on the wagon after all this is over. After all, haven’t I proven to myself that I can do it? ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("This tack gets to me, and I actually take a step into the hallway. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But then Becky opens the guest bedroom door. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She’s wearing just the vocational school T-shirt, as far as I can tell—it hangs down below her hips—and in the soft light from the kitchen she looks a lot like she did twenty years before: broad-featured and strong, and with that cascade of hair, like a handsome Irish warrior-girl. Only she’s standing straight, like a soldier, not knock-kneed and crooked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hey,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hi, Beck.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You were making that noise again.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I was? Did I wake you?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I wasn’t asleep. So what are you up to?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No good, I think.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Me?” she says. “Or the kitchen?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The kitchen.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That’s not very flattering.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I figured you were out of the question.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She doesn’t laugh, just looks steadily at me. Then she moves suddenly close and puts her arms around my neck. My own go automatically around her waist, and we hang together there between the two doors. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“This feels pretty normal,” she says.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It kind of does.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I told you I was foolish.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re not.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Just look at me, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You haven’t done anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I might, though. I might at any time. Because I’m foolish, right? Unless you stop me, like I just stopped you. What about that, Cal? Are you going to stop me?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Somehow I’m moving backwards. “I might.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Go ahead, then.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We keep moving into the room, and then the back of my knees bump the bed, and she says, “Stop me, Cal,” and when I merely tighten my arms around her, she gives me one last push. ")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Thirty-five")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-36"
    }
  }, [_vm._v("Baxter, 1995")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("When I wake up Becky is sitting cross-legged at the foot of the bed. She’s gathered all that hair over one shoulder and is hanging onto it with both hands. And maybe she doesn’t look seventeen like she did last night, but she still looks very good, especially in just the long T-shirt. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good morning,” she says. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re up early.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Never mind that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All right. Do I have to get up, too?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No. How are you feeling?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I take a quick mental inventory, and find the lurkers and meanies seem to have gone back underground. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Pretty good.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good, because I need to ask you something.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I get up on one elbow. “Go ahead.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Did you think this was going to happen?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are you kidding?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You couldn’t tell that I was still foolish?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re not foolish.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Foolish enough to trick.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“But you’re the one who started it!” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That was the trick!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You lost me, Beck.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She throws her hair back over her shoulder and leans forward, elbows on her knees. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The trick was getting me to warm up to you all over again, and knowing I’d be dumb enough to start something.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How could I possibly do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“By being nice. By making me laugh. By keeping your distance. By being tenderhearted. By playing the trumpet.” She stares at my eyes. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s a cornet.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She looks fierce, like she might punch me.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sorry.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m not kidding around.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All right. But I told you plenty of bad stuff.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You mean, like, drinking?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“For starters.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That was to appeal to my maternal instincts.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When I grin she looks fierce again, and I flop forward onto my stomach and take her hands. “Listen, I thought "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I")]), _vm._v(" was being foolish.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Swear to God?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Cross my tender heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She stares hard, and I can see the wheels turning. Then she tucks her legs under and dives on me, putting me in the Becky headlock, and we wrestle on the bed until I break free, and then we fall onto our backs, breathing hard, looking up at the ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So what now?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Maybe just see what happens?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“If you break my heart again I’ll kill you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll keep that in mind.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We turn together, smiling, our faces nearly touching. She kisses me and says, “Do you want me to come with you today?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yes.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“When do you want to head over?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I kiss her back. “Not right this second.”")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Thirty-Six")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-37"
    }
  }, [_vm._v("Baxter, 1995")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("So I’m not alone, arriving at the old farmstead two hours later. Becky O’Dell’s driving, and I’m in the passenger seat, trying not to make that anxious noise. Succeeding, too; it’s easier after last night, and with the two of us now. I can lean on her, because she knows where all the ghosts are.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Which isn’t to say I’m not plenty nervous.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We turn in at the mailbox and I notice the old vegetable stand is gone. There are rosebushes instead, but from the way they look, no one’s been tending them; they’re bedraggled and there aren’t many blossoms. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Becky heads up the driveway, slowly. The barn’s been painted lately; it’s a deeper red than before. There’s a black pickup parked in front of the house. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Becky says, “Are you ready?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“As I’ll ever be.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She drives up behind the pickup. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We get out and look at each other over the hood, she tips her head toward the house, and we circle the black pickup and climb the five steps to the porch. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I look around at the barn, the apple trees, the field leading down to the river. Then I pull the screen door open and knock on the main door.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("After a minute Becky says, “Try a little more volume.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I give it a couple of healthy raps. But still nothing. I walk over to the kitchen window and shade my eyes to peer in. It looks like the same old kitchen. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nobody’s home.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Maybe they’re at church?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I look at my watch. “I keep forgetting it’s Sunday.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Should we wait?” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Guess we’d better.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("On the way back to her pickup I say, “Let’s wait in the barn,” and I grab Uncle Gus’s Committee out of the extended cab on the way by. (My plan has been to find a chance to play “Blue Summer”"), _c('span', {
    staticClass: "CharOverride-3"
  }), _vm._v("for Julie, hoping that in her presence I can make it all the way to the end.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("We cut across to the side door, which has the same old hasp latch with a rusty screwdriver holding it shut. I pull the screwdriver out and we go in past the stalls to the drive bay. I look up at the hayloft and the timbers that run over to the hay door. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are you all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I think so.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There’s a new boat parked where Dad’s used to be, a sleek-looking sixteen-footer. (But it’s still dirty.) I walk out into the bay and look up at the hayloft again. I look down at the trumpet, flutter the valves.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Play that one from the hospital.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It was for Julie anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“It’s pretty, like her.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I lean back against the double doors and put a foot up behind me and play, pointing the Committee up at the hayloft. I play “Blue Summer”"), _c('span', {
    staticClass: "CharOverride-3"
  }), _vm._v("up to the little sidestep, and when I move into the new part I feel it settling into a direction and a shape: I see Julie sitting on a bale of hay, and then stepping onto the parallel timbers, and starting across. I’m still playing, and I see her open the hay door and the breeze moves her hair and then swirls down and into me and out through the horn, and then I see her sitting on the left-hand beam and telling me to turn around.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I stop and lower the horn.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What is it?” Becky says. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I just remembered something.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I hand her the horn and walk over to the ladder affixed to the beam and test the rungs. It feels pretty solid, so I start climbing. There’s no scurrying above me, and I think Pike must have finally starved those cats out: great victory for the Big Man. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I keep climbing, putting one foot after the other, and then I’m at the top rung and pushing myself over. I roll away from the edge and stand up. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Cal? What’s going on?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Tell you in a minute.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I walk over to the conveyor timbers, feeling ahead with my toes before each step in case there’s a rotten board hidden beneath the loose hay. I look over the edge at Becky and my stomach turns over on itself. You always hear that distances and heights are smaller than you remember, but this still looks pretty high to me. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re not going across.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I think I might be.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not sure that’s a good idea.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“That makes two of us.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why don’t I hunt up a ladder?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“No, I have to do this.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A ladder would make more sense, but it’s not what I want. I have to go over because of what I remembered, and I have to do it the way I couldn’t then. It’s almost a musical feeling, like my life has been a complex chord, and this is how it might finally resolve. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I’m not dumb enough to try and walk the beams, though. Instead I sit down and ease myself onto the right-hand timber. Then I start hunching across. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re scaring me, Cal.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I can’t talk right now.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I work my way very carefully out onto the timber. It creaks once and I freeze, trying not to panic, and when nothing happens I start moving again. When I get out in the middle it feels very precarious, and I nearly freeze again, but I know if I do, I might be stuck, and the fear pushes me forward. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I make it across out of sheer momentum. Then all I can do at first is hook my hand under the nailed board and hold on. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When I can breathe again I slip my other hand behind the lower board and fish out a little spiral notebook with a stub of pencil stuck into the wire binding. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I knew it,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ll have to show you.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I reach behind and fit it into my hip pocket. Then I turn very carefully and start back. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Easy does it,” Becky says from below.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t worry about that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But on the way back things start batting around, shapes diving on me from all over the barn, trying to knock me loose. I try to push through like I did going over, and I keep going as long as I can, but then it gets so bad that I have to stop. I’m only about ten feet from the platform, too. But I just can’t move. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I let myself down onto the timber and hold on tight.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are you all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I just need a minute.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I press my cheek against the timber and wait for it to ease, but the bombardment continues until I want to let go and slip over sideways just to make it stop. But I can’t let that happen because I have to read Julie’s notebook. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then I hear movement, and Becky quietly saying, “Hey.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I open my eyes, and she’s standing on the platform. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How’d you get up here?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I flew up on my broomstick.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("This makes me laugh despite everything.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Come on back now.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not sure I can, Beck.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You can, or I’m coming out.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She sits, legs hanging down on either side of the same timber I’m on. When I don’t move she puts her hands on the edge of the platform and hops forward a couple of inches onto the timber.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The timber creaks again, and I say, “All right!” and push myself up, my hands flat on the wood. I feel very shaky, like I might have some kind of spasm.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But Becky says, “Keep looking at me,” and I do, and when she says, “Come on, now,” I lean forward and move my hands and inch or so. Then I hunch myself toward her. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Do it again.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I do it again, and once more, and then I’m moving steadily along, and I feel Julie with me. She’s smiling and she’s come out of the rafters to ride along for the last couple of feet.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why didn’t you do that sooner?” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What?” Becky says,")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Nothing.” I didn’t realize I was talking out loud.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Becky lifts herself backward off the beam and onto the platform as I get closer, and when I’m within reach, she takes my hand and leans away, pulling hard, feet braced against the edge, and then I’m rolling with Julie and Becky onto the platform and we’re all tumbling backwards into the hay bales, and it’s as if no time and all time has passed since we were together.  ")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Thirty-seven")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-38"
    }
  }, [_vm._v("Baxter, 1995")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("It’s too dim in the barn to read, so we go out the side door and sit on the old half-log bench in the bright sunshine. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There are only a dozen or so pages of writing in the notebook. The first one says "), _c('span', {
    staticClass: "small-caps _idGenCharOverride-1"
  }, [_vm._v("Private—Do Not Enter! ")]), _vm._v("and"), _c('span', {
    staticClass: "CharOverride-16"
  }), _c('span', {
    staticClass: "small-caps _idGenCharOverride-1"
  }, [_vm._v("Property of Julia Mary Shaw")]), _vm._v(". Then it explains how “a person whose name I refuse to utter” discovered the diary she’d hidden in her room and read everything about how much she hated him. She was in big trouble, now. He still wasn’t going to keep her from writing everything down, though, because this one would stay up by the hay door, where he was too fat to go, and where I couldn’t get to it, either, because she had to make sure I didn’t know what was going on or I’d be in big trouble too. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It gets so bad that I can hardly make out the words. But Julie’s still here, and she won’t let me look away. So I read everything about the bullying, the harassment, the outright abuse that happened after Pike found the original diary. I hear Julie describing the daily humiliations, some of which I saw but was too scared to do anything about. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("By the time I close the book I want to throw up.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It’s all there, and I realize I’d always known, deep down, how bad it got. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I hand Becky the notebook and wait. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("After a little while I hear her gasp and I know she’s reading about Pike’s lectures in Julie’s room, with her face between his hands and his nose touching hers; she’s reading about the grabbing and shaking, and “Keep it up, Princess, and see what happens.” ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And worst of all, the spankings, with Julie pinned across his lap while he “taught her a little respect,” at first by the book, and then, more uncomfortable, and finally with her panties all the way down, and Julie “feeling him under there” while he slapped her bare bottom, which made her so sick she threw up on the floor. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Julie’s still narrating in my head, and I admire her composure, her grace, as she tells me how he stood over her while she cleaned it up and told her that if she said a word to anyone, there’d be hell to pay—and this especially meant her mouthy little brother, unless she wanted his wagon fixed for good. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("That’s the last entry, which she must have written that day on the beams while I had my back to her. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Oh my God,” Becky says.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The son of a bitch.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She never said anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“She was scared.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Becky is silent for a moment. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I feel Julie still with us, glad I made it back. I feel her elegance and coolness—she seems all grown up—and I’m glad I made it back, too.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Foss needs to see this,” Becky says. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Damn right.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She hands me back the notebook, and I stick it in my pocket. I pick up the Committee and we start back to the Silverado. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There’s a lot going on in my head, bad, dismal stuff trying to take over, but it’s not at its best; it’s fitful and pale, and then there’s a countercharge that comes from all of us: me, Julie, and Becky, too. There’s a pure, strong mingling of smooth-edged shapes and colors and harmony—sevenths—that is coming "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("from")]), _vm._v(" us, not "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("at")]), _vm._v(" us, and we all turn together to face the light green minivan turning off the River Road, and Becky says “That’s Alvin’s,” and it all coalesces into something complete, something proud and dark.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The minivan comes up the driveway and parks behind the Silverado. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike, my mother, Alvin and his wife and two kids get out and walk toward us in their church clothes. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My mother looks like a sixty-year-old woman, one I barely know. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin’s not skinny anymore, and his wife is pretty. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The Prodigal Son!” Alvin says, grinning.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Then he’s talking, and my mother’s trying to say something and Alvin’s wife and kids are staring, but all I’m really aware of is Pike lumbering into range with a smirk he’s not quite trying to hide. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He looks pretty much the same, with a bigger gut and some gray in his crew cut, and then he’s close and his smirk turns into one of the old meat-eater grins, and I suddenly see him with Julie, naked, across his lap, his hand in the air, and I feel Julie still with me, and she’s waiting. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She’s been waiting.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pike stops next to my mother. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Cal, are you all right?” Alvin peers at me, as if he can detect some of the notes going off in my head. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v(" Becky puts a hand on my arm, and then that proud, dark shape in my head—the blend of my fury, Julie’s fierce dignity, and Becky’s outrage—focuses and narrows, and I hear the “Blue Summer” melody, the ending I’ve needed, and there’s a last dark complex chord, and I’m lifting my trumpet as if to play it when something happens and suddenly Pike is down on the gravel, blood pooling in the dirt by his ear, and my mother is kneeling beside him, everybody else is yelling. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Becky’s staring at the Committee. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There’s blood smeared on the hard bottoms of the valves. I look back at Pike and then I sit down on the porch steps. I need to wait for things to clear up. Seems like somehow I’ve always been sitting on this porch, waiting. But this time, it’s so noisy.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvin runs past me into the house, and Pike is still down and not moving.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Becky sits beside me and slips the little notebook out of my back pocket. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I’m not sure how long we sit there. But pretty soon, all kinds of sirens are coming down the River Road. There are flashing blue and red lights, and both town cruisers turn up the driveway, followed by the ambulance. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Becky stands up and walks out to meet them. ")]), _vm._v(" "), _c('p', {
    staticClass: "number-trend"
  }, [_vm._v("Epilogue")]), _vm._v(" "), _c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-39"
    }
  }, [_c('span', {
    attrs: {
      "lang": "fr-FR",
      "xml:lang": "fr-FR"
    }
  }, [_vm._v("Bolduc Correctional Facility")]), _vm._v(", 1997")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("So here we are, and that’s the story behind all those lurid headlines. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I was charged with manslaughter, but because of Julie’s notebook the prosecutor made it a class C felony, which is a maximum of five years instead of thirty, and the judge put me in the Bolduc Correctional Facility instead of the Maine State Prison. (This was big, because the only musical instruments they allow in the Maine State Prison are guitars and harmonicas, neither of which I can play.) ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So I get to keep my horns in my room.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I say horns because I inherited Uncle Gus’s Committee. He passed away that same year without ever fully regaining consciousness, which means I never got to talk to him again. (Which is a shame, because there’s a lot I would have liked to say.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It’s good to have two horns, because that way I get to swap off, which keeps me fresh as far as playing something new. There’s also a piano in the Bolduc that I can use to compose. In case you wondered about the section headings in this book, they’re all the names of songs I’ve created, some of which have been published. These songs have been coming at me from all directions, and I’ve had to work hard to keep up. I’m not sure if that works in a literary way, but they all seemed to derive from this story as I told it, and weren’t to be excluded. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I also inherited Uncle G’s house. Becky’s living there now, and I’ll join her when I get out, which should be in another seven months or so, because of what they call “good time” here, which is the same as time off for good behavior. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I think our first visitors might be Loretta McCarty and Georgie. She wrote to me after seeing one of the news reports, and we’ve corresponded ever since. In fact, my letters to her were the start of this book. See, once I got started writing about it I couldn’t stop. I guess it was therapeutic. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("You’re probably wondering how I feel about it now. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It’s complicated, but I guess I think that Pike got what was coming to him. There’s still a lurking horror that I took a life, and I’ll have to live with that. But I’ve settled on the idea that it was retribution delivered through me—not "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("by")]), _vm._v(" me, or I’d remember it, which I still don’t. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I think the retribution came from Julie, which is good enough for me. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rationalization, maybe. But there it is.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Neither my unfathomable mother nor Alvin has tried to come in to see me. I guess it’s complicated for them, too. It must have been terrible to witness, and maybe they don’t believe everything Julie wrote in her notebook. Or maybe they do, and can’t admit it to themselves, which would be more in keeping with the past, right? ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Anyway, that’s my story, as well as I can tell it. Probably as a writer I’m a pretty good musician, but I hope I haven’t ranged too far afield along the way. I’ve just been going where the shape of it leads me, following the notes, playing the melody, playing the riffs when it’s my turn to swing, trying to follow where it wants me to go.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer012"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer013"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer014"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer015"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer016"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer017"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer018"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer019"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer020"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer021"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer022"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer023"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer024"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer025"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer026"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer027"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer028"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer029"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer030"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer031"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer032"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer033"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer034"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer035"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer036"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-3",
    attrs: {
      "id": "_idContainer037"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer038"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer039"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer040"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-2",
    attrs: {
      "id": "_idContainer041"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer042"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-17"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer043"
    }
  }, [_c('p', {
    staticClass: "TITLE",
    attrs: {
      "id": "_idParaDest-40"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-3"
  }, [_c('br'), _vm._v("My deepest appreciation to the amazing crew at Islandport Press: Dean Lunt, Teresa Lagrange, Holly Eddy, Shannon Butler and Taylor McCafferty, with special thanks to my brilliant editor, Genevieve Morgan; and to Melissa Hayes. ")])])])])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781952143069',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(64)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(66);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 66 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.a4e6b8bb492b8db6ce60.js